// tslint:disable
var i18nDict = {
  "2015 champions nexagon": "2015世锦赛冠军飞碟",
  "2016 championship banner": "2016冠军旗帜",
  "2016 fall finals nexagon": "2016秋季决赛飞碟",
  "2016 spring finals nexagon": "2016春季决赛飞碟",
  "2016 summer finals nexagon": "2016夏季决赛飞碟",
  "2017 championship banner": "2017冠军旗帜",
  "2018 championship banner": "2018冠军旗帜",
  "2018 hgc finals steed carried": "2018 HGC全球总决赛战驹（扛着）",
  "2018 hgc finals steed": "2018 HGC全球总决赛战驹",
  "2018 mid season brawl nexagon": "2018季中大乱斗冠军飞碟",
  "64 kb marathon": "64KB马拉松",
  "7th legion nightslayer valeera": "第七军团夜幕杀手瓦莉拉",
  "a fishy deal": "鱼奸鱼猾",
  "a proper greeting": "亲切问候",
  "a touch of honey": "蜜酒调味",
  "abandoned infested tychus": "被遗弃的被感染的泰凯斯",
  "abathur": "阿巴瑟",
  "abhorred skull": "嫉恨之颅",
  "ablative armor": "烧蚀装甲",
  "abolish magic": "废除魔法",
  "abominable fel reaver blaze": "怪火魔能机甲布雷泽",
  "absolute zero": "绝对零度",
  "abundance": "生机绽放",
  "abyssal crypt queen zagara": "深渊地穴女王扎加拉",
  "abyssal deathbringer sonya": "深渊死亡使者桑娅",
  "abyssal demonic imperius": "深渊恶魔英普瑞斯",
  "abyssal dreadlord jaina": "深渊恐惧魔王吉安娜",
  "abyssal sinlord azmodan": "深渊罪恶之王阿兹莫丹",
  "abyssal symbiosis": "深渊共生体",
  "accelerando": "墙面快步",
  "accelerated contamination": "加速污染",
  "accelerated decay": "加速凋零",
  "accumulating flame": "火势汹涌",
  "ace in the hole": "底牌有王",
  "acid drenched mandibles": "强酸上颚",
  "active reload": "主动装填",
  "adanium shell": "艾德曼合金外壳",
  "adaptation": "适者生存",
  "adhesive petroleum": "黏性燃油",
  "admiral krakenov": "海军上将海怪诺夫",
  "adrenal overload": "腺体过载",
  "adrenaline boost": "肾上腺激素",
  "adrenaline rush": "冲动",
  "adrenaline stimpack": "肾上腺素强化剂",
  "aduns wisdom": "亚顿智慧",
  "advanced artillery": "远程炮击",
  "advanced cloaking": "尖端隐身服",
  "advanced lava strike": "高级熔岩打击",
  "advanced targeting": "高级瞄准",
  "adventurer li li": "冒险家丽丽",
  "aegis of light": "圣光护盾",
  "aerie gusts": "鹰巢狂风",
  "aether walker": "以太行者",
  "afflicted deckard": "受难迪卡德",
  "afterburner": "后燃充能",
  "agent shrike": "特工伯劳鸟",
  "agent stars and stripes raynor": "特工星条旗雷诺",
  "aggression matrix": "进攻矩阵",
  "aggressive matrix": "进攻矩阵",
  "aggressive shredding": "绝佳狂奏",
  "agile dismount": "灵巧身法",
  "air ally": "风相幻身",
  "alabaster varian": "雪花石膏瓦里安",
  "alarak": "阿拉纳克",
  "albino funny bunny murky": "白化搞笑兔奔波尔霸",
  "aldor peacekeeper": "奥尔多卫士",
  "alexstrasza": "阿莱克丝塔萨",
  "all shall burn": "燃尽万物",
  "all together": "一起嗨",
  "allegrissimo": "急速变奏",
  "alloy mecha valla": "合金机甲维拉",
  "almond horse carried": "浅黄色马（扛着）",
  "almond horse": "浅黄色马",
  "alone in the dark": "黑暗孤独",
  "alpha killer": "头狼杀手",
  "alpha wolf": "头狼",
  "alterac drek thar rehgar": "奥特兰克德雷克塔尔雷加尔",
  "alterac pass": "奥特兰克战道",
  "amani hide": "阿曼尼之皮",
  "amani rage": "阿曼尼之怒",
  "amani resilience": "阿曼尼抗性",
  "amani war bear": "阿曼尼战熊",
  "amaranth centurion johanna": "紫红百夫长乔汉娜",
  "amateur opponent": "业余对手",
  "amber brewmaster chen": "琥珀酒仙陈",
  "amber burning blade samuro": "琥珀火刃萨穆罗",
  "amber ghost tracer": "琥珀幽灵“猎空”",
  "amber lil ragnaros": "琥珀小拉格",
  "amber lunar kaelthas": "琥珀春节凯尔萨斯",
  "amber lunar li ming": "琥珀春节李敏",
  "amber nexus battle beast": "琥珀时空蛮兽",
  "amber nexus charger carried": "琥珀时空战马（扛着）",
  "amber nexus charger": "琥珀时空战马",
  "amber nexus tiger": "琥珀时空战虎",
  "amber sir murkalot": "琥珀鱼卡罗特爵士",
  "amber soundblast lucio": "琥珀震音卢西奥",
  "amber spectre phantom": "琥珀幽魂幻影摩托",
  "amber spectre tracer": "琥珀幽魂“猎空”",
  "amber techno vandal chromie": "琥珀科技颠覆者克罗米",
  "amber widowmaker nova": "琥珀黑百合诺娃",
  "amberlord zuljin": "琥珀领主祖尔金",
  "ambush": "伏击",
  "amethyst highlord alarak": "紫水晶高阶领主阿拉纳克",
  "amethyst knight owl medivh": "紫水晶枭鹰骑士麦迪文",
  "amethyst serpent king xul": "紫水晶毒蛇之王祖尔",
  "amp it up": "强音",
  "amphibious commander raynor": "两栖指挥官雷诺",
  "amplify damage": "伤害增效",
  "ana": "安娜",
  "ancestral healing": "先祖治疗",
  "ancestral lunar zuljin": "祭祖春节祖尔金",
  "ancestral strength": "先祖之力",
  "ancestral wrath": "先祖之怒",
  "ancient blessings": "远古祝福",
  "ancient dark nexus hound": "远古黑暗时空恶犬",
  "ancient demonic auriel": "远古恶魔奥莉尔",
  "ancient demonic hellsteed carried": "远古恶魔战马（扛着）",
  "ancient demonic hellsteed": "远古恶魔战马",
  "ancient flame": "远古烈焰",
  "ancient seraphim tyrael": "远古六翼天使泰瑞尔",
  "ancient skelethur abathur": "远古骷髅阿巴瑟",
  "ancient spear": "上古之矛",
  "ancient unraveler zeratul": "上古剖尸者泽拉图",
  "and a shark too": "…还有鲨鱼！",
  "andariels visage": "安达莉尔的仪容",
  "andorhal anomaly": "安多哈尔异动",
  "anduin": "安度因",
  "angel of death": "死亡天使",
  "angel of justice": "正义天使",
  "angelic armaments": "天堂神兵",
  "angelic corruptor chogall": "天使腐蚀者古加尔",
  "angelic deckard": "天使迪卡德",
  "angelic flight": "天使飞行",
  "angelic grave warden malthael": "天堂镇墓者马萨伊尔",
  "angelic l 800 e t c": "天使800级精英牛头人酋长",
  "angelic phantom carried": "天使幽灵战马（扛着）",
  "angelic phantom": "天使幽灵战马",
  "angelic sonya": "天使桑娅",
  "angelic valla": "天使维拉",
  "angry cloud": "愤怒云",
  "animal husbandry": "野兽驯养",
  "animosity": "憎恨不息",
  "annihilate": "歼灭打击",
  "annihilating spirit": "湮灭恶灵",
  "anti armor shells": "反护甲弹",
  "anti healer": "反治疗",
  "anti magic shell": "反魔法护罩",
  "anubalisk": "阿努巴利斯克",
  "anubarak": "阿努巴拉克",
  "apex predator": "顶级捕食者",
  "apex xenotech malthael": "尖端异度机甲马萨伊尔",
  "apocalypse": "末世浩劫",
  "apollo suit": "阿波罗战服",
  "apothecary morales": "药剂师莫拉莉斯",
  "applied force": "强施之力",
  "aquamarine shrike": "碧绿伯劳鸟",
  "aquatic insectoid zagara": "水栖昆虫形态扎加拉",
  "ara executor zeratul": "艾拉执行官泽拉图",
  "ara tribe probius": "亚拉部族普罗比斯",
  "aranoch warmatron cassia": "埃拉诺克战争仕女卡西娅",
  "arcadian war turtle": "阿坎迪安战龟",
  "arcane brilliance": "奥术光辉",
  "arcane chaos lizard": "魔法混沌蜥蜴",
  "arcane charge": "奥术充能",
  "arcane echoes": "奥能回响",
  "arcane elemental lion": "奥能元素雄狮",
  "arcane emberlord zuljin": "奥术灰烬领主祖尔金",
  "arcane explosion": "魔爆术",
  "arcane flare": "奥术闪耀",
  "arcane grimskull nazeebo": "奥术恐惧之颅纳兹波",
  "arcane intellect": "奥术智慧",
  "arcane medivh": "奥义麦迪文",
  "arcane orb": "奥术之球",
  "arcane orbit": "奥术星环",
  "arcane rift": "奥术裂隙",
  "arcane ruinwalker fenix": "奥术废墟行者菲尼克斯",
  "arcanist jaina": "奥术师吉安娜",
  "arcanite axes": "奥金飞斧",
  "archangel auriel": "大天使奥莉尔",
  "archangel diablo": "大天使迪亚波罗",
  "archangel tyrael": "大天使泰瑞尔",
  "archangels wrath": "大天使之怒",
  "archon li ming": "御法者李敏",
  "archon pure power": "御法者：纯净能量",
  "archon": "执政官",
  "arctic deathfang genji": "北极死亡之牙源氏",
  "arctic enforcer johanna": "北极执法者乔汉娜",
  "arctic imperator stukov": "北极大帝斯托科夫",
  "arctic power drench tychus": "极地大泵水枪泰凯斯",
  "arctic reign deer": "北极时空驯鹿",
  "arctic sidewinder ana": "北极响尾蛇安娜",
  "arctic watchdog greymane": "北极看门狗格雷迈恩",
  "ardent defender": "炽热防御者",
  "ardent restoration": "热忱治愈",
  "ark reaktor": "聚变反应堆",
  "armor of faith": "信仰护甲",
  "armor of the archlich": "大巫妖护甲",
  "armor piercing rounds": "穿甲弹",
  "armor up": "铁甲加身",
  "armored assault": "重甲突袭",
  "armored stance": "掩蔽姿态",
  "armored war steed carried": "重甲军马（扛着）",
  "armored war steed": "重甲军马",
  "army of hell": "地狱大军",
  "army of the dead": "亡者大军",
  "arreat crater": "亚瑞特巨坑",
  "arsenal overcharge": "武库超载",
  "arsenal synergy": "火力协同",
  "arsenal": "火器射击",
  "art of chaos": "混乱湮灭",
  "artanis": "阿塔尼斯",
  "arthas": "阿尔萨斯",
  "ascendant alexstrasza": "升腾阿莱克丝塔萨",
  "ascendant probius prime": "升格主力机普罗比斯",
  "ash primal queen kerrigan": "灰烬原始女王凯瑞甘",
  "ashen hellflame nazeebo": "灰烬地狱火纳兹波",
  "ashen hellhammer thrall": "灰烬地狱之锤萨尔",
  "askari warmatron cassia": "阿斯卡利战争仕女卡西娅",
  "aspect of the beast": "野兽守护",
  "aspect of the hawk": "雄鹰守护",
  "assassinate": "刺杀",
  "assimilation blades": "同化之刃",
  "assimilation mastery": "同化专精",
  "assimilation": "同化效应",
  "astral communion": "星界沟通",
  "astral mecha tassadar": "星际机甲塔萨达尔",
  "astral presence": "星辰之躯",
  "atomic firestorm blaze": "原子烈焰风暴布雷泽",
  "auditiva lucio": "律动卢西奥",
  "augmented guard": "强化防御",
  "auriel": "奥莉尔",
  "aurora winter veil jaina": "极光冬幕节吉安娜",
  "automated first lt morales": "自动化莫拉莉斯上尉",
  "autumn lunara": "秋季露娜拉",
  "autumn storm mantle malfurion": "秋季怒风肩甲玛法里奥",
  "auxiliary shields": "辅助护盾",
  "avarice azmodan": "贪婪阿兹莫丹",
  "avatar": "天神下凡",
  "avenging wrath": "复仇之怒",
  "avoidance": "闪避",
  "awkward paper bag gazlowe": "怪笑袋加兹鲁维",
  "az guldan": "阿兹古尔丹",
  "azmodan": "阿兹莫丹",
  "azmodunk": "阿兹乔丹",
  "azure big top gazlowe": "碧蓝马戏团加兹鲁维",
  "azure bikini stitches": "碧蓝比基尼缝合怪",
  "azure cheerleader kerrigan": "天蓝啦啦队长凯瑞甘",
  "azure cyber oni warboar": "碧空鬼械战猪",
  "azure daelaam artanis": "碧蓝达拉姆阿塔尼斯",
  "azure elemental boar": "碧蓝元素野猪",
  "azure elemental lion": "碧蓝元素雄狮",
  "azure elemental lizard": "碧蓝元素蜥蜴",
  "azure elemental stag": "碧蓝元素驯鹿",
  "azure elemental wolf": "碧蓝元素战狼",
  "azure epic elemental lizard": "碧蓝史诗元素蜥蜴",
  "azure glam metal e t c": "碧蓝万人迷精英牛头人酋长",
  "azure grimskull nazeebo": "碧蓝恐惧之颅纳兹波",
  "azure headless horsemans charger carried": "碧蓝无头骑士的战马（扛着）",
  "azure headless horsemans charger": "碧蓝无头骑士的战马",
  "azure jaina": "碧蓝吉安娜",
  "azure lo gosh varian": "碧蓝洛戈什瓦里安",
  "azure lunar cassia": "碧空春节卡西娅",
  "azure lunar chen": "碧空春节老陈",
  "azure lunar dragon": "碧空春节祥龙",
  "azure lunar sylvanas": "碧空春节希尔瓦娜斯",
  "azure nimbus cloud": "碧蓝筋斗云",
  "azure ordermaster valla": "碧蓝秩序大师维拉",
  "azure orochi hovercycle": "碧蓝“大蛇”悬浮摩托",
  "azure power briefs tychus": "海蓝劲泳泰凯斯",
  "azure sacred oath johanna": "碧蓝神圣誓言乔汉娜",
  "azure sakura auriel": "碧蓝樱花奥莉尔",
  "azure slip n stream tracer": "天蓝水枪“猎空”",
  "azure soundblast lucio": "碧蓝震音卢西奥",
  "azure storm punk kaelthas": "碧蓝朋克凯尔萨斯",
  "backbiter": "冲击反噬",
  "backdraft": "爆燃",
  "backlash": "白骨反冲",
  "badlands deathfang genji": "恶土死亡之牙源氏",
  "badlands imperator stukov": "恶土大帝斯托科夫",
  "badlands sidewinder ana": "恶土响尾蛇安娜",
  "badlands viper dominator": "恶土蝰蛇陆霸",
  "bag of bolts gazlowe": "螺栓袋加兹鲁维",
  "baleog the fierce": "猛男巴尔洛戈",
  "balespider guldan": "邪蛛古尔丹",
  "ball lightning": "闪电球",
  "baneling barrage": "爆虫冲锋",
  "baneling massacre": "爆戮场",
  "banner of dalaran": "达拉然战旗",
  "banner of ironforge": "铁炉堡战旗",
  "banner of stormwind": "暴风城战旗",
  "banshee raven sylvanas": "邪鸦希尔瓦娜斯",
  "banshee tyrande": "女妖泰兰德",
  "barbed chains": "棘冰锁链",
  "barbed shot": "倒刺射击",
  "barko polo": "巴可·波罗",
  "barrel roll": "侧滚翻",
  "barricade cancel": "取消路障",
  "barricade": "路障",
  "base var 4 yellow": "Base - Var4 - Yellow",
  "bat form": "蝙蝠形态",
  "bat transformation": "蝙蝠形态",
  "battered assault": "猛烈连击",
  "battle beast": "战争蛮兽",
  "battle hunger": "战斗饥渴",
  "battle rage": "战斗怒火",
  "battle raptor": "战争迅猛龙",
  "battleborn": "战争之魔",
  "battlefield of eternity": "永恒战场",
  "beacon of light": "圣光道标",
  "beastmaster rexxar": "兽王雷克萨",
  "bed of barbs": "荆棘之丛",
  "beetle juiced": "吃饱喝足",
  "behemoth armor": "巨兽装甲",
  "benediction": "祈福",
  "berserk scrapper queen qhira": "狂暴削铁女皇琪拉",
  "berserker kharazim": "狂战士卡拉辛姆",
  "berserker": "狂暴",
  "beryl death god arthas": "绿玉死神阿尔萨斯",
  "bestial wrath": "狂野怒火",
  "bestow hope": "希望恩赐",
  "betrayer illidan": "背叛者伊利丹",
  "betrayer malfurion": "背叛者玛法里奥",
  "betrayers thirst": "背叛者的饥渴",
  "bewitching brightwing": "女巫光明之翼",
  "big as": "大钢牙",
  "big red button": "红色按钮",
  "big shot": "脉冲射击",
  "big top gazlowe": "马戏团加兹鲁维",
  "big top ringmasters pride": "杂耍马戏团长的雄狮",
  "big tuna kahuna": "大鱼人",
  "big voodoo": "大巫毒仪式",
  "bikini stitches": "比基尼缝合怪",
  "bile drop": "胆汁喷淋",
  "billie the kid": "儿童版比利",
  "binding heal": "联结治疗",
  "bio explosion switch": "生化爆裂",
  "bio kill switch": "生化杀伤",
  "biohazard mad axe garrosh": "生化危机疯狂艾克斯加尔鲁什",
  "biohazard raider rexxar": "生化游骑兵雷克萨",
  "biohazard road boar": "生化危机霸路猪",
  "bioluminescent murky": "荧光奔波尔霸",
  "biotic armor": "生化护甲",
  "biotic enhancements": "生物强化",
  "biotic grenade": "生物手雷",
  "bird of prey": "猛禽猎杀",
  "biting cold": "刺骨之寒",
  "black arrows": "黑蚀箭",
  "black claws": "漆黑之爪",
  "black grand marshal uther": "黑色大元帅乌瑟尔",
  "black hand uther": "黑手乌瑟尔",
  "black harvest": "黑暗收割",
  "black hearts bay": "黑心湾",
  "black knight sonya": "黑骑士桑娅",
  "black lagoon": "黑湖粘液",
  "black metal e t c": "黑色金属精英牛头人酋长",
  "black pool": "漆黑之池",
  "black soulstone": "黑暗灵魂石",
  "blackhearts doubloon": "黑心船长的达布隆币",
  "blackout delta hanzo": "黑疤敢死队半藏",
  "blackrock garrosh": "黑石加尔鲁什",
  "blackrock lord muradin": "黑石之王穆拉丁",
  "blackrock meat wagon": "黑石绞肉车",
  "blackwald hunter greymane": "黑瘴林猎手格雷迈恩",
  "blade dance": "飞刀轮舞",
  "blade dash": "利刃冲刺",
  "blade flurry": "剑刃乱舞",
  "blade of the highlord": "高阶领主之刃",
  "bladed armor": "刀刃护甲",
  "bladed momentum": "刀锋动能",
  "blademasters pursuit": "剑圣之道",
  "blades of a templar": "圣堂武士之刃",
  "blades of azzinoth": "埃辛诺斯之刃",
  "bladestorm cancel": "取消剑刃风暴",
  "bladestorm": "剑刃风暴",
  "blast echo": "余波",
  "blast shield": "爆裂护盾",
  "blast wave": "冲击波",
  "blaze of glory": "炽燃荣耀",
  "blaze": "布雷泽",
  "blazing fists": "拳出火势",
  "blazing lil ragnaros": "炽热小拉格",
  "blessed champion": "受祝福的勇士",
  "blessed hammer": "祝福之锤",
  "blessed judgment charger carried": "祝福审判战马（扛着）",
  "blessed judgment charger": "祝福审判战马",
  "blessed judgment uther": "祝福审判套装乌瑟尔",
  "blessed momentum": "祝福动能",
  "blessed recovery": "神恩回复",
  "blessed shield": "祝福之盾",
  "blessing of the bronze": "青铜龙的祝福",
  "blessing of the red": "红龙祝福",
  "blessings of yulon": "玉珑的祝福",
  "blight": "疫病之云",
  "blighted crypt queen zagara": "枯萎地穴女王扎加拉",
  "blighted death knight sonya": "枯萎死亡骑士桑娅",
  "blighted dreadlord jaina": "枯萎恐惧魔王吉安娜",
  "blighted frost": "枯萎冰霜",
  "blightlord kel thuzad": "枯萎领主克尔苏加德",
  "blind as a bat": "蝙蝠抓瞎",
  "blind": "致盲",
  "blinded by the light": "眩目圣光",
  "blinding flash": "眩目闪光",
  "blinding light": "致盲之光",
  "blinding speed": "绝世轻功",
  "blinding wind": "炫目之风",
  "blink heal": "闪烁治疗",
  "blink": "闪现",
  "blistering attacks": "灼热攻击",
  "blizzard": "暴风雪",
  "block party": "街舞派对",
  "block": "格挡",
  "blood and thunder": "鲜血与雷鸣",
  "blood elf tyrande": "血精灵泰兰德",
  "blood frenzy": "血性狂乱",
  "blood rage": "血怒",
  "blood raven sylvanas": "血鸦希尔瓦娜斯",
  "blood ritual": "鲜血仪式",
  "blood rush": "热血奔行",
  "blood sentinel lunara": "鲜血哨兵露娜拉",
  "bloodcraze": "血腥疯狂",
  "bloodfang valeera": "血牙瓦莉拉",
  "bloodlust rehgar": "嗜血雷加尔",
  "bloodlust": "嗜血",
  "bloodmoon raven runner": "血月陆行鸦",
  "bloodmyst yrel": "秘血伊瑞尔",
  "bloodsail pirate queen cassia": "血帆海盗女王卡西娅",
  "bloodscalp zuljin": "血顶祖尔金",
  "bloodthirst": "嗜血打击",
  "blossom lunar li ming": "花样春节李敏",
  "blossom lunar skyrocket": "花样春节爆竹",
  "blossom lunar sylvanas": "花样春节希尔瓦娜斯",
  "blossom swell": "花朵膨胀",
  "blueberry gingerboard": "蓝莓姜饼飞板",
  "blueberry gingerdread nazeebo": "蓝莓姜饼怪人纳兹波",
  "bluefish landwalker murky": "蓝鱼陆地行者奔波尔霸",
  "blunt force gun": "钝头弹",
  "bob and weave": "闪避身法",
  "body check": "身体阻截",
  "bogged down": "恐雷症",
  "bold strategy": "大胆的策略",
  "bolt of the storm": "风暴转移",
  "bombard strain": "轰击变种",
  "bombardment": "罪恶蔓延",
  "bombs away": "炸弹发射",
  "bond of anguish": "苦痛之枷",
  "bonds of corruption": "腐蚀之索",
  "bonds of justice": "制裁之索",
  "bone abathur": "白骨阿巴瑟",
  "bone armor": "白骨护甲",
  "bone herald of n zoth alarak": "白骨恩佐斯的传令官阿拉纳克",
  "bone necromaster xul": "白骨死灵大师祖尔",
  "bone prison": "骨牢",
  "bone spear": "骨矛",
  "bone visage xul": "白骨面罩祖尔",
  "boneslicer": "剔骨者",
  "bonewarden maiev": "白骨刑官玛维",
  "bonzer hits": "炸得漂亮",
  "boo merang": "爆炸回旋锤",
  "boom pow": "咔哒砰",
  "boombox": "立体音箱",
  "booming kick": "爆炸踢",
  "boosters": "推进器",
  "born in battle": "生于战斗",
  "bossa nova": "波萨诺瓦",
  "bottomless flask": "无尽药水",
  "bouncy bouncy": "弹弹乐",
  "bound by law": "天律之缚",
  "bound by shadow": "暗影束缚",
  "boundless fury": "无尽狂怒",
  "boundless stride": "跳跃无羁",
  "bounty hunter": "赏金猎人",
  "brand of solarion": "索拉里昂烙印",
  "brass special ordnance raynor": "黄铜特殊军火雷诺",
  "braxis holdout": "布拉克希斯禁区",
  "break it down": "给我拆！",
  "breath of fire": "火焰之息",
  "breath of heaven": "回天息",
  "breath of life": "生命吐息",
  "brewmaster chen": "酒仙陈",
  "brewmasters balance": "酒仙之道",
  "brightwing": "光明之翼",
  "bring it on": "放马过来",
  "bronze cyber wolf": "青铜科幻战狼",
  "bronze talons": "青铜龙爪",
  "bronze tiger kharazim": "青铜伏虎卡拉辛姆",
  "bronze vengeance valla": "青铜复仇维拉",
  "bronzebeard rage": "铜须之怒",
  "brood expansion": "虫巢扩张",
  "brooding guldan": "阴险古尔丹",
  "broodmother flight": "飞行虫母",
  "brown dire wolf": "棕色恐狼",
  "brown mystic kingdoms arthas": "棕色武圣阿尔萨斯",
  "bruised stitches": "瘀伤缝合怪",
  "bruiser": "斗士",
  "brushstalker": "隐蔽猎手",
  "brutal strike": "残忍打击",
  "brutal warlord chogall": "野蛮督军古加尔",
  "brutish vanguard": "残暴先锋",
  "bubble hearth": "无敌炉石",
  "buccaneer falstad": "掠夺者弗斯塔德",
  "bullet spray": "散射",
  "bullet time": "子弹时间",
  "bullseye": "正中靶心",
  "bulwark of light": "圣光堡垒",
  "bunker drop": "空投地堡",
  "bunny hop": "兔子跳",
  "buried alive": "活埋",
  "burn notice": "烧伤警告",
  "burn the impure": "净化不洁者",
  "burned flesh": "燃灼血肉",
  "burning blade samuro": "火刃萨穆罗",
  "burning blade": "燃烧之刃",
  "burning despair": "燃烧绝望",
  "burning halo": "炽热光环",
  "burning pumpkin chogall": "燃烧南瓜古加尔",
  "burning rage": "盛燃之怒",
  "burnished ana": "光亮安娜",
  "burrow charge cancel": "潜地冲锋取消",
  "burrow charge": "潜地冲锋",
  "burrow": "潜地",
  "burst fire": "急促连射",
  "busan police hovercycle": "釜山执法悬浮摩托",
  "butchers beast": "屠夫蛮兽",
  "butchers brand": "屠夫烙印",
  "butterscotch kandy king muradin": "黄油硬糖王穆拉丁",
  "buzzsaw": "断头锯",
  "c thuns gift": "克苏恩的赠礼",
  "caduceus feedback": "卡度休斯回馈",
  "caduceus reactor 2 0": "卡度休斯反应堆 2.0",
  "caduceus reactor": "卡度休斯反应堆",
  "calamity": "灾厄降临",
  "caldeum warmatron cassia": "卡尔蒂姆战争仕女卡西娅",
  "call mech": "呼叫机甲",
  "call of the wildhammer": "蛮锤召唤",
  "calldown mule": "轨道空投：矿骡",
  "calloused hide": "硬化外皮",
  "caltrops": "铁蒺藜",
  "camo d va": "迷彩D.Va",
  "camo prisoner tychus": "迷彩囚犯泰凯斯",
  "camo psycho stitches": "迷彩电锯缝合怪",
  "camo war world sgt hammer": "迷彩世界大战重锤军士",
  "canary striker li ming": "金丝雀排球女将李敏",
  "cancel berserker": "取消狂暴",
  "cancel boosters": "取消推进器",
  "cancel burrow": "取消潜地",
  "cancel defense matrix": "取消防御矩阵",
  "cancel dimensional shift": "取消次元相移",
  "cancel disintegrate": "取消瓦解射线",
  "cancel drain life": "取消吸取生命",
  "cancel eye of horus": "取消荷鲁斯之眼",
  "cancel fend": "取消猛刺",
  "cancel frozen tempest": "取消寒冰风暴",
  "cancel healing beam": "取消治疗射线",
  "cancel holy word salvation": "取消圣言术：赎",
  "cancel jug of 1 000 cups": "取消千杯不倒",
  "cancel leap": "取消腾空斩",
  "cancel march of the murlocs": "取消鱼人冲锋",
  "cancel mind control": "取消精神控制",
  "cancel portal": "取消传送门",
  "cancel raven form": "取消乌鸦形态",
  "cancel regeneration": "取消再生",
  "cancel return": "取消返回",
  "cancel sanctification": "取消圣化",
  "cancel shrike": "取消伯劳鸟",
  "cancel slowing sands": "取消减速沙尘",
  "cancel stay awhile and listen": "取消英雄请留步",
  "cancel stealth": "取消潜行",
  "cancel symbiote": "取消共生体",
  "cancel whirlwind": "取消旋风斩",
  "cancel wraith walk": "取消幽灵步",
  "cannibalize": "野蛮残食",
  "cannonball": "换炮弹！",
  "cannoneer": "爆炸魔星",
  "caramel kandy king muradin": "焦糖王穆拉丁",
  "carapace": "甲壳硬化",
  "carbon cybersteed carried": "碳纤赛博战马（扛着）",
  "carbon cybersteed": "碳纤赛博战马",
  "carbon fiber genji": "碳素纤维源氏",
  "carbon fiber mecha yrel": "碳纤机甲伊瑞尔",
  "carnage": "灭杀延形",
  "carrion swarm": "腐臭蝠群",
  "cassia": "卡西娅",
  "cataclysmic dark nexus guldan": "降劫黑暗时空古尔丹",
  "cataclysmic succubus kerrigan": "灾变魅魔凯瑞甘",
  "catching fire": "着火",
  "cauterize wounds": "烧灼伤口",
  "cave dweller lurkablo": "穴居奔波尔菠萝",
  "celerity": "动如脱兔",
  "celestial alignment": "众星合月",
  "celestial attunement": "星空弦音",
  "celestial billie": "星空比利",
  "celestial charge": "天界冲锋",
  "celestial empress whitemane": "星界女皇怀特迈恩",
  "celestial raptor": "星界迅猛龙 ",
  "celestial serpent": "星空巨蛇",
  "celestial steed carried": "星骓（扛着）",
  "celestial steed": "星骓",
  "celestial surfboard": "星空冲浪板",
  "celestial swiftness": "天界迅捷",
  "celestial ursa": "星界大熊",
  "celestial wrath": "星空之怒",
  "cellular reactor": "细胞反应堆",
  "centurion johanna": "百夫长乔汉娜",
  "ceremonial nazeebo": "祭祀纳兹波",
  "chain gang": "环锁囚禁",
  "chain heal": "治疗链",
  "chain lightning": "闪电链",
  "chain link": "链锁效应",
  "chain of command": "带兵有方",
  "chains of ice": "寒冰锁链",
  "chains of kel thuzad": "巫妖锁链",
  "chainsaw": "链锯模组",
  "champion azmodunk": "冠军阿兹乔丹",
  "champion cheerleader kerrigan": "冠军啦啦队长凯瑞甘",
  "champion dropkick kharazim": "“拳霸”卡拉辛姆",
  "champion striker li ming": "冠军排球女将李敏",
  "change is survival": "改变才能生存",
  "chaos az guldan": "混乱阿兹古尔丹",
  "chaos ironclaw rehgar": "混乱铁爪雷加尔",
  "chaos lion": "混沌雄狮",
  "chaos lizard": "混沌蜥蜴",
  "chaos reigns": "混乱统治",
  "chaos shadow council guldan": "混乱暗影议会古尔丹",
  "chaos warlord garrosh": "混乱督军加尔鲁什",
  "chaos wolf": "混沌狼",
  "chaotic energy": "混沌能量",
  "char abathur": "查尔阿巴瑟",
  "char kerrigan": "查尔凯瑞甘",
  "char zagara": "查尔扎加拉",
  "char zergling": "查尔跳虫",
  "charge": "冲锋",
  "charged blast": "充能爆破",
  "charged strikes": "充能一击",
  "charged up": "灌魔雷电",
  "charred mecha rehgar": "火焰机甲雷加尔",
  "chastise": "惩戒之光",
  "chattering teeth": "追着咬",
  "cheap shot": "偷袭",
  "checked pure country e t c": "格纹乡村歌手精英牛头人酋长",
  "checkpoint reached": "成功存档",
  "cheerleader kerrigan": "啦啦队长凯瑞甘",
  "chef stitches": "大厨缝合怪",
  "chen": "陈",
  "chief engineer gazlowe": "首席工程师加兹鲁维",
  "chilling seasons reapings malthael": "极寒礼物收割者马萨伊尔",
  "chilling touch": "寒冷之触",
  "chitinous plating": "强化骨板",
  "cho": "古",
  "choking pollen": "窒息花粉",
  "chomp": "魔噬",
  "chop chop": "狂切猛砍",
  "chop meat": "剁肉",
  "chosen crypt king tassadar": "神选墓穴之王塔萨达尔",
  "chromatic genji": "炫彩源氏",
  "chrome ribbit lucio": "铬黄宇宙蛙卢西奥",
  "chrome tiger": "铬钢丛林虎",
  "chromie": "克罗米",
  "chronic conditions": "时停症状",
  "chrono surge": "时空涌动",
  "chrysalis": "虫茧",
  "circle of life": "生生不息",
  "circle of protection": "守护之环",
  "citrine cyber wolf": "黄水晶科幻战狼",
  "citrine knight owl medivh": "黄水晶枭鹰骑士麦迪文",
  "citrine theramore jaina": "黄水晶塞拉摩吉安娜",
  "citrine thunderguard zarya": "黄水晶雷霆卫队查莉娅",
  "classic bloodfang valeera": "经典血牙瓦莉拉",
  "classic bone visage xul": "经典白骨面罩祖尔",
  "classic lost vikings": "经典失落的维京人",
  "classic piggy bank": "经典招财小猪",
  "classic zuljin": "经典祖尔金",
  "cleanse": "净化",
  "cleansing flame": "净化烈焰",
  "cleansing shield": "净化屏障",
  "cleansing touch": "净化之触",
  "clear out": "驱逐出境",
  "clear": "让开！",
  "cleave": "顺劈斩",
  "cleaver": "劈肉斧",
  "clemency": "格外开恩",
  "cloak of shadows": "暗影斗篷",
  "clockwerk steam fists": "发条蒸汽拳",
  "cloud serpent": "腾云巨蛇",
  "clown big top gazlowe": "小丑马戏团加兹鲁维",
  "clownfish murky": "小丑鱼奔波尔霸",
  "clowning junkrat": "小丑狂鼠",
  "coal greatfather winter malfurion": "碳黑冬天爷爷玛法里奥",
  "coal seasons reapings malthael": "碳黑礼物收割者马萨伊尔",
  "coal winter veil kharazim": "碳黑冬幕节卡拉辛姆",
  "coal winters helper valla": "碳黑冬天爷爷的助手维拉",
  "coastal sharkbite surfboard": "海岸鲨鱼咬痕冲浪板",
  "coastal surfboard": "海岸冲浪板",
  "cobalt cybarak anubarak": "钴蓝塞伯巴拉克",
  "cobalt high gravity zarya": "钴蓝超强重力查莉娅",
  "cobalt mecha tassadar": "钴蓝机甲塔萨达尔",
  "cobalt qhira": "钴蓝琪拉",
  "cobalt stormbot kaelthas": "钴蓝风暴机械凯尔萨斯",
  "cobalt tal rasha li ming": "钴蓝塔·拉夏李敏",
  "cobalt technolope": "钴蓝科技战羊",
  "cobalt valeera": "钴蓝瓦莉拉",
  "cobaltside dire wolf": "钴蓝恐狼",
  "cocoon": "虫茧缚体",
  "cold embrace": "死寒之拥",
  "cold greatfather winter stitches": "冰冷冬天爷爷缝合怪",
  "cold hand of death": "死神的冰冷之手",
  "cold hand": "冰冷之手",
  "cold snap": "急速冷却",
  "cold warchief sylvanas": "冰冷大酋长希尔瓦娜斯",
  "cold winter veil lunara": "冰冷冬幕节露娜拉",
  "coldfire fel reaver blaze": "冷火魔能机甲布雷泽",
  "coldheart vampire slayer v": "冷血吸血鬼猎人V",
  "colossal ruinwalker fenix": "巨型废墟行者菲尼克斯",
  "colossal totem": "巨型图腾",
  "colossus smash": "巨人打击",
  "combat advantage": "战斗优势",
  "combat readiness": "备战就绪",
  "combat tactician": "战斗专家",
  "combo strikes": "快速连击",
  "combustion cancel": "取消增压爆燃",
  "combustion": "增压爆燃",
  "coming through": "推力加量",
  "command raynors raider": "指挥雷诺的游骑兵",
  "command ultralisk": "命令雷兽",
  "command water elemental": "指挥水元素",
  "commandant varian": "指挥官瓦里安",
  "commandeer odin": "奥丁降临",
  "commander raynor": "指挥官雷诺",
  "commando d e r p a": "突击队德尔帕",
  "competitive azmodunk": "千分球王阿兹乔丹",
  "competitive pro d va": "竞技职业选手D.Va",
  "composite spear": "复合之矛",
  "composition b": "复合炸药",
  "concentrated doses": "浓缩剂量",
  "concussion grenade": "震撼手雷",
  "concussion mine": "震荡地雷",
  "concussive blast": "震荡炮击",
  "concussive pulse": "震荡脉冲",
  "condemn": "天谴",
  "cone of cold": "冰锥术",
  "congealed stitches": "凝结缝合怪",
  "consecrated count arthas": "圣化伯爵阿尔萨斯",
  "constriction": "束缚",
  "construct additional pylons": "建造更多的水晶塔",
  "construction mecha rehgar": "建造机甲雷加尔",
  "consume soul": "吞噬灵魂",
  "consume souls": "噬魂",
  "consume vitality": "活力吸收",
  "consumed by hatred": "仇恨之噬",
  "consuming blaze": "吞噬耀光",
  "consuming fire": "吞噬之焰",
  "consuming flame": "噬体烈焰",
  "contact healing": "接触治疗",
  "contagion": "传染",
  "contain": "禁锢",
  "containment disc": "禁锢环刃",
  "contaminated butcher": "被污染的屠夫",
  "controlled chaos": "隐忍杀欲",
  "convection": "热能对流",
  "converging force": "汇聚之力",
  "convict junkrat": "罪犯狂鼠",
  "conviction": "定罪",
  "copper cloud serpent": "赤铜腾云巨蛇",
  "copper leoric": "赤铜李奥瑞克",
  "copper piggy bank": "铜色招财小猪",
  "copper serpent king xul": "赤铜毒蛇之王祖尔",
  "copper varian": "黄铜瓦里安",
  "coral deepcrawler": "珊瑚深渊爬行蟹",
  "coral warbringer zuljin": "珊瑚战争使者祖尔金",
  "corpse explosion": "尸爆",
  "corpse feeders": "食尸虫",
  "corpse spiders": "尸蛛",
  "corrosive dark nexus manta": "腐蚀黑暗时空蝠鲼",
  "corrosive saliva": "腐蚀唾液",
  "corrupted archangel diablo": "腐化大天使迪亚波罗",
  "corrupted tombstone": "亵渎之墓碑",
  "corruption": "腐蚀术",
  "corruptor chogall": "腐蚀者古加尔",
  "cosmic force valeera": "宇宙特攻队瓦莉拉",
  "cosmic lion": "宇宙雄狮",
  "counter strike": "反击",
  "countess kerrigan": "伯爵夫人凯瑞甘",
  "courageous auriel": "英勇奥莉尔",
  "courageous rooster": "勇敢的公鸡",
  "court witch whitemane": "圣庭女巫怀特迈恩",
  "covert mission": "隐秘任务",
  "covert ops": "隐秘行动",
  "covert paramedic morales": "隐秘急救医师莫拉莉斯",
  "covert raider rexxar": "隐秘游骑兵雷克萨",
  "crash course": "别挡道",
  "crash lightning": "毁灭闪电",
  "creed of the hunter": "猎人信条",
  "creep tumor": "菌毯肿瘤",
  "creepie chromie": "骷髅脸克罗米",
  "crimson alarak": "猩红阿拉纳克",
  "crimson apothecary morales": "猩红药剂师莫拉莉斯",
  "crimson battle raptor": "猩红战争迅猛龙",
  "crimson bewitching brightwing": "猩红女巫光明之翼",
  "crimson cheerleader kerrigan": "猩红啦啦队长凯瑞甘",
  "crimson chen": "猩红陈",
  "crimson count arthas": "血腥伯爵阿尔萨斯",
  "crimson crypt king tassadar": "猩红墓穴之王塔萨达尔",
  "crimson cybarak anubarak": "猩红塞伯巴拉克",
  "crimson demon hunter valeera": "猩红恶魔猎手瓦莉拉",
  "crimson eagle eye tyrande": "猩红鹰眼泰兰德",
  "crimson epic battle raptor": "猩红史诗战争迅猛龙",
  "crimson eredar armor illidan": "猩红艾瑞达护甲伊利丹",
  "crimson fel queen chromie": "猩红邪能女王克罗米",
  "crimson felsaber": "猩红邪刃豹",
  "crimson grave warden malthael": "血腥镇墓者马萨伊尔",
  "crimson gryphon master falstad": "猩红狮鹫大师弗斯塔德",
  "crimson hare carried": "赤兔（扛着）",
  "crimson hare": "赤兔",
  "crimson headless horsemans charger carried": "猩红无头骑士的战马（扛着）",
  "crimson headless horsemans charger": "猩红无头骑士的战马",
  "crimson hell billie": "猩红地狱比利",
  "crimson high gravity zarya": "猩红超强重力查莉娅",
  "crimson illidan": "猩红伊利丹",
  "crimson illidans nightmare carried": "猩红伊利丹的梦魇（扛着）",
  "crimson illidans nightmare": "猩红伊利丹的梦魇",
  "crimson kaijo diablo": "猩红怪兽迪亚波罗",
  "crimson king stitches": "猩红国王缝合怪",
  "crimson legions wrath sonya": "猩红军团之怒桑娅",
  "crimson li ming": "猩红李敏",
  "crimson lionheart varian": "猩红狮心瓦里安",
  "crimson mechanospider": "猩红机械蜘蛛",
  "crimson nazeebo": "猩红纳兹波",
  "crimson nazeebra carried": "猩红纳兹布拉（扛着）",
  "crimson nazeebra": "猩红纳兹布拉",
  "crimson orochi hovercycle": "猩红“大蛇”悬浮摩托",
  "crimson purifier artanis": "猩红净化者阿塔尼斯",
  "crimson ringmasters pride": "猩红马戏团长的雄狮",
  "crimson sacred oath johanna": "猩红神圣誓言乔汉娜",
  "crimson scarecrow xul": "猩红稻草人祖尔",
  "crimson soundblast lucio": "猩红震音卢西奥",
  "crimson special ordnance raynor": "猩红特殊军火雷诺",
  "crimson storm punk kaelthas": "猩红朋克凯尔萨斯",
  "crimson storm wolf rehgar": "猩红风暴之狼雷加尔",
  "crimson succubus kerrigan": "猩红魅魔凯瑞甘",
  "crimson swarm abathur": "猩红虫群阿巴瑟",
  "crimson tal rasha li ming": "猩红塔·拉夏李敏",
  "crimson war bear": "猩红战熊",
  "crimson warchief sylvanas": "猩红大酋长希尔瓦娜斯",
  "crimson wrath sonya": "猩红愤怒套装桑娅",
  "crimson xul": "猩红祖尔",
  "crimson zeratul": "猩红泽拉图",
  "crippling hammer": "致残回旋锤",
  "crippling poison": "减速药膏",
  "crippling shot": "致残射击",
  "crippling slam": "致残猛劈",
  "crippling spores": "致残孢子",
  "crippling talons": "致残利爪",
  "critical mass": "临界炽焰",
  "critical mist": "救急之雾",
  "critical strike": "致命一击",
  "critterize": "渺小变形",
  "crossfade": "切歌",
  "crossfire": "交叉火力",
  "crowd pleaser": "取悦观众",
  "crowd surfer": "舞台冲浪",
  "crown prince arthas": "洛丹伦王子阿尔萨斯",
  "cruel chain": "残忍锁链",
  "cruel lunar zuljin": "残暴春节祖尔金",
  "cruel queen of ghosts kerrigan": "残忍幽灵女王凯瑞甘",
  "cruelty": "残酷",
  "crusher chogall": "粉碎者古加尔",
  "crushing blows": "致命打击",
  "crushing hope": "粉碎希望",
  "crushing jaws": "巨颚碎压",
  "cryo deathfang genji": "冰霜死亡之牙源氏",
  "cryo imperator stukov": "冰霜斯托科夫大帝",
  "cryo sidewinder ana": "冰霜响尾蛇安娜",
  "cryo spectre tracer": "急冻幽魂“猎空”",
  "crypt king tassadar": "墓穴之王塔萨达尔",
  "crypt lord wings": "地穴领主之翼",
  "crypt queen zagara": "地穴女王扎加拉",
  "cryptweave": "地穴织网",
  "crystal aegis": "水晶庇护",
  "crystal arch lt morales": "水晶穹顶莫拉莉斯中尉",
  "crystalforged yrel": "晶铸伊瑞尔",
  "crystalline ruinwalker fenix": "水晶废墟行者菲尼克斯",
  "crystalline saddled battle beast": "水晶鞍座战争蛮兽",
  "cube mastery": "魔盒老手",
  "cuddle bear stitches": "抱抱熊缝合怪",
  "curse of exhaustion": "疲劳诅咒",
  "curse of the worgen": "狼人诅咒",
  "cursed bullet": "诅咒枪弹",
  "cursed hollow": "诅咒谷",
  "cursed hunter greymane": "诅咒猎手格雷迈恩",
  "cursed strikes": "邪灵打击",
  "cursed witch whitemane": "诅咒女巫怀特迈恩",
  "custom mecha rehgar": "改装机甲雷加尔",
  "custom rig tychus": "特制装备泰凯斯",
  "cyan void speeder": "青绿虚空穿梭者",
  "cybarak anubarak": "塞伯巴拉克",
  "cyber agility": "灵",
  "cyber ghost kerrigan": "赛博幽灵凯瑞甘",
  "cyber oni anubarak": "鬼械阿努巴拉克",
  "cyber oni butcher": "鬼械屠夫",
  "cyber oni warboar": "鬼械战猪",
  "cyber oni zarya": "鬼械查莉娅",
  "cyber orochi hovercycle": "赛博“大蛇”悬浮摩托",
  "cyber ram": "科幻公羊",
  "cyber shield": "机械护盾",
  "cyber wolf": "科幻战狼",
  "cyberdemon zarya": "赛博恶鬼查莉娅",
  "cyberhawk kaelthas": "赛博雄鹰凯尔萨斯",
  "cybernetic star wraith mephisto": "机动星际怨灵墨菲斯托",
  "cyborgdemon zarya": "机械恶鬼查莉娅",
  "cyborghawk kaelthas": "机械雄鹰凯尔萨斯",
  "cydaeas kiss": "辛迪娅之吻",
  "d e r p a": "德尔帕",
  "d haka": "D.哈卡",
  "d va the destroyer": "灭世者D.Va",
  "d va the destroyerlisk": "灭世异虫D.Va",
  "d va the dreamer": "沉睡者D.Va",
  "d va the life binder": "生命的缚誓者D.Va",
  "d va the spellweaver": "织法者D.Va",
  "d va": "D.Va",
  "daelaam artanis": "达拉姆阿塔尼斯",
  "dalaran prince arthas": "达拉然王子阿尔萨斯",
  "dampening field": "衰减场",
  "dance of death": "死亡之舞",
  "daredevil helldorado": "鲁莽地狱狂驹",
  "daredevil roadraider raynor": "超胆巡游侠雷诺",
  "dark angelic valla": "黑暗天使维拉",
  "dark auriel": "黑暗奥莉尔",
  "dark bargain": "黑暗交易",
  "dark conversion": "黑暗转换",
  "dark e t c": "深色精英牛头人酋长",
  "dark executioner butcher": "黑暗刽子手屠夫",
  "dark hand samuro": "黑手萨穆罗",
  "dark iron falstad": "黑铁弗斯塔德",
  "dark iron magni muradin": "黑铁麦格尼穆拉丁",
  "dark lady sylvanas": "黑暗女王希尔瓦娜斯",
  "dark ladys call": "黑暗女王的召唤",
  "dark mecha rehgar": "黑暗机甲雷加尔",
  "dark mecha tyrael": "黑暗机甲泰瑞尔",
  "dark medivh": "黑暗麦迪文",
  "dark nexus alarak": "黑暗时空阿拉纳克",
  "dark nexus guldan": "黑暗时空古尔丹",
  "dark nexus hound": "黑暗时空恶犬",
  "dark nexus manta": "黑暗时空蝠鲼",
  "dark power drench tychus": "暗色大泵水枪泰凯斯",
  "dark prelate zeratul": "黑暗教长泽拉图",
  "dark queen alexstrasza": "黑暗女王阿莱克丝塔萨",
  "dark sentinel lunara": "黑暗哨兵露娜拉",
  "dark seraphim tyrael": "黑暗六翼天使泰瑞尔",
  "dark shaman thrall": "黑暗萨满萨尔",
  "dark star princess li ming": "黑暗星辰公主李敏",
  "dark storm lord falstad": "黑暗风暴之王弗斯塔德",
  "dark swarm": "黑暗虫群",
  "dark templar li ming": "黑暗圣堂武士李敏",
  "dark tyrande": "黑暗泰兰德",
  "dark valeera": "暗影瓦莉拉",
  "darkener mal ganis": "亵渎者玛尔加尼斯",
  "darkflight": "疾步夜行",
  "darkmoon ringmaster greymane": "暗月马戏团长格雷迈恩",
  "darkness descends": "黑暗迫袭",
  "darkness within": "黑暗之心",
  "darkshire anduin": "夜色镇安度因",
  "darkshire reverence carried": "夜色镇虔敬（扛着）",
  "darkshire reverence": "夜色镇虔敬",
  "darkspear sapper junkrat": "暗矛爆破兵狂鼠",
  "darkwing": "黑暗之翼",
  "darnassian archery": "达纳苏斯箭术",
  "darnassian maiev": "达纳苏斯玛维",
  "dash": "突进",
  "dauntless": "坚定",
  "dazer zone": "晕眩矩阵",
  "dead magic": "过时的魔法",
  "dead rush": "亡者进军",
  "deadeye": "致命狙击",
  "deadly battle raptor": "致命战争迅猛龙",
  "deadly calm": "致命平静",
  "deadly chaos lizard": "致命混沌蜥蜴",
  "deadly chaos wolf": "致命混沌狼",
  "deadly charge": "致命冲锋",
  "deadly demon hunter valeera": "致命恶魔猎手瓦莉拉",
  "deadly epic battle raptor": "致命史诗战争迅猛龙",
  "deadly garrosh": "致命加尔鲁什",
  "deadly lo gosh varian": "致命洛戈什瓦里安",
  "deadly reach active": "冲心拳激活",
  "deadly reach": "冲心拳",
  "deadly strike": "下段踢",
  "deadwalker warmatron cassia": "死亡行者战争仕女卡西娅",
  "deafening blast": "震耳欲聋",
  "death and decay": "死亡凋零",
  "death aspect alexstrasza": "死亡巨龙阿莱克丝塔萨",
  "death coil": "死亡缠绕",
  "death dealer": "死亡使者",
  "death from above": "天降杀机",
  "death god arthas": "死神阿尔萨斯",
  "death knight sonya": "死亡骑士桑娅",
  "death march": "死亡进军",
  "death metal": "死亡金属",
  "death shroud": "死亡笼罩",
  "death siphon": "死亡虹吸",
  "death wish": "死亡之愿",
  "deathbringer sonya": "死亡使者桑娅",
  "deathchill": "死亡之寒",
  "deathfang genji": "死亡之牙源氏",
  "deathguard meat wagon": "死卫绞肉车",
  "deathlord": "死亡领主",
  "deatholme underking anubarak": "死亡之洲地底虫王阿努巴拉克",
  "deathranger nova": "死亡游侠诺娃",
  "deathreaper mecha tyrael": "死亡收割机甲泰瑞尔",
  "deaths advance": "死亡脚步",
  "deaths head mecha rehgar": "死亡之颅机甲雷加尔",
  "deaths reach": "死亡延伸",
  "debilitating dart": "衰弱镖",
  "debilitating flames": "虚弱烈焰",
  "debilitating rounds": "衰弱弹",
  "debilitation": "衰竭",
  "decimate": "致残挥砍",
  "deckard pain": "迪卡德·佩恩",
  "deckard": "迪卡德",
  "deep bag gazlowe": "海鲜袋加兹鲁维",
  "deep breathing": "深呼吸",
  "deep chill": "极寒冰冻",
  "deep herald of n zoth alarak": "深色恩佐斯的传令官阿拉纳克",
  "deep impact": "深度撞击",
  "deep roots": "根深蒂固",
  "deep shift": "深度相移",
  "deep sleep": "深度沉睡",
  "deep tunnel": "深槽虫道",
  "deepcrawler": "深渊爬行蟹",
  "defense matrix": "防御矩阵",
  "defense of the angels": "天使之御",
  "defensive measures": "防御措施",
  "defensive shielding": "防御屏障",
  "deflect": "闪",
  "deflection": "偏斜",
  "dehaka": "德哈卡",
  "dehakasaurus rex": "暴龙王德哈卡",
  "delta hanzo": "敢死队半藏",
  "delta squadron medic uther": "德尔塔中队医疗兵乌瑟尔",
  "demolitions expert": "爆破专家",
  "demon hanzo": "恶龙半藏",
  "demon hunter valeera": "恶魔猎手瓦莉拉",
  "demon lieutenant": "地狱大将",
  "demonic auriel": "恶魔奥莉尔",
  "demonic circle": "恶魔法阵",
  "demonic form": "恶魔形态",
  "demonic hellsteed carried": "恶魔战马（扛着）",
  "demonic hellsteed": "恶魔战马",
  "demonic imperius": "恶魔英普瑞斯",
  "demonic invasion": "恶魔入侵",
  "demonic phantom carried": "恶魔幽灵战马（扛着）",
  "demonic phantom": "恶魔幽灵战马",
  "demonic tyrael": "恶魔泰瑞尔",
  "demoralizing shout": "挫志怒吼",
  "deputy valla": "副警长维拉",
  "desert anubarak": "沙漠阿努巴拉克",
  "desert commander raynor": "沙漠指挥官雷诺",
  "desert d e r p a": "沙漠德尔帕",
  "desert ops deckard pain": "沙漠特战队迪卡德·佩恩",
  "desert queen zagara": "沙漠女王扎加拉",
  "desert scrapper queen qhira": "荒漠削铁女皇琪拉",
  "desert warbringer zuljin": "沙漠战争使者祖尔金",
  "desert watchdog greymane": "沙漠看门狗格雷迈恩",
  "desperate plea": "绝望祈求",
  "desperate prayer": "绝望祷言",
  "detainment strike": "束缚打击",
  "determination": "坚定信念",
  "deth lazor end": "死亡射线结束",
  "deth lazor": "死亡射线",
  "detonate displacement grenade": "引爆位移手雷",
  "detonate mine": "引爆地雷",
  "detonate rip tire": "引爆炸弹轮胎",
  "detonate time trap": "引爆时间陷阱",
  "detonate twisting nether": "引爆扭曲虚空",
  "devastating charge": "毁灭冲锋",
  "devil dogs goliath d va": "恶魔犬歌利亚D.Va ",
  "devilish fallen junkrat": "邪性堕落者狂鼠",
  "devils due": "恶魔代价",
  "devotion": "虔诚",
  "devour": "吞噬",
  "devouring maw": "吞噬巨口",
  "diablo": "迪亚波罗",
  "diablos doubloon": "迪亚波罗的达布隆币",
  "diabolical momentum": "魔王动能",
  "diamond resolve": "钻石决心",
  "diamond skin": "钻石体肤",
  "dictator stukov": "独裁者斯托科夫",
  "die alone": "孤独死亡",
  "diesel speaker nazeebo": "柴油爆音王纳兹波",
  "diesel wastewalker deckard": "柴油废墟行者迪卡德",
  "digestive juices": "腐蚀胃液",
  "dignified greymane": "高贵格雷迈恩",
  "dimensional shift": "次元相移",
  "dinometal dehakasaurus rex": "机械暴龙德哈卡",
  "dire beast": "凶暴野兽",
  "dire wolf": "恐狼",
  "discord strike": "混乱打击",
  "disengage": "逃脱",
  "disintegrate cancel": "瓦解射线（取消）",
  "disintegrate": "瓦解射线",
  "displacement grenade": "位移手雷",
  "disruption pulse": "干扰脉冲",
  "dissonance": "不谐",
  "dive": "俯冲",
  "divert power weapons": "能量转向：武器",
  "diverting power": "能量传输",
  "divine favor": "神恩术",
  "divine hurricane": "神圣飓风",
  "divine palm": "圣灵掌",
  "divine protection": "圣佑术",
  "divine purpose": "神圣意志",
  "divine queen alexstrasza": "神圣女王阿莱克丝塔萨",
  "divine rage": "神怒",
  "divine reckoning": "神圣清算",
  "divine shield": "圣盾术",
  "divine star": "神圣之星",
  "divine steed": "神圣马驹",
  "divine storm": "神圣风暴",
  "divine vigor": "神圣活力",
  "doctor wolf stein": "沃尔夫博士与斯坦",
  "dodge": "移",
  "dominance": "彼消我长",
  "domination": "魔王统御",
  "dominion blaze": "帝国布雷泽",
  "dominion cyber ram": "帝国科幻公羊",
  "dominion elite agent nova": "帝国精英特工诺娃",
  "dominion ghost speeder": "帝国幽灵穿梭者",
  "dominion infested tychus": "帝国被感染的泰凯斯",
  "dominion maraudin muradin": "帝国劫掠者穆拉丁",
  "dominion marshal raynor": "帝国警长雷诺",
  "dominion marshals outrider carried": "帝国警长的先驱者（扛着）",
  "dominion marshals outrider": "帝国警长的先驱者",
  "dominion medic uther": "帝国医疗兵乌瑟尔",
  "dominion raynor": "帝国雷诺",
  "dominion vulture": "帝国秃鹫",
  "dominus vile azmodan": "恶毒大君阿兹莫丹",
  "doombringer l 800 e t c": "厄运使者800级精英牛头人",
  "dorm 2017 championship banner": "2017风暴学霸冠军旗帜",
  "dorm cheerleader kerrigan": "风暴学霸啦啦队长凯瑞甘",
  "dottie creepie chromie": "诡异骷髅脸克罗米",
  "double back": "回跳",
  "double dragon": "双龙戏珠",
  "double jump": "二段跳",
  "double tap": "二连发",
  "double trouble": "双重麻烦",
  "double up": "加倍武装",
  "double wyrmhole": "龙洞再现",
  "draconic discipline": "巨龙戒律",
  "draenor burning blade samuro": "德拉诺燃烧之刃萨穆罗",
  "draenor drek thar rehgar": "德拉诺德雷克塔尔雷加尔",
  "draenor hellhammer thrall": "德拉诺地狱之锤萨尔",
  "drag": "拖拽",
  "dragon aspect alexstrasza": "守护巨龙阿莱克丝塔萨",
  "dragon claw": "龙爪",
  "dragon hanzo": "巨龙半藏",
  "dragon lunar illidan": "舞龙春节伊利丹",
  "dragon scales": "巨龙之鳞",
  "dragon shire": "巨龙镇",
  "dragonblade": "斩",
  "dragonflayer lord muradin": "屠龙之王穆拉丁",
  "dragonqueen": "红龙女王",
  "dragons arrow": "绝",
  "dragons breath": "青铜龙息",
  "dragonstrike": "竜",
  "drain essence": "吸取精华",
  "drain hope": "绝望吸魂",
  "drain life": "吸取生命",
  "drain momentum": "吸魂动能",
  "drakkari war bear": "达卡莱战熊",
  "drakken laser drill": "德拉肯激光钻机",
  "dread orb": "恐惧之球",
  "dread": "蠕行煞魔",
  "dreadlands sonya": "恐惧之地桑娅",
  "dreadlord jaina": "恐惧魔王吉安娜",
  "dreadmachine mal ganis": "恐惧装甲玛尔加尼斯",
  "dreadwarden maiev": "恐惧刑官玛维",
  "dream genie chromie": "梦幻精灵克罗米",
  "dream shot": "梦境射击",
  "dream waywatcher malfurion": "梦境守路者玛法里奥",
  "dreambreaker grizzly": "碎梦者灰熊",
  "dreambreaker thrall": "碎梦者萨尔",
  "dreamie genie chromie": "梦境精灵克罗米",
  "dreamknight yrel": "梦想骑士伊瑞尔",
  "drek thar rehgar": "德雷克塔尔雷加尔",
  "dropdead kharazim": "“夺命腿”卡拉辛姆",
  "dropkick kharazim": "“金刚腿”卡拉辛姆",
  "drowned junkrat": "失智狂鼠",
  "druid of the flame malfurion": "烈焰德鲁伊玛法里奥",
  "dryads swiftness": "树妖迅捷",
  "durance of hate": "憎恨囚牢",
  "durotar wanderer chen": "杜隆塔尔云游者陈 ",
  "dusk auriel": "黄昏奥莉尔",
  "dusk bewitching brightwing": "幽暗女巫光明之翼",
  "dusk deathranger nova": "暮色死亡游侠诺娃",
  "dusk maiev": "暮色玛维",
  "dusk wing": "黄昏之翼",
  "dust of appearance": "显影之尘",
  "dust of disappearance": "隐匿之尘",
  "dwarf launch": "矮人飞射",
  "dwarf toss": "矮人投掷",
  "dying breath": "殒命之息",
  "dynamic optics": "动态光学组件",
  "e t c": "精英牛头人酋长",
  "eager adventurer": "急切的冒险者",
  "eager wolf": "恶狼",
  "eagle eye tyrande": "鹰眼泰兰德",
  "earth ally": "土相幻身",
  "earth shield": "大地之盾",
  "earth": "大地之灵",
  "earthbind totem": "地缚图腾",
  "earthbreaker grizzly": "碎地者灰熊",
  "earthbreaker thrall": "碎地者萨尔",
  "earthen frostlord rexxar": "大地冰霜领主雷克萨",
  "earthen shields": "大地护盾",
  "earthgrasp totem": "地握图腾",
  "earthliving enchant": "大地生命附魔",
  "earthquake": "地震术",
  "earthshaker": "震地者",
  "easy prey": "小菜一碟",
  "ebon vampire slayer valla": "乌木吸血鬼杀手维拉",
  "echo of doom": "末日回响",
  "echo of heaven": "天音袅绕",
  "echo of the elements": "元素回响",
  "echo pedal": "回声踏板",
  "echo pulse": "回荡脉冲",
  "echoed corruption": "回荡腐蚀",
  "echoes of death": "死亡回音",
  "eclipse lunar jaina": "月蚀春节吉安娜",
  "eclipse lunar li li": "月蚀春节丽丽",
  "eclipse lunar tiger": "月蚀月光虎",
  "edge of madness": "疯狂边缘",
  "egg hunt": "鱼蛋狩猎",
  "egg shell": "蛋壳",
  "el chamuco diablo": "“火罗刹”迪亚波罗",
  "el fuego garrosh": "“火旋风”加尔鲁什",
  "el jefe garrosh": "“暴君”加尔鲁什",
  "el mariachi e t c": "“玛利亚奇音乐牛”E.T.C.",
  "elder flying monkey brightwing": "长者飞猿光明之翼",
  "eldritch conduit": "异能通道",
  "eldritch dark nexus guldan": "恐怖黑暗时空古尔丹",
  "eldruins flash": "圣剑之耀",
  "eldruins might": "圣剑之力",
  "electric charge": "充电",
  "electric street cyborg kharazim": "电子街头改造人卡拉辛姆",
  "elegant dream genie chromie": "优雅梦幻精灵克罗米",
  "elemental boar": "元素野猪",
  "elemental conduit": "元素导能",
  "elemental lion": "元素雄狮",
  "elemental lizard": "元素蜥蜴",
  "elemental stag": "元素驯鹿",
  "elemental wolf": "元素战狼",
  "elite agent nova": "精英特工诺娃",
  "elite pro d va": "精英职业选手D.Va",
  "elongated tongue": "长舌",
  "elunes chosen": "艾露恩钦定者",
  "elunes wrath": "艾露恩之怒",
  "elusive brawler": "醉拳大师",
  "elusive strike": "闪避打击",
  "elusiveness": "飘忽不定",
  "elwynn anduin": "艾尔文森林安度因",
  "ember deathranger nova": "灰烬死亡游侠诺娃",
  "emberlord zuljin": "灰烬领主祖尔金",
  "embrace death": "死神之拥",
  "emerald bloodfang valeera": "翡翠血牙瓦莉拉",
  "emerald chromie": "翡翠克罗米",
  "emerald countess kerrigan": "翡翠伯爵夫人凯瑞甘",
  "emerald highlord alarak": "翡翠高阶领主阿拉纳克",
  "emerald knight owl medivh": "翡翠枭鹰骑士麦迪文",
  "emerald lunara": "翡翠露娜拉",
  "emerald monarch brightwing": "翡翠帝王蝶光明之翼",
  "emerald tassadar": "翡翠塔萨达尔",
  "emerald theramore jaina": "翡翠塞拉摩吉安娜",
  "emerald thunder guard zarya": "翡翠雷霆卫队查莉娅",
  "emerald widowmaker nova": "翡翠黑百合诺娃",
  "emerald wind": "翡翠之风",
  "emerald": "绿宝石",
  "emergency protocol": "应急程序",
  "emergency shielding": "应急护盾",
  "emp grenade": "EMP手雷",
  "empathic link": "共鸣链接",
  "empower sulfuras": "强化萨弗拉斯",
  "empower": "强化术",
  "en pointe": "足尖芭蕾",
  "enchant boots lions speed": "附魔靴子 - 雄狮之速",
  "enchanted sentinel lunara": "魔法哨兵露娜拉",
  "encore": "再来一首",
  "endless creep": "无限菌毯",
  "endless nades": "快速装弹",
  "endless spores": "无尽孢子",
  "endurance stimpack": "耐力强化剂",
  "endurance training": "耐力训练",
  "enduring swarm": "坚韧虫群",
  "enduring will": "坚韧意志",
  "energized cord": "充能束带",
  "energizing brew": "豪能酒",
  "energy roil": "混沌能量",
  "energy": "能量",
  "enforcer johanna": "执法者乔汉娜",
  "engine gunk": "粘稠引擎",
  "engulfing flame": "噬体烈焰",
  "engulfing oblivion": "湮灭之缚",
  "enhanced agility": "增强敏捷",
  "ennead deckard": "恩奈德迪卡德",
  "enough to share": "这次我请",
  "enraged anubalisk": "暴怒阿努巴利斯克",
  "enraged butcherlisk": "暴怒屠夫雷兽",
  "enraged regeneration": "狂怒恢复",
  "enraged": "激怒",
  "ensnare": "诱捕",
  "ensnaring swing": "束缚索",
  "entangling roots": "纠缠根须",
  "entomb cancel": "乱葬坟墓（取消）",
  "entomb": "乱葬坟墓",
  "entombed zakarum leoric": "埋葬萨卡兰姆李奥瑞克",
  "entrenched": "加固阵地",
  "entropic dark nexus manta": "熵能黑暗时空蝠鲼",
  "enveloping shadows": "暗影笼罩",
  "envenomed nest": "毒害巢穴",
  "envenomed spikes": "剧毒尖刺",
  "envenomed spines": "淬毒骨刺",
  "epic arcadian war turtle": "史诗级阿坎迪安战龟",
  "epic arcane chaos lizard": "史诗魔法混沌蜥蜴",
  "epic arcane elemental lion": "史诗奥能元素雄狮",
  "epic azure elemental boar": "史诗碧蓝元素野猪",
  "epic azure elemental lion": "史诗碧蓝元素雄狮",
  "epic azure elemental stag": "史诗碧蓝元素驯鹿",
  "epic azure elemental wolf": "史诗碧蓝元素战狼",
  "epic battle raptor": "史诗战争迅猛龙",
  "epic carbon cybersteed carried": "史诗碳纤赛博战马（扛着）",
  "epic carbon cybersteed": "史诗碳纤赛博战马",
  "epic chaos lion": "史诗混沌雄狮",
  "epic chaos lizard": "史诗混沌蜥蜴",
  "epic chaos wolf": "史诗混沌狼",
  "epic cobalt technolope": "史诗级钴蓝科技战羊",
  "epic coral deepcrawler": "史诗珊瑚深渊爬行蟹",
  "epic crimson chaos wolf": "史诗猩红混沌狼",
  "epic deadly chaos lizard": "史诗致命混沌蜥蜴",
  "epic deadly chaos wolf": "史诗致命混沌狼",
  "epic deepcrawler": "史诗深渊爬行蟹",
  "epic dreambreaker grizzly": "史诗碎梦者灰熊",
  "epic earthbreaker grizzly": "史诗碎地者灰熊",
  "epic elemental boar": "史诗元素野猪",
  "epic elemental lion": "史诗元素雄狮",
  "epic elemental lizard": "史诗元素蜥蜴",
  "epic elemental stag": "史诗元素驯鹿",
  "epic elemental wolf": "史诗元素战狼",
  "epic furious epic wolf": "史诗暴怒混沌狼",
  "epic fusion technolope": "史诗级融合科技战羊",
  "epic golden chaos lion": "史诗金色混沌雄狮",
  "epic golden cybersteed carried": "史诗金色赛博战马（扛着）",
  "epic golden cybersteed": "史诗金色赛博战马",
  "epic hellfire direhorn": "史诗地狱火半岛恐角龙",
  "epic jade arcadian war turtle": "史诗级翡翠阿坎迪安战龟",
  "epic master cybersteed carried": "史诗士官赛博战马（扛着）",
  "epic master cybersteed": "史诗士官赛博战马",
  "epic mount": "史诗坐骑",
  "epic netherbreaker grizzly": "史诗碎空者灰熊",
  "epic primal direhorn": "史诗原始恐角龙",
  "epic reef deepcrawler": "史诗礁石深渊爬行蟹",
  "epic sandy arcadian war turtle": "史诗级沙地阿坎迪安战龟",
  "epic sholazar direhorn": "史诗索拉查恐角龙",
  "epic spectrum cybersteed carried": "史诗光谱赛博战马（扛着）",
  "epic spectrum cybersteed": "史诗光谱赛博战马",
  "epic technolope": "史诗级科技战羊",
  "epic titanium cybersteed carried": "史诗钛金赛博战马（扛着）",
  "epic titanium cybersteed": "史诗钛金赛博战马",
  "epic verdant elemental boar": "史诗翠绿元素野猪",
  "epic verdant elemental lion": "史诗翠绿元素雄狮",
  "epic verdant elemental stag": "史诗翠绿元素驯鹿",
  "epic verdant elemental wolf": "史诗翠绿元素战狼",
  "epicenter": "地震中心",
  "epiphany": "灵光悟",
  "eredar armor illidan": "艾瑞达护甲伊利丹",
  "erik the swift": "迅捷的埃瑞克",
  "essence claws": "精华之爪",
  "essence collection": "采集精华",
  "eternal dragon kharazim": "永恒龙卡拉辛姆",
  "eternal feast": "永恒盛宴",
  "eternal flames": "永恒烈焰",
  "eternal hunger": "无尽饥渴",
  "eternal retaliation": "无尽复仇",
  "eternal seraph wing": "永恒炽天使之翼",
  "eternal star lich kel thuzad": "永恒星辰巫妖克尔苏加德",
  "eternal star queen li ming": "永恒星辰女王李敏",
  "eternal star wraith mephisto": "永恒星际怨灵墨菲斯托",
  "ethereal existence": "虚幻之躯",
  "ethereal spirit healer auriel": "清虚灵魂医师奥莉尔",
  "evasion": "闪避",
  "evasive fire": "闪避射击",
  "evenhanded blessings": "公正祝福",
  "evergreen winter veil kharazim": "常青冬幕节卡拉辛姆",
  "everlasting light": "永续之光",
  "eviscerate": "刺骨",
  "evolution complete": "进化完成",
  "evolutionary link": "进化链条",
  "evolve monstrosity active": "进化畸兽激活中",
  "evolve monstrosity": "进化畸兽",
  "exalted road chariot": "尊贵双轮战车",
  "execute": "就地枪决",
  "executioner butcher": "刽子手屠夫",
  "executioner": "终结者",
  "executor scrapper queen qhira": "律法削铁女皇琪拉",
  "executor tassadar": "执行官塔萨达尔",
  "executor zeratul": "执行官泽拉图",
  "exiled crypt king tassadar": "放逐墓穴之王塔萨达尔",
  "exiled druid of the flame malfurion": "被放逐的烈焰德鲁伊玛法里奥",
  "exiled marshal varian": "流亡元帅瓦里安",
  "exiled zerg hunter zeratul": "流亡的异虫猎手泽拉图",
  "expedition vanndar muradin": "远征军范达尔穆拉丁",
  "expensive plating": "昂贵装甲",
  "experimental fenix": "实验型菲尼克斯",
  "explorer li li": "探险者丽丽",
  "explosive arrows": "爆破箭矢",
  "explosive attacks": "爆炸攻击",
  "explosive barrier": "爆炸屏障",
  "explosive round": "爆裂弹",
  "explosive rune": "爆炸符文",
  "expulsion zone": "喷涌区域",
  "extended care": "延长护理",
  "extended lightning": "延展闪电",
  "exterminator": "怪物猎手",
  "extra oomph": "炸上瘾",
  "extra tnt": "过量TNT",
  "extra wound timers": "加长引信",
  "exuberance": "精力旺盛",
  "eye of horus": "荷鲁斯之眼",
  "eye of kilrogg": "基尔罗格之眼",
  "eye of the tiger": "猛虎之眼",
  "eye of zuljin": "祖尔金之眼",
  "eye pad": "章鱼眼",
  "eyes in the dark": "黑暗中的眼睛",
  "eyes of the huntress": "女猎手之眼",
  "ez pz dimensional ripper": "EZ-PZ相位撕裂射线",
  "face melt": "热力四射",
  "face smelt": "热情难挡",
  "faerie protector": "守护小魔龙",
  "fallen junkrat": "堕落者狂鼠",
  "falling sword": "天罚之剑",
  "falstad": "弗斯塔德",
  "fan of knives": "刀扇",
  "fanatical power": "狂热之力",
  "fanaticism": "狂热信念",
  "fancy ringmaster greymane": "梦幻马戏团长格雷迈恩",
  "farflight quiver": "远行箭袋",
  "farseers blessing": "先知的赐福",
  "farstrider hanzo": "远行者半藏",
  "fast feet": "无影步",
  "fast forward": "快进",
  "fast reload": "快速装填",
  "fatal finesse": "致命灵巧",
  "fatal wounds": "致命创伤",
  "favor of the old gods": "上古之神的眷顾",
  "fealty unto death": "至死效忠",
  "fear the reaper": "惧怕夺魂者",
  "fearless qhira": "无畏者琪拉",
  "feast on fear": "狂啖恐惧",
  "feeding frenzy": "吞食狂热",
  "feel the heat": "感受热量",
  "feign death": "假死",
  "fel armor": "邪甲术",
  "fel betrayer illidan": "邪能背叛者伊利丹",
  "fel burning blade samuro": "邪能燃烧之刃萨穆罗",
  "fel butchers beast": "邪能屠夫蛮兽",
  "fel claws": "邪能之爪",
  "fel demonic tyrael": "邪能恶魔泰瑞尔",
  "fel druid of the flame malfurion": "邪能烈焰德鲁伊玛法里奥",
  "fel e t c": "邪能精英牛头人酋长",
  "fel flame": "邪焰",
  "fel infusion": "邪能灌注",
  "fel iron butcher": "魔铁屠夫",
  "fel iron chief engineer gazlowe": "魔铁首席工程师加兹鲁维",
  "fel pumpkin chogall": "邪能南瓜古加尔",
  "fel queen chromie": "邪能女王克罗米",
  "fel razorgrin": "邪能刀鳍鲨",
  "fel reaver blaze": "魔能机甲布雷泽",
  "fel reign deer": "邪能时空驯鹿",
  "fel sgt doomhammer": "邪能毁灭之锤军士",
  "fel sovereign kaelthas": "邪能帝王凯尔萨斯",
  "fel warlord chogall": "邪能督军古加尔",
  "felblade samuro": "魔刃萨穆罗",
  "felblood illidan": "魔血伊利丹",
  "felfuron uther": "邪能萨弗隆乌瑟尔",
  "felhammer thrall": "邪能之锤萨尔",
  "fell iron diablo": "堕落钢铁迪亚波罗",
  "fellboar": "凶猛野猪",
  "felsaber": "邪刃豹",
  "felstalker": "魔犬",
  "fend": "猛刺",
  "fenix": "菲尼克斯",
  "feral dehaka": "狂野德哈卡",
  "feral greymane": "野性格雷迈恩",
  "feral heart": "野性狼心",
  "feral resilience": "野性韧性",
  "feral spirit": "野性狼魂",
  "feral swarm abathur": "野生虫群阿巴瑟",
  "ferocious stalker": "凶狠猎手",
  "ferocity": "凶残",
  "fervent love goddess tyrande": "炽热爱神泰兰德",
  "festering butcherlisk": "溃烂屠夫雷兽",
  "festering wounds": "溃烂之伤",
  "festival mariachi e t c": "“节日玛利亚奇音乐牛”E.T.C.",
  "festive goblin": "欢乐地精",
  "festive greatfather winter stitches": "节日冬天爷爷缝合怪",
  "fetid touch": "腐臭之触",
  "fey dragon brightwing": "灵龙光明之翼",
  "field study": "实地研究",
  "fierce seraph wing": "暴烈炽天使之翼",
  "fiery brand": "烈火烙印",
  "fiery d va": "火神D.Va",
  "fiery paramedic morales": "火爆急救医师莫拉莉斯",
  "fight or flight": "可战可散",
  "fighting cheerleader kerrigan": "永不言败的啦啦队长凯瑞甘",
  "final curtain": "谢幕演出",
  "final cut": "斩断",
  "final strike": "最终斩击",
  "final toccata": "终焉狂想曲",
  "fingers of frost": "寒冰指",
  "finishing touch": "猛攻要害",
  "fire batty murky": "火蝠奔波尔霸",
  "fire genji": "火焰源氏",
  "fire lunar dragon": "火焰春节祥龙",
  "fire lunar illidan": "火焰春节伊利丹",
  "fire medivh": "火焰麦迪文",
  "fire raider rexxar": "火焰游骑兵雷克萨",
  "fire stomp": "火焰践踏",
  "fire ward": "防护火焰结界",
  "fire within": "火焰反哺",
  "fire": "火焰之灵",
  "fireflies": "萤火虫",
  "fires of hell": "地狱烈焰",
  "firestarter": "纵火者",
  "firestorm blaze": "烈焰风暴布雷泽",
  "firin mah lazorz": "同步射线",
  "first ascendant li ming": "升格第一人李敏",
  "first dragon genji": "初代神龙源氏",
  "first lt morales": "莫拉莉斯上尉",
  "first responder": "急救队",
  "first war guldan": "一战古尔丹",
  "fish eye": "鱼眼",
  "fish oil": "鱼油",
  "fish tank": "鱼缸",
  "fishing hook": "鱼钩",
  "fission bomb": "炽热炸弹",
  "flail axe": "连枷斧",
  "flailing swipe": "横扫猛击",
  "flame buffet": "烈焰打击",
  "flame dragon kharazim": "烈焰龙卡拉辛姆",
  "flame stream": "火焰喷流",
  "flame sulfuron ragnaros": "烈焰萨弗隆拉格纳罗斯",
  "flame warmaster chen": "烈焰战争大师陈",
  "flames of fury": "愤怒烈焰",
  "flames of judgment charger carried": "审判战马之焰（扛着）",
  "flames of judgment charger": "审判战马之焰",
  "flames of sulfuron": "萨弗隆烈焰",
  "flames of wrath": "狂怒烈火",
  "flamestrike": "烈焰风暴",
  "flamethrower": "火焰喷射",
  "flare": "照明弹",
  "flash fire": "急速燃烧",
  "flash heal": "快速治疗",
  "flash of anger": "怒火闪耀",
  "flash of light": "圣光闪现",
  "flawless technique": "技艺精湛",
  "fleet of foot": "健步如飞",
  "flesh frost wyrm arthas": "血肉冰霜巨龙阿尔萨斯",
  "flight": "飞行",
  "flirty cloud": "风骚云",
  "floral champion lunara": "鲜花勇士露娜拉",
  "flow like water": "行如流水",
  "flow rider": "气流骑士",
  "flying kick": "飞天脚",
  "flying leap": "冲天脚",
  "flying monkey brightwing": "飞猿光明之翼",
  "focus fire": "集中火力",
  "focus turrets": "炮台集火！",
  "focused beam": "聚焦光线",
  "focusing diodes": "聚焦二极管",
  "follow through": "一鼓作气",
  "force armor": "原力护甲",
  "force barrier": "力场壁垒",
  "force of magic": "魔法之力",
  "force of will": "意志之力",
  "force wall cancel": "力场屏障取消",
  "force wall": "力场屏障",
  "forest kaelthas": "森林凯尔萨斯",
  "forest lumberjack uther": "森林伐木工乌瑟尔",
  "forest medicine": "森林药剂",
  "forests wrath": "森林之怒",
  "forgotten dark nexus alarak": "遗忘的黑暗时空阿拉纳克",
  "forgotten spider warden maiev": "遗忘蜘蛛守望者玛维",
  "forgotten witch whitemane": "遗忘女巫怀特迈恩",
  "fortified bunker": "加固地堡",
  "fortifying brew": "壮胆酒",
  "fortitude of the faithful": "信仰弥坚",
  "frag grenade": "破片手雷",
  "frag launcher": "榴弹发射器",
  "free drinks": "免费饮料",
  "frenzied assault": "狂乱攻击",
  "frenzied fists": "狂暴之拳",
  "frenzy of kalimdor": "卡利姆多的狂野",
  "frenzy": "狂暴",
  "fresh meat": "新鲜的肉",
  "freshest ingredients": "新鲜原料",
  "friend or foe": "敌我不分",
  "fright": "恐煞横行",
  "frost armor": "霜甲术",
  "frost blast": "冰星爆",
  "frost emberlord zuljin": "冰霜灰烬领主祖尔金",
  "frost lunara": "冰霜露娜拉",
  "frost nova": "冰霜新星",
  "frost presence": "冰霜灵气",
  "frost shards": "寒冰碎片",
  "frost shot": "冰霜射击",
  "frost star lich kel thuzad": "冰霜之星巫妖克尔苏加德",
  "frost storm lord falstad": "冰霜风暴之王弗斯塔德",
  "frost storm": "冰霜风暴",
  "frost strike": "冰霜打击",
  "frost sylvanas": "冰霜希尔瓦娜斯",
  "frost wyrm arthas": "冰霜巨龙阿尔萨斯",
  "frost xul": "冰霜祖尔",
  "frostbite": "霜寒",
  "frostbolt": "寒冰箭",
  "frostborn falstad": "霜脉弗斯塔德",
  "frostborn magni muradin": "霜脉麦格尼穆拉丁",
  "frosted gingerboard": "加冰姜饼飞板",
  "frosted kandy king muradin": "糖霜王穆拉丁",
  "frostlord rexxar": "冰霜领主雷克萨",
  "frostmane zuljin": "霜鬓祖尔金",
  "frostmourne feeds": "霜之哀伤的盛宴",
  "frostmourne hungers primed": "霜之哀伤的饥渴已激活",
  "frostmourne hungers": "霜之哀伤的饥渴",
  "frostwolf johanna": "霜狼乔汉娜",
  "frostwolf pack": "冰霜狼群",
  "frostwolf resilience": "霜狼韧性",
  "frostwolf warlord garrosh": "霜狼督军加尔鲁什",
  "frostwolfs grace": "霜狼之赐",
  "frosty brewmaster chen": "冰霜酒仙陈",
  "frozen anubarak": "冰冻阿努巴拉克",
  "frozen crimson hare carried": "冰冻赤兔（扛着）",
  "frozen crimson hare": "冰冻赤兔",
  "frozen grave warden malthael": "冰霜镇墓者马萨伊尔",
  "frozen great father winter rehgar": "冰冻冬天爷爷雷加尔",
  "frozen mad axe garrosh": "冰霜疯狂艾克斯加尔鲁什",
  "frozen mystic kingdoms arthas": "冰冻武圣阿尔萨斯",
  "frozen overqueen zagara": "冰冻女王扎加拉",
  "frozen road boar": "冰霜霸路猪",
  "frozen tempest": "寒冰风暴",
  "frozen valorous sonya": "冰冻勇猛桑娅",
  "frozen wastes": "冰冻废土",
  "frozen winter veil kharazim": "冰霜冬幕节卡拉辛姆",
  "fruitcake gingerdread nazeebo": "水果蛋糕姜饼怪人纳兹波",
  "fuchsia bikini stitches": "洋红比基尼缝合怪",
  "fuchsia valla": "紫红维拉",
  "fuchsia wrath sonya": "桃红愤怒套装桑娅",
  "fuel for the flame": "烈焰能量",
  "fuel leak": "燃油泄漏",
  "fuel the rush": "激发冲动",
  "fueled by torment": "痛感治愈",
  "funny bunny murky": "搞笑兔奔波尔霸",
  "furious black metal e t c": "狂怒黑色金属精英牛头人酋长",
  "furious blow": "狂暴打击",
  "furious chaos wolf": "暴怒混沌狼",
  "furious spark": "狂怒火花",
  "furnace blast": "焚炉冲击",
  "fury of the storm": "风暴之怒",
  "fury of the sunwell": "太阳井之怒",
  "fury of the swarm": "虫群之怒",
  "fury": "狂怒",
  "fusion generator": "聚变充能",
  "fusion technolope": "融合科技战羊",
  "fuzzy plush unicorn": "毛绒独角兽绒绒",
  "gain train": "获得训练",
  "galactic empress whitemane": "银河女皇怀特迈恩",
  "galactic xenotech abathur": "星河异度机甲阿巴瑟",
  "gale force": "狂风之力",
  "gall": "加尔",
  "galloping gait": "轻盈疾步",
  "gamma xenotech malthael": "伽马异度机甲马萨伊尔",
  "garden of terror": "恐魔园",
  "garden shambler murky": "恐波尔霸",
  "gargantuan stomp": "僵尸巨兽践踏",
  "gargantuan": "僵尸巨兽",
  "garnet executor tassadar": "石榴石执行官塔萨达尔",
  "garnet heart stone": "石榴石爱心之石",
  "garrosh": "加尔鲁什",
  "garrote": "锁喉",
  "gas flare": "胆汁飞溅",
  "gate keeper": "折跃门卫士",
  "gather minerals": "采集晶体矿",
  "gathering storm": "风暴聚集",
  "gazlowe": "加兹鲁维",
  "geist knight zarya": "鬼魅骑士查莉娅",
  "genius monkey king samuro": "天才猴王萨穆罗",
  "genji": "源氏",
  "get stuffed": "吃我一拳！",
  "get through this": "打爆这个试试！",
  "gg wp": "GG, WP",
  "ghastly armor": "邪魔护甲",
  "ghastly reach": "苍白之触",
  "ghastly swing": "苍白重击",
  "ghost admiral krakenov": "幽灵上将海怪诺夫",
  "ghost illidan": "幽灵伊利丹",
  "ghost protocol": "幽灵协议",
  "ghost speeder": "幽灵穿梭者",
  "ghost tracer": "幽灵“猎空”",
  "ghost wolf deactivate": "取消幽魂之狼形态",
  "ghost wolf": "幽魂之狼",
  "ghostlands ranger general sylvanas": "幽魂之地游侠将军希尔瓦娜斯",
  "ghostly helldorado": "幽灵地狱狂驹",
  "ghostly roadraider raynor": "幽灵巡游侠雷诺",
  "giant killer": "巨人克星",
  "giant scorcher": "巨人天敌",
  "giant slammer": "巨人煞星",
  "giant slayer": "巨人杀手",
  "giddy up": "得儿驾",
  "gift of life": "生命赐福",
  "gift of the naaru": "纳鲁的赐福",
  "gift of the ox": "玄牛之赐",
  "gift of the xel naga": "萨尔纳加之赐",
  "gilnean cocktail": "吉尔尼斯鸡尾酒",
  "gilnean roulette": "吉尔尼斯轮盘",
  "gingerboard": "姜饼飞板",
  "gingerdread nazeebo": "姜饼怪人纳兹波",
  "give em some pepper": "教他做人",
  "give em the axe": "吃我一斧",
  "give me more": "激素爆发",
  "give me twenty": "二十个俯卧撑",
  "glacial spike": "冰川尖刺",
  "gladiator rehgar": "角斗士雷加尔",
  "gladiators war shout": "角斗士的战吼",
  "glam metal e t c": "万人迷精英牛头人酋长",
  "glass cannon": "玻璃大炮",
  "glimmer of hope": "闪烁希望",
  "glitch steed carried": "紫电（扛着）",
  "glitch steed": "紫电",
  "global pro d va": "全球职业选手D.Va",
  "globe of annihilation": "湮灭之球",
  "gloom": "黑影",
  "glorious 2017 championship banner": "辉煌2017冠军旗帜",
  "glorious archangel auriel": "光辉大天使奥莉尔",
  "glorious garrosh": "光辉加尔鲁什",
  "glory to the alliance": "荣耀属于联盟",
  "gluttony": "暴食",
  "glyph of faith": "信仰雕文",
  "glyph of poly bomb": "变形炸弹雕文",
  "gnome speed ahead": "进击的侏儒",
  "go for the throat": "直取要害",
  "go go go": "冲冲冲",
  "goblin fusion": "地精聚变",
  "goblin repairs": "地精修理",
  "god king leoric": "神王李奥瑞克",
  "gold black metal e t c": "金色黑色金属精英牛头人酋长",
  "gold storm punk kaelthas": "金色朋克凯尔萨斯",
  "golden 2017 championship banner": "金色2017冠军旗帜",
  "golden chaos lion": "金色混沌雄狮",
  "golden crypt king tassadar": "金色墓穴之王塔萨达尔",
  "golden cyber wolf": "金色科幻战狼",
  "golden cyberdemon zarya": "黄金赛博恶鬼查莉娅",
  "golden cybersteed carried": "金色赛博战马（扛着）",
  "golden cybersteed": "金色赛博战马",
  "golden fel queen chromie": "金色邪能女王克罗米",
  "golden genji": "黄金源氏",
  "golden highlord alarak": "金色高阶领主阿拉纳克",
  "golden lunar guardian": "黄金来福",
  "golden lunar rooster": "黄金春节公鸡",
  "golden lunar skyrocket": "黄金春节爆竹",
  "golden mephisto": "黄金墨菲斯托",
  "golden monkey king samuro": "金色猴王萨穆罗",
  "golden necromaster xul": "金色死灵大师祖尔",
  "golden nexus charger carried": "黄金战马（扛着）",
  "golden nexus charger": "黄金战马",
  "golden orochi hovercycle": "金色“大蛇”悬浮摩托",
  "golden patriarch kharazim": "金色尊者卡拉辛姆",
  "golden roller derby nova": "金色轮滑女孩诺娃",
  "golden tiger": "黄金丛林虎",
  "golden treasure goblin": "黄金盗宝地精",
  "golden unraveler zeratul": "黄金剖尸者泽拉图",
  "goldenside dire wolf": "金色恐狼",
  "goliath d va": "歌利亚D.Va",
  "good vibrations": "良性振动",
  "gorge": "暴食",
  "gotta trap em all": "全都夹住！",
  "grace of air": "风之优雅",
  "graduating range": "射程调节",
  "grand commandant varian": "大指挥官瓦里安",
  "grand marshal uther": "大元帅乌瑟尔",
  "grand marshal varian": "大元帅瓦里安",
  "grand slam": "裂地震击",
  "grappling hook": "抓钩",
  "grassy deputy valla": "草绿副警长维拉",
  "grav o bomb 3000": "3000型引力炸弹",
  "grave warden malthael": "镇墓者马萨伊尔",
  "gravitic thrusters": "引力推进器",
  "graviton surge": "重力喷涌",
  "graviton vortex": "重力漩涡",
  "gravity kills": "致命重力",
  "gravity lapse": "引力失效",
  "gravity well": "重力井",
  "gray warden lunara": "灰色守望者露娜拉",
  "grease gazlowe": "油污加兹鲁维",
  "great father winter rehgar": "冬天爷爷雷加尔",
  "great razorgrin": "刀鳍鲨",
  "greater cleave": "强化顺劈斩",
  "greater polymorph": "强效变形术",
  "greater spell shield": "大型法术护盾",
  "greatfather winter malfurion": "冬天爷爷玛法里奥",
  "greatfather winter stitches": "冬天爷爷缝合怪",
  "greed": "贪婪",
  "green eagle eye tyrande": "绿色鹰眼泰兰德",
  "green treasure goblin": "绿色盗宝地精",
  "grenadier": "掷弹兵",
  "grendel butcherlisk": "格伦德尔屠夫雷兽",
  "grey horse carried": "灰色马（扛着）",
  "grey horse": "灰色马",
  "grey raynor": "灰色雷诺",
  "greymane": "格雷迈恩",
  "grievous throw": "重伤投掷",
  "grill and kill": "现杀现烤",
  "grim phantom stallion carried": "冷酷幽灵马 (扛着)",
  "grim phantom stallion": "冷酷幽灵马",
  "grim scythe": "酷刑镰刀",
  "grimskull nazeebo": "恐惧之颅纳兹波",
  "grizzled fortitude": "巨熊坚韧",
  "groundbreaker": "裂地重斧",
  "grounded totem": "根基图腾",
  "grounding bolt": "定身雷矢",
  "growing infestation": "感染增生",
  "growing nightmare": "噩梦滋蔓",
  "grunty murky": "枪兵奔波尔霸",
  "gryphon master falstad": "狮鹫大师弗斯塔德",
  "guardian of ancient kings": "远古列王守卫",
  "guardian of tirisfal": "提瑞斯法守护者",
  "guardian seraph wing": "守护炽天使之翼",
  "guardian stars and stripes raynor": "守护者星条旗雷诺",
  "guardian toads": "守卫蟾蜍",
  "guiding light": "引路之光",
  "guillotine": "断头斧",
  "guitar hero": "吉他英雄",
  "guitar solo": "吉他独奏",
  "guldan": "古尔丹",
  "hallowed broom": "神圣扫帚",
  "hallowed ground": "高圣之地",
  "hallowed orphea": "神圣奥菲娅",
  "hallowed seasons reapings malthael": "神圣礼物收割者马萨伊尔",
  "hammer gains": "强化蛮锤",
  "hammer of justice": "制裁之锤",
  "hammer of the lightbringer": "光明使者之锤",
  "hammer of twilight": "暮光神锤",
  "hammer on": "上半音",
  "hammerang": "回旋锤",
  "hamstring": "断筋打击",
  "hanamura temple": "花村寺",
  "hand of freedom": "自由之手",
  "hand of protection": "保护之手",
  "hand of ragnaros": "拉格纳罗斯之手",
  "hanzo": "半藏",
  "happy birthday billie": "生日快乐比利",
  "happy cloud": "欢乐云",
  "harden carapace": "硬化甲壳",
  "hardened bones": "硬化骨骼",
  "hardened shield": "刚毅护盾",
  "hardened skin": "硬化皮肤",
  "hardened street cyborg kharazim": "硬化街头改造人卡拉辛姆",
  "harlequin nazeebo": "小丑纳兹波",
  "harsh discipline": "严酷鞭刑",
  "harsh moonlight": "苛烈月光",
  "harsh winds": "疾风",
  "harvest champion lunara": "丰收冠军露娜拉",
  "harvest harlequin nazeebo": "丰收小丑纳兹波",
  "harvest life": "生命收割",
  "harvest lunar tiger": "丰收月光虎",
  "harvest vitality": "吸收活力",
  "hasty bargain": "迅捷契约",
  "hateful mending": "怨毒治疗",
  "hatred": "憎恨",
  "haunt": "鬼影缠身",
  "haunted creepie chromie": "闹鬼骷髅脸克罗米",
  "haunted mines": "鬼灵矿",
  "haunted raven runner": "鬼灵陆行鸦",
  "haunting teleport": "索命传送",
  "haunting wave": "索命妖魂",
  "haymaker": "野蛮斗殴",
  "hazard goliath d va": "废土歌利亚D.Va",
  "hazardous blaze": "生化奇兵布雷泽",
  "hazardous doctor wolf stein": "危化沃尔夫博士与斯坦",
  "hazardous viper dominator": "废尘蝰蛇陆霸",
  "hazardus vile azmodan": "恶毒灾星阿兹莫丹",
  "head chef stitches": "主厨缝合怪",
  "headhunter": "猎头者",
  "headless horsemans charger carried": "无头骑士的战马（扛着）",
  "headless horsemans charger": "无头骑士的战马",
  "healer": "治疗者",
  "healing beam": "治疗射线",
  "healing brew": "治愈佳酿",
  "healing dart": "治疗镖",
  "healing pathogen": "医疗病原体",
  "healing potion": "治疗药水",
  "healing static": "静电恢复",
  "healing totem": "治疗图腾",
  "healmonger": "投机治疗",
  "health funnel": "生命通道",
  "healthstone": "治疗石",
  "heart stone": "爱心之石",
  "heartbreaker cheerleader kerrigan": "令人心碎的啦啦队长凯瑞甘",
  "hearthstone card": "炉石卡牌",
  "hearthstone": "炉石",
  "hearty love bug anubarak": "爱心爱虫阿努巴拉克",
  "hearty wonder billie": "爱心神奇比利",
  "heat exhaustion": "热力衰竭",
  "heat of battle": "越战越勇",
  "heat treatment": "高温疗法",
  "heatwave bikini stitches": "热浪比基尼缝合怪",
  "heatwave slip n stream tracer": "热浪水枪“猎空”",
  "heavenly grunty murky": "天堂枪兵奔波尔霸",
  "heavenly host": "天使军团",
  "heavenly lunar illidan": "天堂春节伊利丹",
  "heavenly lunar kaelthas": "福临春节凯尔萨斯",
  "heavenly lunar li ming": "福临春节李敏",
  "heavenly zeal": "回天狂热",
  "heavens fury": "天堂之怒",
  "heavy burden": "寸步难行",
  "heavy casters": "重型脚轮",
  "heavy impact": "猛烈撞击",
  "heavy slugs": "重型独头弹",
  "hell billie": "地狱比利",
  "hell iron diablo": "地狱钢铁迪亚波罗",
  "hell rift": "地狱裂隙",
  "hellblade samuro": "地狱之刃萨穆罗",
  "hellboar": "地狱野猪",
  "helldorado": "地狱狂驹",
  "hellfire direhorn": "地狱火半岛恐角龙",
  "hellfire": "地狱火",
  "hellflame nazeebo": "地狱火纳兹波",
  "hellforged armor": "熔炉战甲",
  "hellgate": "地狱之门",
  "hellhammer thrall": "地狱之锤萨尔",
  "hellish fallen junkrat": "魔性堕落者狂鼠",
  "hells screamer diablo": "“地狱吼”迪亚波罗",
  "hells screamer luchihuahua": "地狱吼露奇花花",
  "hells screamer pignata": "地狱吼皮纳塔小猪",
  "hellstorm": "地狱风暴",
  "hellwarden maiev": "地狱刑官玛维",
  "helping hand": "援手屠钩",
  "hemorrhage": "出血",
  "herald of n zoth alarak": "恩佐斯的传令官阿拉纳克",
  "here and there": "身影交错",
  "hero stalker": "英雄猎手",
  "heroic balespider guldan": "英雄邪蛛古尔丹",
  "heroic difficulty": "英雄难度",
  "heroic sequel lost vikings": "英雄续作失落的维京人",
  "heroic strike": "英勇打击",
  "hexed crawlers": "妖术蜘蛛",
  "hexplug diesel speaker nazeebo": "六角塞头柴油爆音王纳兹波",
  "hibiscus shambler murky": "木槿恐波尔霸",
  "hierarch artanis": "大主教阿塔尼斯",
  "high elf tyrande": "高等精灵泰兰德",
  "high five": "击掌",
  "high gravity zarya": "超强重力查莉娅",
  "high inquisitor": "大审讯官",
  "high king magni muradin": "至高王麦格尼穆拉丁",
  "high kings quest": "至高王的任务",
  "high powered round": "高功率子弹",
  "high priestess tyrande": "高阶祭司泰兰德",
  "high templar zeratul": "高阶圣堂武士泽拉图",
  "high warlord garrosh": "高阶督军加尔鲁什",
  "highlord alarak": "高阶领主阿拉纳克",
  "highlords ascent": "高阶领主的升格",
  "highmaul chogall": "悬槌堡古加尔",
  "hindered motion": "妨害移动",
  "hindering moonfire": "妨害月火",
  "hindering winds": "妨害之风",
  "hinterland blast": "辛特兰雷击",
  "hippity hop": "蹦蹦跳跳",
  "hippityhop ribbit lucio": "嘻哈宇宙蛙卢西奥",
  "hired goons": "佣兵打手",
  "hit me": "见招拆招",
  "hit the nitrous": "氮气加速",
  "hive master": "吸血暴蝗",
  "hivemind": "主巢心智",
  "hoarfrost road chariot": "霜白双轮战车",
  "hold your ground": "坚守阵地",
  "hollow mephisto": "中空墨菲斯托",
  "hollow unraveler zeratul": "空壳剖尸者泽拉图",
  "holo decoy": "全息诱饵",
  "holo stability": "稳定全息",
  "holy arena": "神圣竞技场",
  "holy avenger": "神圣复仇者",
  "holy farstrider hanzo": "神圣远行者半藏",
  "holy fervor": "神圣狂热",
  "holy fire": "神圣之火",
  "holy fury": "神圣愤怒",
  "holy ground": "神圣之地",
  "holy light": "圣光术",
  "holy nova": "神圣新星",
  "holy radiance": "圣光普照",
  "holy reach": "神圣延伸",
  "holy renewal": "神圣恢复",
  "holy seraph wing": "神圣炽天使之翼",
  "holy shock": "神圣震击",
  "holy spellbreaker johanna": "神圣破法者乔汉娜",
  "holy word salvation": "圣言术：赎",
  "holy wrath": "神圣愤怒",
  "honey bear stitches": "宝贝熊缝合怪",
  "honey plush unicorn": "蜜糖毛绒僵尸独角兽",
  "honored lunar cassia": "荣耀春节卡西娅",
  "hook": "屠钩",
  "hopelessness": "求生无望",
  "horadric cube": "赫拉迪姆方块",
  "horadric reforging": "赫拉迪姆重铸",
  "horadric staff": "赫拉迪姆法杖",
  "horde axe garrosh": "部落巨斧加尔鲁什",
  "horde dire wolf": "部落恐狼",
  "horde l 800 e t c": "部落800级精英牛头人酋长",
  "horde reign deer": "部落时空驯鹿",
  "horde road boar": "部落霸路猪",
  "hordewarden maiev": "部落刑官玛维",
  "horrific prime evil diablo": "惊悚大魔神迪亚波罗",
  "horrify": "地狱嚎叫",
  "horse carried": "马（扛着）",
  "horse": "马",
  "hot pursuit": "狂热迫袭",
  "hot rod turbo tracer": "飞车手极速“猎空”",
  "hour of twilight": "暮光审判",
  "house party": "家庭派对",
  "hover siege mode": "悬浮攻城模式",
  "howling blast": "凛风冲击",
  "humongoid": "尸魔巨怪",
  "hunger for power": "力量渴求",
  "hunger of the wolf": "饿狼",
  "hungering arrow": "追踪箭",
  "hungering cold": "饥饿之寒",
  "hungry bear": "饥饿巨熊",
  "hungry for more": "饿了还要",
  "hungry hungry stitches": "饥饿缝合怪",
  "hunka burning olaf": "炽热燃烧的奥拉夫",
  "hunter felsaber": "猎手邪刃豹",
  "hunter first lt morales": "猎手莫拉莉斯上尉",
  "hunter gatherer": "野外生存",
  "hunter greymane": "猎手格雷迈恩",
  "hunter killer": "屠猎者",
  "hunter mecha dehaka": "猎手机甲德哈卡",
  "hunter pack leader dehaka": "猎手虫群首领德哈卡",
  "hunter space lord leoric": "猎手太空王李奥瑞克",
  "hunter space lords starbreaker": "猎手太空王的歼星者号",
  "hunter star lich kel thuzad": "猎手之星巫妖克尔苏加德",
  "hunters blunderbuss": "猎人短炮",
  "hunters mark": "猎人印记",
  "hunters onslaught": "猎手猛击",
  "huntress fury": "女猎手之怒",
  "hurricane": "飓风",
  "hush": "嘘！",
  "hydralisk transfusion": "刺蛇哺液",
  "hyper cooling engines": "超冷却引擎",
  "hyper shift": "超级变换",
  "hyper slip n stream tracer": "高压水枪“猎空”",
  "hyper turbo tracer": "超级极速“猎空”",
  "hyperactivity": "肌能亢奋",
  "hyperfocus coils": "超焦线圈",
  "hyperion": "休伯利安号",
  "hysteria": "丧心病狂",
  "i am the strongest": "我最强壮",
  "ice barrier": "寒冰护体",
  "ice blink": "冰霜闪现",
  "ice block": "寒冰屏障",
  "ice cold": "极冰之寒",
  "ice floes": "浮冰术",
  "ice lance": "冰枪术",
  "ice queen alexstrasza": "冰雪女王阿莱克丝塔萨",
  "ice storm mantle malfurion": "寒冰怒风肩甲玛法里奥",
  "iceblade arrows": "冰刃箭矢",
  "icebound farstrider hanzo": "冰缚远行者半藏",
  "icebound fortitude": "冰封之韧",
  "iceforged reign deer": "冰铸时空驯鹿",
  "icefury wand": "冰怒魔杖",
  "icewind winters helper valla": "冰风冬天爷爷的助手维拉",
  "icy grasp": "寒冰之握",
  "icy greatfather winter malfurion": "冰雪冬天爷爷玛法里奥",
  "icy talons": "冰冷之爪",
  "icy veins": "冰冷血脉",
  "ignite": "点燃",
  "ignore all distractions": "心无旁骛",
  "ignore pain": "无视苦痛",
  "illidan": "伊利丹",
  "illidans nightmare carried": "伊利丹的梦魇（扛着）",
  "illidans nightmare": "伊利丹的梦魇",
  "illusion master": "幻象大师",
  "illusionist": "幻术师",
  "image transmission": "镜像转移",
  "immolation": "献祭",
  "immortal coil": "不朽缠绕",
  "immortal space lord leoric": "不朽太空王李奥瑞克",
  "impale": "穿刺",
  "impaling blades": "穿刺之刃",
  "impaling light": "穿刺之光",
  "impatience is a virtue": "急性子是一种美德",
  "imperator stukov": "斯托科夫大帝",
  "imperial lunar li ming": "帝国春节李敏",
  "imperius": "英普瑞斯",
  "impervious": "不动如山",
  "imposing presence": "盛气凌人",
  "imprisoning light": "禁锢之光",
  "improved ice block": "强化寒冰屏障",
  "improved life tap": "强化生命分流",
  "in for the kill": "杀心骤起",
  "in the rhythm": "节奏步伐",
  "incendiary elixir": "易燃药剂",
  "incinerator gauntlets": "焚烧臂铠",
  "increasing clarity": "明澈之势",
  "indestructible": "坚不可摧",
  "indigo cyberdemon zarya": "靛蓝赛博恶鬼查莉娅",
  "indigo executor tassadar": "靛蓝执行官塔萨达尔",
  "indigo li ming": "靛蓝李敏",
  "indomitable imperius": "不屈者英普瑞斯",
  "indomitable resolve": "坚定决心",
  "indomitable": "无人敢挡",
  "indulgence": "沉溺刑欲",
  "industrial zarya": "重工查莉娅",
  "inevitable end": "在劫难逃",
  "infernal archon li ming": "地狱御法者李敏",
  "infernal demonic tyrael": "炼狱恶魔泰瑞尔",
  "infernal fel reaver blaze": "狱火魔能机甲布雷泽",
  "infernal knight zarya": "炼狱骑士查莉娅",
  "infernal mal ganis": "地狱火玛尔加尼斯",
  "infernal shrine": "炼狱圣坛",
  "infernal sulfuron ragnaros": "炼狱萨弗隆拉格纳罗斯",
  "infernal wyrm alexstrasza": "炼狱魔龙阿莱克丝塔萨",
  "inferno doctor wolf stein": "狱火沃尔夫博士与斯坦",
  "infest": "感染",
  "infested azmodan": "被感染的阿兹莫丹",
  "infested drop": "异化空投",
  "infested tychus": "被感染的泰凯斯",
  "infiltrator deckard pain": "渗透者迪卡德·佩恩",
  "infiltrator mecha dehaka": "渗透者机甲德哈卡",
  "infinite lightning": "无限闪电",
  "inhibiting energy": "拘束能量",
  "initiative": "先发制人",
  "inky landwalker murky": "墨黑陆地行者奔波尔霸",
  "inner beast": "野兽之力",
  "inner fire": "心灵之火",
  "inner focus": "心灵专注",
  "inner light": "内视之光",
  "inner rage": "怒火中烧",
  "innervate": "激活",
  "innocent creepie chromie": "天真骷髅脸克罗米",
  "inquisition cancel": "血色审讯（取消）",
  "inquisition": "血色审讯",
  "insatiable blade": "嗜血狂刀",
  "insatiable": "大胃魔",
  "insectoid zagara": "昆虫形态扎加拉",
  "insight": "悟性",
  "inspire": "激励",
  "intensifying toxin": "毒素增强",
  "intensive winds": "狂风频频",
  "intercession": "代祷",
  "interference": "干扰",
  "intimidation": "实力震慑",
  "into the fray": "盟友抛投",
  "invasive miasma": "恶瘴迸发",
  "invigorating spores": "活力孢子",
  "invigoration": "精力充沛",
  "invisible friends": "看不见的朋友",
  "invisible horse carried": "隐形马（扛着）",
  "invisible horse": "隐形马",
  "ionic force field": "离子力场",
  "iridescent love bug anubarak": "斑斓爱虫阿努巴拉克",
  "iridescent queen alexstrasza": "墨绿女王阿莱克丝塔萨",
  "iron butcher": "钢铁屠夫",
  "iron dragon genji": "钢铁神龙源氏",
  "iron farstrider hanzo": "钢铁远行者半藏",
  "iron fists": "铁拳",
  "iron skin": "钢铁之肤",
  "iron spellbreaker johanna": "钢铁破法者乔汉娜",
  "iron timewalker chromie": "钢铁时光旅行者克罗米",
  "iron valorous sonya": "钢铁勇猛桑娅",
  "iron varian": "钢铁瓦里安",
  "ironclaw rehgar": "铁爪雷加尔",
  "ironforge falstad": "铁炉堡弗斯塔德",
  "ironheart vanndar muradin": "钢铁之心范达尔穆拉丁",
  "ironside dire wolf": "铁甲恐狼",
  "is that a health pack": "那是急救包吗？",
  "isolation": "隔离",
  "it hungers": "它饿了",
  "its a sabotage": "恶意破坏",
  "its raining scrap": "天降碎片",
  "ivory 2015 champions nexagon": "象牙2015世锦赛冠军飞碟",
  "ivory alarak": "象牙阿拉纳克",
  "ivory apothecary morales": "象牙药剂师莫拉莉斯",
  "ivory cyber oni butcher": "象牙鬼械屠夫",
  "ivory cyber oni warboar": "象牙鬼械战猪",
  "ivory demon hunter valeera": "象牙恶魔猎手瓦莉拉",
  "ivory great father winter rehgar": "象牙冬天爷爷雷加尔",
  "ivory greatfather winter stitches": "象牙冬天爷爷缝合怪",
  "ivory johanna": "象牙乔汉娜",
  "ivory kaelthas": "象牙凯尔萨斯",
  "ivory leoric": "象牙李奥瑞克",
  "ivory lo gosh varian": "象牙洛戈什瓦里安",
  "ivory maiev": "象牙玛维",
  "ivory special snowflake": "象牙特殊雪花",
  "ivory speed demon lucio": "象牙飚速恶鬼卢西奥",
  "ivory tyrael": "象牙泰瑞尔",
  "ivory tyraels charger carried": "象牙泰瑞尔的天使战马（扛着）",
  "ivory tyraels charger": "象牙泰瑞尔的天使战马",
  "ivory vampire slayer valla": "象牙吸血鬼杀手维拉 ",
  "ivy winters helper valla": "蓝藤冬天爷爷的助手维拉",
  "jack o phantom stallion carried": "南瓜灯幽灵马 (扛着)",
  "jack o phantom stallion": "南瓜灯幽灵马",
  "jade alexstrasza": "碧玉阿莱克丝塔萨",
  "jade arcadian war turtle": "翡翠阿坎迪安战龟",
  "jade chen": "翡翠老陈",
  "jade cyber oni warboar": "翡翠鬼械战猪",
  "jade dragon kharazim": "青龙卡拉辛姆",
  "jade hierarch artanis": "翡翠大主教阿塔尼斯",
  "jade li li": "翡翠丽丽",
  "jade lunar cassia": "青玉春节卡西娅",
  "jade lunar guardian": "青玉来福",
  "jade lunar jaina": "青玉春节吉安娜",
  "jade lunar kaelthas": "青玉春节凯尔萨斯",
  "jade lunar li ming": "青玉春节李敏",
  "jade lunar skyrocket": "青玉春节爆竹",
  "jade lunar sylvanas": "青玉春节希尔瓦娜斯",
  "jade lunar zuljin": "青玉春节祖尔金",
  "jade monkey king samuro": "翡翠猴王萨穆罗",
  "jade nimbus cloud": "翡翠筋斗云",
  "jade nova": "翡翠诺娃",
  "jade qhira": "青玉琪拉",
  "jade techno vandal chromie": "青玉科技颠覆者克罗米",
  "jailbird tychus": "恶棍泰凯斯",
  "jailors": "狱卒",
  "jaina": "吉安娜",
  "janitor leoric": "清洁工李奥瑞克",
  "jasper frostlord rexxar": "碧玉冰霜领主雷克萨",
  "jet propulsion": "喷射推进",
  "jigoku cyber oni butcher": "地狱鬼械屠夫",
  "jigoku cyber oni warboar": "地狱鬼械战猪",
  "jigoku speed demon lucio": "地狱飚速恶鬼卢西奥",
  "johanna": "乔汉娜",
  "judgment charger carried": "审判战马（扛着）",
  "judgment charger": "审判战马",
  "judgment day": "审判日",
  "judgment uther": "审判套装乌瑟尔",
  "judgment": "审判",
  "jug of 1 000 000 cups": "万杯不醉",
  "jug of 1 000 cups": "千杯不倒",
  "juggernaut plating": "铁人装甲",
  "juggernaut": "主宰",
  "jump": "维京跳跃",
  "jumper": "跳跃器",
  "jungle commander raynor": "丛林指挥官雷诺",
  "jungle novazon": "丛林亚马逊诺娃",
  "jungle raven sylvanas": "林鸦希尔瓦娜斯",
  "jungle warbringer zuljin": "丛林战争使者祖尔金",
  "jungle zeratul": "丛林泽拉图",
  "junkrat": "狂鼠",
  "justice for all": "义昭万众",
  "justice mecha tyrael": "正义机甲泰瑞尔",
  "kaelthas": "凯尔萨斯",
  "kaijo diablo": "怪兽迪亚波罗",
  "kalans edict": "卡兰的法令",
  "kaldir abathur": "卡亚迪尔阿巴瑟",
  "kaldir anubalisk": "卡亚迪尔阿努巴利斯克",
  "kaldir stukov": "卡亚迪尔斯托科夫",
  "kaldir zagara": "卡亚迪尔扎加拉",
  "kaldir zergling": "卡亚迪尔跳虫",
  "kaldorei aspect alexstrasza": "卡多雷巨龙阿莱克丝塔萨",
  "kaldorei resistance": "卡多雷抗性",
  "kaldorei spellbreaker johanna": "卡多雷破法者乔汉娜",
  "kanais cube": "卡奈魔盒",
  "kandy king muradin": "糖果王穆拉丁",
  "kawarimi": "化身术",
  "keep moving": "别停下！",
  "keg smash": "醉酿投",
  "kel thuzad": "克尔苏加德",
  "kerrigan": "凯瑞甘",
  "kezan sapper junkrat": "科赞爆破兵狂鼠",
  "khalas celerity": "卡拉之速",
  "khalas embrace": "卡拉之拥",
  "khalas light": "卡拉之光",
  "kharazim": "卡拉辛姆",
  "khaydarin resonance": "凯达琳共鸣",
  "kill command": "杀戮命令",
  "kinetic fulmination": "动能爆发",
  "king stitches": "国王缝合怪",
  "kinoko hanzo": "木龙半藏",
  "kneel peasants": "跪下，大胆刁民！",
  "knight captain imperius": "骑士队长英普瑞斯",
  "knight lieutenant morales": "骑士中尉莫拉莉斯",
  "knight owl medivh": "枭鹰骑士麦迪文",
  "krasari wanderer chen": "卡桑利云游者陈",
  "kul tiras footman varian": "库尔提拉斯步兵瓦里安",
  "kul tiras prince arthas": "库尔提拉斯王子阿尔萨斯",
  "kuroi sakura auriel": "黑之樱花奥莉尔",
  "kvaldir leoric": "克瓦迪尔李奥瑞克",
  "kwik release charge": "速发炸药",
  "l 800 e t c": "800级精英牛头人酋长",
  "la catrina lunara": "“骷髅花”露娜拉",
  "la pantera dorada sonya": "“黄金豹”桑娅",
  "la pantera sonya": "“美洲豹”桑娅",
  "la parca lunara": "“死神花”露娜拉",
  "lacerate": "裂痕",
  "lamb to the slaughter": "待宰羔羊",
  "landwalker murky": "陆地行者奔波尔霸",
  "large and in charge": "巨人冲撞",
  "laser drill issue order": "向激光钻机发出指令",
  "lashing out": "无情鞭挞",
  "last laugh": "笑到最后",
  "last rites": "断魂仪式",
  "lava surge": "熔岩奔腾",
  "lava wave": "熔岩波浪",
  "lavender deputy valla": "薰衣草副警长维拉",
  "law and order": "法律与秩序",
  "laws of hope": "希望律法",
  "lead rain": "枪林弹雨",
  "leaden orb": "沉重铁球",
  "leap of faith": "信仰飞跃",
  "leap": "腾空斩",
  "leaping strike": "跳跃攻击",
  "leather armored war steed carried": "皮革重甲军马（扛着）",
  "leather armored war steed": "皮革重甲军马",
  "leeching rounds": "吸血弹",
  "leeching scarabs": "吸血甲虫",
  "legendary hearthstone card": "传奇炉石卡牌",
  "legion guldan": "军团古尔丹",
  "legion mistress kerrigan": "军团妖女凯瑞甘",
  "legion of beetles": "甲虫军团",
  "legion of northrend": "诺森德大军",
  "legions wrath sonya": "军团之怒桑娅",
  "leopard beastmaster rexxar": "豹纹兽王雷克萨",
  "leopard glam metal e t c": "豹纹万人迷精英牛头人酋长",
  "leoric": "李奥瑞克",
  "leorics phantom": "李奥瑞克的幽灵战马",
  "leper timewalker chromie": "麻风时光旅行者克罗米",
  "leroics phantom carried": "李奥瑞克的幽灵战马（扛着）",
  "let the killing begin": "杀戮开始",
  "let them wither": "枯萎毒素",
  "lethal decoy": "致命诱饵",
  "lethal onslaught": "夺命强攻",
  "lets go": "出发！",
  "ley line seal": "魔网封印",
  "li li": "丽丽",
  "li ming": "李敏",
  "life binder": "生命缚誓者",
  "life drain": "生命吸取",
  "life funnel": "生命通道",
  "life leech": "汲取生命",
  "life support": "生命供给",
  "life tap": "生命分流",
  "life unbound": "生命释放",
  "lifebloom": "生命绽放",
  "lifeblossom": "生命之花",
  "lifeguard bikini stitches": "救生员比基尼缝合怪",
  "light e t c": "浅色精英牛头人酋长",
  "light of elune": "月神之光",
  "light of karabor": "卡拉波之光",
  "light of stormwind": "暴风城之光",
  "light speed": "光速",
  "lightbomb": "圣光炸弹",
  "lightning barrage": "闪电乱流",
  "lightning breath cancel": "闪电吐息取消",
  "lightning breath": "闪电吐息",
  "lightning fury": "雷霆之怒",
  "lightning nova": "闪电新星",
  "lightning reaction": "闪电反应",
  "lightning rod": "引雷针",
  "lightning serpent": "闪电翔龙",
  "lightning shield": "闪电之盾",
  "lightning surge": "闪电奔涌",
  "lightwell": "光明之泉",
  "lil ming timewalker chromie": "时光旅行者克罗敏",
  "lil ragnaros": "小拉格",
  "lilac shambler murky": "紫丁香恐波尔霸",
  "lingering ailment": "持久创痕",
  "lingering chill": "不散之寒",
  "lingering spines": "残留脊刺",
  "lionheart varian": "狮心瓦里安",
  "lionheart": "雄狮之心",
  "lions fang": "雄狮之牙",
  "lions maw": "雄狮之爪",
  "live and let live": "好生之德",
  "living bomb": "活动炸弹",
  "living meteor": "活体流星",
  "living the dream": "美梦成真",
  "living weapon": "人剑合一",
  "lo gosh varian": "洛戈什瓦里安",
  "locked and loaded": "荷枪实弹",
  "locust brood": "蝗虫大军",
  "locust nest": "蝗虫巢穴",
  "locust strain": "蝗虫变种",
  "locust swarm": "虫群风暴",
  "longboat raid": "战船掠夺",
  "longshot": "长程射击",
  "lord of hatred": "憎恨之王",
  "lord of terror": "恐惧之王",
  "lordaeron whitemane": "洛丹伦怀特迈恩",
  "lorenado": "书籍旋风",
  "los muertos lunara": "“亡灵花”露娜拉",
  "lost love goddess tyrande": "失落爱神泰兰德",
  "lost soul": "迷失之魂",
  "lotus lunar kaelthas": "瑞莲春节凯尔萨斯",
  "loud speakers": "扩音器",
  "love bug anubarak": "爱虫阿努巴拉克",
  "love doctor morales": "爱心医生莫拉莉斯",
  "love goddess tyrande": "爱神泰兰德",
  "lovely archon li ming": "可爱御法者李敏",
  "low blow": "卑鄙攻击",
  "lt morales": "莫拉莉斯中尉",
  "lucha pignata": "摔角斗士皮纳塔小猪",
  "luchihuahua": "露奇花花",
  "lucio": "卢西奥",
  "lucky azmodunk": "幸运阿兹乔丹",
  "lucky piggy bank": "幸运招财小猪",
  "lucky rainbow unicorn carried": "幸运彩虹独角兽（扛着）",
  "lucky rainbow unicorn": "幸运彩虹独角兽",
  "lumberjack uther": "伐木工乌瑟尔",
  "luminescent lurkablo": "冷光奔波尔菠萝",
  "lunar azmodan": "春节阿兹莫丹",
  "lunar blaze": "炽热月火",
  "lunar cassia": "春节卡西娅",
  "lunar chen": "春节老陈",
  "lunar dragon": "春节祥龙",
  "lunar flare": "月光术",
  "lunar genji": "春节源氏",
  "lunar guardian": "来福",
  "lunar illidan": "春节伊利丹",
  "lunar jaina": "春节吉安娜",
  "lunar kaelthas": "春节凯尔萨斯",
  "lunar li li": "春节丽丽",
  "lunar li ming": "春节李敏",
  "lunar mecha yrel": "月光机甲伊瑞尔",
  "lunar rooster": "春节公鸡",
  "lunar shower": "月光淋漓",
  "lunar skyrocket": "春节爆竹",
  "lunar sylvanas": "春节希尔瓦娜斯",
  "lunar tiger": "月光虎",
  "lunar zuljin": "春节祖尔金",
  "lunara": "露娜拉",
  "lunging strike": "突刺攻击",
  "lurkablo": "奔波尔菠萝",
  "lurker strain": "潜伏者变种",
  "lurking arm cancel": "潜伏手臂取消",
  "lurking arm": "潜伏手臂",
  "lurking terror": "潜伏恐魔",
  "machinus vile azmodan": "恶毒铁王阿兹莫丹",
  "mad axe garrosh": "疯狂艾克斯加尔鲁什",
  "mad harlequin yrel": "疯狂哈莉伊瑞尔",
  "mad jester yrel": "疯狂小丑伊瑞尔",
  "mad martian gazlowe": "疯狂火星人加兹鲁维",
  "maelstrom rounds": "漩涡弹",
  "maelstrom weapon": "漩涡武器",
  "maelstrom": "灵能漩涡",
  "mage armor": "法师护甲",
  "mage warlord chogall": "法师督军古加尔",
  "magenta elite agent nova": "品红精英特工诺娃",
  "magenta hell billie": "品红地狱比利",
  "magenta monarch brightwing": "品红帝王蝶光明之翼",
  "magenta shadowpaw li li": "品红影爪丽丽",
  "magenta super sonya": "品红超级桑娅",
  "maghar johanna": "玛格汉乔汉娜",
  "maghar shadow council guldan": "玛格汉暗影议会古尔丹",
  "maghar storm wolf rehgar": "玛格汉风暴之狼雷加尔",
  "maghar thrall": "玛格汉萨尔",
  "magic carpet": "魔法飞毯",
  "magic missiles": "魔法飞弹",
  "magic pumpkin chogall": "魔法南瓜古加尔",
  "magic spit": "魔法唾沫",
  "magical star chariot": "魔法星辰战车",
  "magical star princess li ming": "魔法星辰公主李敏",
  "magni muradin": "麦格尼穆拉丁",
  "magus medivh the black": "黑色大法师麦迪文",
  "magus medivh the green": "绿色大法师麦迪文",
  "magus medivh the white": "白色大法师麦迪文",
  "magus medivh": "大法师麦迪文",
  "mahogany blood elf tyrande": "桃木血精灵泰兰德",
  "maiev": "玛维",
  "majestic span": "辉煌耀光",
  "major d va": "少校D.Va",
  "making inky": "脏兮兮粘乎乎",
  "mal ganis": "玛尔加尼斯",
  "malachite valeera": "孔雀石瓦莉拉",
  "malevolence": "怨毒",
  "malfurion": "玛法里奥",
  "malicious intent": "恶毒杀意",
  "malthael": "马萨伊尔",
  "malthaels phantom carried": "马萨伊尔的幽灵战马（扛着）",
  "malthaels phantom": "马萨伊尔的幽灵战马",
  "mana addict": "魔瘾者",
  "mana tap": "法力分流",
  "mana tide": "法力之潮",
  "manticore": "蝎尾狮",
  "maraads insight": "玛尔拉德的洞察",
  "maraudin muradin": "劫掠者穆拉丁",
  "marble lunar guardian": "大理石来福",
  "march of the black king": "黑王进军",
  "march of the murlocs": "鱼人冲锋",
  "maritime dropkick kharazim": "“怒海升龙”卡拉辛姆",
  "mark of mending": "愈合印记",
  "marked for death": "死亡标记",
  "maroon tempest regalia jaina": "栗色风暴套装吉安娜",
  "maroon zarya": "栗色查莉娅",
  "marshal raynor": "警长雷诺",
  "marshals outrider carried": "警长的先驱者（扛着）",
  "marshals outrider": "警长的先驱者",
  "martial law": "戒严",
  "martyrdom": "殉道之心",
  "mass vortex": "超强漩涡",
  "massacre": "屠杀",
  "massive shove": "巨力猛推",
  "master assassin": "刺客大师",
  "master at arms": "武器大师",
  "master cybersteed carried": "士官赛博战马（扛着）",
  "master cybersteed": "士官赛博战马",
  "master dragon genji": "大师级神龙源氏",
  "master dreadmachine mal ganis": "大师恐惧装甲玛尔加尼斯",
  "master mecha valla": "大师机甲维拉",
  "master mecha yrel": "大师机甲伊瑞尔",
  "master of destruction": "毁灭专长",
  "master of flames": "驭火大师",
  "master of the cold dark": "冰冷黑魔法大师",
  "master sgt hammer": "大师级重锤军士",
  "master warp blade": "大师级折跃灵刃",
  "maximum charge": "能量全满",
  "maximum effort": "最大效能",
  "meat hook": "肉钩",
  "meat shield": "血肉之盾",
  "meat wagon": "绞肉车",
  "mech mode": "机甲模式",
  "mecha dehaka": "机甲德哈卡",
  "mecha lord": "机甲霸王",
  "mecha morph": "机甲变形",
  "mecha rehgar": "机甲雷加尔",
  "mecha tassadar": "机甲塔萨达尔",
  "mecha thrusters": "机甲推进器",
  "mecha tyrael": "机甲泰瑞尔",
  "mecha valla": "机甲维拉",
  "mecha yrel": "机甲伊瑞尔",
  "mechanical know how": "机械能手",
  "mechanized walker": "机械化步战机甲",
  "mechanospider": "机械蜘蛛",
  "medic ana": "医师安娜",
  "medic uther": "医疗兵乌瑟尔",
  "medivac dropship": "医疗运输机",
  "medivh cheats": "麦迪文作弊！",
  "medivh hearthstone card": "麦迪文炉石卡牌",
  "medivh": "麦迪文",
  "medusa blades": "美杜莎之刃",
  "mega love doctor morales": "超级爱心医生莫拉莉斯",
  "mek afall": "MEKA空投",
  "melee assassin": "近战刺客",
  "melee": "近战",
  "meltdown": "熔解",
  "melting touch": "熔火之触",
  "memento mori": "死亡警示",
  "mend pet": "治疗宠物",
  "mending strikes": "恢复打击",
  "mental acuity": "久远之视",
  "mephisto": "墨菲斯托",
  "mercenary lord": "佣兵统领",
  "mercenary queen": "雇佣兵女王",
  "merciful lt morales": "天使莫拉莉斯中尉",
  "merciless strikes": "无情打击",
  "metamorphosis": "恶魔变形",
  "meteor bomb": "爆破流星",
  "meteor shower": "流星雨",
  "mic check": "试音",
  "midnight ana": "午夜安娜",
  "midnight arcanist jaina": "午夜奥术师吉安娜",
  "midnight buccaneer falstad": "午夜掠夺者弗斯塔德",
  "midnight love goddess tyrande": "午夜爱神泰兰德",
  "midnight lunar cassia": "午夜春节卡西娅",
  "midnight monkey king samuro": "午夜猴王萨穆罗",
  "midnight theramore jaina": "午夜塞拉摩吉安娜",
  "midnight vampire slayer v": "午夜吸血鬼猎人V",
  "might of sargeras": "萨格拉斯之力",
  "might of the banshee queen": "女妖之王的力量",
  "might of the nerazim": "奈拉齐姆之力",
  "might of the scourge": "天灾之威",
  "mighty gust": "狂风来袭",
  "mimic": "拟态之影",
  "mind control": "精神控制",
  "mind devourer": "蚀心魔",
  "mind numbing agent": "降智药剂",
  "miniature black hole": "迷你黑洞",
  "minigun": "速射机枪",
  "mint gingerdread nazeebo": "薄荷姜饼怪人纳兹波",
  "mint sugar plum sylvanas": "薄荷糖梅希尔瓦娜斯",
  "mirage deathranger nova": "幻影死亡游侠诺娃",
  "mirage": "幻影",
  "mirror image": "镜像",
  "mirrorball": "镜光魔珠",
  "mirrored steel": "钢铁镜像",
  "misha charge": "米莎冲锋",
  "misha focus": "米莎锁定",
  "mist hunter greymane": "迷雾猎手格雷迈恩",
  "mistletoe winter veil lunara": "槲寄生冬幕节露娜拉",
  "mistweaver": "织雾",
  "mithril mace": "秘银之锤",
  "mithril muradin": "秘银穆拉丁",
  "mixing fire": "混音火力",
  "mobile offense": "机动攻势",
  "mobius loop": "莫比乌斯回路",
  "mocking strikes": "嘲讽打击",
  "moebius master sgt hammer": "莫比斯大师级重锤军士",
  "moldy gingerboard": "发霉姜饼飞板",
  "moldy gingerdread nazeebo": "发霉姜饼怪人纳兹波",
  "molten armor": "熔火战甲",
  "molten block": "熔火格挡",
  "molten core": "熔火之心",
  "molten diesel speaker nazeebo": "熔火柴油爆音王纳兹波",
  "molten druid of the flame malfurion": "熔火烈焰德鲁伊玛法里奥",
  "molten flow": "熔火激流",
  "molten overqueen zagara": "熔火女王扎加拉",
  "molten power": "熔火之力",
  "molten queen alexstrasza": "熔火女王阿莱克丝塔萨",
  "molten ragnaros": "熔火拉格纳罗斯",
  "molten swing": "熔火横扫",
  "monarch brightwing": "帝王蝶光明之翼",
  "monkey king samuro": "猴王萨穆罗",
  "monster creepie chromie": "怪物骷髅脸克罗米",
  "monster hunter": "怪物猎人",
  "monster within": "暗藏之魔",
  "moonfire": "月火术",
  "moonlight widowmaker nova": "月光黑百合诺娃",
  "moonlit arrows": "月光箭矢",
  "moonlit harmony": "月光调谐",
  "moonstone bloodfang valeera": "月长石血牙瓦莉拉",
  "moral compass": "道德罗盘",
  "morenados": "又要刮风啦！",
  "mortal combo": "致死连击",
  "mortal strike": "致死打击",
  "mortal wound": "重伤",
  "mortality": "震魂摄魄",
  "mortar": "迫击炮",
  "mosh pit cancel": "纵情狂欢取消",
  "mosh pit": "纵情狂欢",
  "moss oni genji": "深绿邪鬼源氏",
  "mounted archery": "翻身上马",
  "mounting potency": "效能跃升",
  "move unseen": "来去无踪",
  "multishot": "多重射击",
  "muradin": "穆拉丁",
  "murky sharkbite surfboard": "鱼人鲨鱼咬痕冲浪板",
  "murky surfboard": "奔波尔霸冲浪板",
  "murky": "奔波尔霸",
  "mutalisk": "尖啸异龙",
  "mutant mad axe garrosh": "变异疯狂艾克斯加尔鲁什",
  "mutant road boar": "变异霸路猪",
  "mutilate": "毁伤",
  "mysterious doctor wolf stein": "神秘沃尔夫博士与斯坦",
  "mystic assault": "神秘攻击",
  "mystic deckard": "神秘迪卡德",
  "mystic kingdoms arthas": "武圣阿尔萨斯",
  "mystical spear": "神秘之矛",
  "naishas memento": "娜萨的遗物",
  "nameless helldorado": "孤煞地狱狂驹",
  "nameless roadraider raynor": "孤煞巡游侠雷诺",
  "nano boost": "纳米激素",
  "nano infusion": "纳米注入",
  "nanomachine coating": "纳米机器人涂层",
  "nanoweave suit": "纳米编织服",
  "napalm strike": "凝固汽油弹",
  "natural agility": "敏",
  "natural perspective": "自然视界",
  "nature medivh": "自然麦迪文",
  "natures balance": "自然平衡",
  "natures culling": "自然抉择",
  "natures cure": "自然之愈",
  "natures swiftness": "自然迅捷",
  "natures toxin": "自然毒素",
  "naughty greatfather winter malfurion": "淘气冬天爷爷玛法里奥",
  "navy tychus": "海军泰凯斯",
  "naxxramas kel thuzad": "纳克萨玛斯克尔苏加德",
  "naxxramas knight sonya": "纳克萨玛斯骑士桑娅",
  "nazeebo": "纳兹波",
  "nazeebra carried": "纳兹布拉（扛着）",
  "nazeebra": "纳兹布拉",
  "necromaster xul": "死灵大师祖尔",
  "necrotic embrace": "冥魂之拥",
  "needlespine": "尖刺之脊",
  "nega force valeera": "反派特攻队瓦莉拉",
  "nega lion": "反派雄狮",
  "negatively charged": "负电荷",
  "neo president anduin": "新纪元总统安度因",
  "neo star queen li ming": "月野星辰女王李敏",
  "neo steel anduin": "新纪元钢铁安度因",
  "neo vigilante anduin": "新纪元义警安度因",
  "neocarbon dreadmachine mal ganis": "碳纤恐惧装甲玛尔加尼斯",
  "neon cybarak anubarak": "霓虹塞伯巴拉克",
  "neon diesel speaker nazeebo": "霓虹柴油爆音王纳兹波",
  "neon dragon genji": "霓虹神龙源氏",
  "neon green tracer": "霓虹绿色“猎空”",
  "neon spectre illidan": "霓虹幽魂伊利丹",
  "neon spectre nova": "霓虹幽魂诺娃",
  "neon spectre phantom": "霓虹幽魂幻影摩托",
  "neon spectre tracer": "霓虹幽魂“猎空”",
  "neon war world sgt hammer": "霓虹世界大战重锤军士",
  "neosteel coating": "精钢装甲",
  "neosteel plating": "精钢装甲",
  "nephalem johanna": "奈非天乔汉娜",
  "nephalem kharazim": "奈非天卡拉辛姆",
  "nephalem li ming": "奈非天李敏",
  "nephalem nazeebo": "奈非天纳兹波",
  "nephalem sonya": "奈非天桑娅",
  "nephalem valla": "奈非天维拉",
  "nerazim fenix": "奈拉齐姆菲尼克斯",
  "nerazim probius": "奈拉齐姆普罗比斯",
  "nerubian armor": "蛛魔护甲",
  "nerubian balespider guldan": "蛛魔邪蛛古尔丹",
  "nerves of steel": "钢铁神经",
  "nether monarch brightwing": "虚空帝王蝶光明之翼",
  "nether wind": "虚空灵风",
  "netherbreaker grizzly": "碎空者灰熊",
  "networked carapace": "连锁甲壳",
  "neural stimpack": "神经强化剂",
  "neutron space lord leoric": "中子太空王李奥瑞克",
  "neutron space lords starbreaker": "中子太空王的歼星者号",
  "neutron star lich kel thuzad": "中子星巫妖克尔苏加德",
  "never ending murlocs": "汹涌鱼潮",
  "never outmatched": "未逢敌手",
  "new glam metal e t c": "新万人迷精英牛头人酋长",
  "new habits": "新嗜好",
  "nexus battle beast": "时空蛮兽",
  "nexus blades": "时空利刃",
  "nexus charger carried": "时空战马（扛着）",
  "nexus charger": "时空战马",
  "nexus frenzy": "时空狂暴",
  "nexus razorback": "时空枢纽剃刀野猪",
  "nexus razorgrin": "时空枢纽刀鳍鲨",
  "nexus tiger": "时空战虎",
  "night explorer li li": "黑夜探险者丽丽",
  "night ronin zeratul": "黑夜东瀛剑客泽拉图",
  "night rush": "夜幕骤临",
  "night spectre illidan": "黑夜幽魂伊利丹",
  "night spider warden maiev": "暗夜蜘蛛守望者玛维",
  "night terrors": "噩梦效应",
  "nightborne tempest regalia jaina": "夜之子风暴套装吉安娜",
  "nightmare fuel": "梦魇灌注",
  "nightmare prime evil diablo": "梦魇大魔神迪亚波罗",
  "nightmare shando illidan": "梦魇衫多伊利丹",
  "nightmare waywatcher malfurion": "梦魇守路者玛法里奥",
  "nightslayer valeera": "夜幕杀手瓦莉拉",
  "nighttime wonder billie": "夜晚神奇比利",
  "nihon genji": "东瀛源氏",
  "nimble defender": "迅捷防御",
  "nimbus cloud": "筋斗云",
  "ninja assassin": "忍者刺客",
  "no escape": "无处可逃",
  "no mercy": "决不留情！",
  "no one can stop death": "没人能阻止死亡",
  "no sanctuary": "地狱无门",
  "nocturnal eagle eye tyrande": "夜色鹰眼泰兰德",
  "noir winter veil jaina": "黑色冬幕节吉安娜",
  "nomad kharazim": "游牧者卡拉辛姆",
  "nordic attack squad": "北境特攻队",
  "norse force": "北境力量",
  "northern champion lunara": "北方勇士露娜拉",
  "northern exposure": "北地暴寒",
  "northern kharazim": "北国卡拉辛姆",
  "northrend kel thuzad": "诺森德克尔苏加德",
  "northrend mal ganis": "诺森德玛尔加尼斯",
  "northrend meat wagon": "诺森德绞肉车",
  "northrend shando illidan": "诺森德衫多伊利丹",
  "northrend underking anubarak": "诺森德地底虫王阿努巴拉克",
  "nova": "诺娃",
  "novazon": "亚马逊诺娃",
  "nowhere to hide": "杀机四伏",
  "noxious blossom": "剧毒之花",
  "noxious deathfang genji": "剧毒死亡之牙源氏",
  "noxious imperator stukov": "剧毒大帝斯托科夫",
  "noxious mephisto": "剧毒墨菲斯托",
  "noxious pack leader dehaka": "剧毒虫群首领德哈卡",
  "noxious sidewinder ana": "剧毒响尾蛇安娜",
  "noxious unraveler zeratul": "剧毒剖尸者泽拉图",
  "noxious viper dominator": "剧毒蝰蛇陆霸",
  "nuclear option": "核选项",
  "null gate": "虚化之门",
  "nullification": "废除",
  "numbing blast": "麻木冲击",
  "nydus network": "坑道网络",
  "obsidian chief engineer gazlowe": "黑曜石首席工程师加兹鲁维",
  "obsidian chromie": "黑曜石克罗米",
  "obsidian cyber wolf": "黑曜石科幻战狼",
  "obsidian desert queen zagara": "黑曜石沙漠女王扎加拉",
  "obsidian lionheart varian": "黑曜石狮心瓦里安",
  "obsidian lunar guardian": "黑曜石来福",
  "obsidian sir murkalot": "黑曜鱼卡罗特爵士",
  "obsidian tiger": "黑曜石丛林虎",
  "ochre lost vikings": "赭石失落的维京人",
  "ochre valla": "赭石维拉",
  "octo grab": "章鱼缠绕",
  "off the wall": "即兴表演",
  "offensive cadence": "进攻节奏",
  "ogre hide": "食人魔之皮",
  "ogre mage chogall": "食人魔法师古加尔",
  "ogre rage": "食人魔之怒",
  "ogre rampage": "食人魔狂暴",
  "oil dispersal": "播洒燃油",
  "oil spill": "浮油",
  "olaf the stout": "强壮的奥拉夫",
  "old berserker kharazim": "年迈狂战士卡拉辛姆",
  "old marshal raynor": "年迈警长雷诺",
  "old marshals outrider carried": "老警长的先驱者（扛着）",
  "old marshals outrider": "老警长的先驱者",
  "omega anubalisk": "欧米茄阿努巴利斯克",
  "omegastorm": "欧米茄风暴",
  "ominous wraith": "不祥幽灵",
  "on a pale horse": "死神驾到",
  "on ruby wings": "红龙之翼",
  "on the prowl": "潜伏徘徊",
  "once again the first time": "又一次的第一次",
  "one good spread": "高效传播",
  "one in the chamber": "瞄准待发",
  "one who collects": "我为精华而生",
  "one with the wind": "化身为风",
  "oni genji": "邪鬼源氏",
  "onyx 2015 champions nexagon": "黑色2015世锦赛冠军飞碟",
  "onyx artanis": "黑色阿塔尼斯",
  "onyx billie the kid": "黑色儿童版比利",
  "onyx countess kerrigan": "黑色伯爵夫人凯瑞甘",
  "onyx dark prelate zeratul": "黑色黑暗教长泽拉图",
  "onyx diablo": "黑色迪亚波罗",
  "onyx fey dragon brightwing": "黑色灵龙光明之翼",
  "onyx horse carried": "黑色马（扛着）",
  "onyx horse": "黑色马",
  "onyx johanna": "黑色乔汉娜",
  "onyx mechanospider": "黑色机械蜘蛛",
  "onyx power briefs tychus": "黝黑劲泳泰凯斯",
  "onyx templar li ming": "黑色圣堂武士李敏",
  "oppressor": "武力压迫",
  "oracle": "先知",
  "orange rainbow unicorn carried": "橙色彩虹独角兽（扛着）",
  "orange rainbow unicorn": "橙色彩虹独角兽",
  "orange treasure goblin": "橙色盗宝地精",
  "orbital bfg": "轨道钝头弹",
  "orbital bombardment": "轨道轰炸",
  "orc beastmaster rexxar": "兽人兽王雷克萨",
  "orchid scarecrow xul": "淡紫稻草人祖尔",
  "orchid shambler murky": "兰花恐波尔霸",
  "orcish fallen junkrat": "兽化堕落者狂鼠",
  "ordermaster valla": "秩序大师维拉",
  "ornamented lunar zuljin": "华饰春节祖尔金",
  "orochi hovercycle": "“大蛇”悬浮摩托",
  "orphea": "奥菲娅",
  "ossein renewal": "骸骨再塑",
  "outriders ripper": "骑卫队飞轮",
  "overclocked probius prime": "超频主力机普罗比斯",
  "overdose": "药剂过量",
  "overflowing chaos": "混乱紊流",
  "overkill retarget": "致命连射重新锁定",
  "overkill": "致命连射",
  "overpower": "压制",
  "overpowering nightmare": "无间噩梦",
  "overprotective": "过度保护",
  "overqueen zagara": "女王扎加拉",
  "overwatch nexagon": "守望先锋飞碟",
  "overwhelming affliction": "剧痛难忍",
  "pacify": "安抚",
  "pack leader dehaka": "虫群首领德哈卡",
  "pain dont hurt": "这点伤小儿科",
  "pain is temporary": "短暂痛苦",
  "painful spikes": "痛苦穿刺",
  "paint them red": "枪枪见血",
  "painted horse carried": "斑点马（扛着）",
  "painted horse": "斑点马",
  "pajama party lost vikings": "睡衣派对失落的维京人",
  "pajamathur abathur": "睡衣宝宝阿巴瑟",
  "pale horse carried": "灰白马（扛着）",
  "pale horse": "灰白马",
  "pallid az guldan": "苍白阿兹古尔丹",
  "pallid burning blade samuro": "苍白火刃萨穆罗",
  "pallid dehaka": "苍白德哈卡",
  "pallid felstalker": "苍白魔犬",
  "pallid ironclaw rehgar": "苍白铁爪雷加尔",
  "pallid rexxar": "苍白雷克萨",
  "pallid swarm abathur": "苍白虫群阿巴瑟",
  "pallid world shaman thrall": "苍白世界萨满萨尔",
  "pandamonium hearthstone card": "潘达利亚炉石卡牌",
  "pandemic": "恶疾",
  "paper bag gazlowe": "纸袋加兹鲁维",
  "paralyzing enzymes": "麻痹酵素",
  "paralyzing rage": "瘫痪之怒",
  "paramedic morales": "急救医师莫拉莉斯",
  "paramour pajamathur abathur": "桃心睡衣宝宝阿巴瑟",
  "parry": "招架",
  "particle accelerator": "粒子加速",
  "particle grenade": "粒子榴弹",
  "parting gift": "临别赠礼",
  "party mix": "混音派对",
  "pastel pajama party lost vikings": "蜡笔睡衣派对失落的维京人",
  "patchwork creation": "缝合生物",
  "pathetic mortals": "可悲凡众",
  "pathfinder": "寻路者",
  "patriarch kharazim": "尊者卡拉辛姆",
  "peaceful repose": "心如止水",
  "pearl high templar zeratul": "珍珠高阶圣堂武士泽拉图",
  "pearl shadowpaw li li": "珍珠影掌丽丽",
  "peekaboo": "躲猫猫",
  "penance judgment charger carried": "苦修审判战马（扛着）",
  "penance judgment charger": "苦修审判战马",
  "penance judgment uther": "苦修审判套装乌瑟尔",
  "penetrate": "刺入",
  "penetrating round": "穿透弹",
  "perfect agility": "完美敏捷",
  "perfect aim": "精确打击",
  "perfect defense": "攻不可破",
  "perfect gems": "完美宝石",
  "perfect mecha tyrael": "完美机甲泰瑞尔",
  "perfect pro d va": "完美职业选手D.Va",
  "perfect shot": "百发百中",
  "perfect storm": "完美风暴",
  "permanent cloak": "永久隐形",
  "personal barrier": "个人屏障",
  "petrified butcher": "石化屠夫",
  "pew pew pew": "Biu!Biu!Biu!",
  "phantom knight zarya": "幽灵骑士查莉娅",
  "phantom pain": "幻痛",
  "phantom stallion carried": "幽灵马 (扛着)",
  "phantom stallion": "幽灵马",
  "phantom vampire slayer v": "幻影吸血鬼猎人V",
  "phantom wyrm alexstrasza": "幽灵龙阿莱克丝塔萨",
  "phase bulwark": "相位壁垒",
  "phase disruption": "相位干扰",
  "phase out": "相位脱离",
  "phase prism": "相位棱镜",
  "phase shift": "相位变换",
  "phoenix retarget": "重新指定凤凰目标",
  "phoenix": "凤凰",
  "photon barrier": "光子屏障",
  "photon cannon": "光子炮台",
  "photon lunar jaina": "光子春节吉安娜",
  "photonic weaponry": "光子武器",
  "phylactery of kel thuzad": "克尔苏加德的护命匣",
  "physical therapy": "物理疗法",
  "pick me up": "捡我",
  "pick your trait": "选择天赋",
  "picnic phantom stallion carried": "野餐幽灵马 (扛着)",
  "picnic phantom stallion": "野餐幽灵马",
  "pierce": "穿刺",
  "piercing arrows": "穿透箭矢",
  "piercing lash": "穿刺猛击",
  "piercing sands": "穿刺沙尘",
  "piggy bank": "招财小猪",
  "pignata": "皮纳塔小猪",
  "pilot mode": "驾驶员模式",
  "pin down": "飞刀刺击",
  "pinball wizard": "流行歌曲",
  "pink bikini stitches": "粉色比基尼缝合怪",
  "pink explorer li li": "粉红探险者丽丽",
  "pink fey dragon brightwing": "粉红灵龙光明之翼",
  "pink power briefs tychus": "粉色劲泳泰凯斯",
  "pinning shot": "钉刺射击",
  "pinpoint accuracy": "弹无虚发",
  "pinstripe scarecrow xul": "细纹稻草人祖尔",
  "pinto horse carried": "条纹马（扛着）",
  "pinto horse": "条纹马",
  "pirate queen cassia": "海盗女王卡西娅",
  "pity the frail": "怜悯弱者",
  "pixie boost": "妖精加速",
  "pixie charm": "妖精魔力",
  "pixie dust": "妖精之尘",
  "pixie power": "妖精能量",
  "plague bats": "瘟疫蝙蝠",
  "plague of toads": "蟾蜍之疫",
  "plagued dark lady sylvanas": "瘟疫黑暗女王希尔瓦娜斯",
  "plagued deathbringer sonya": "瘟疫死亡使者桑娅",
  "plaguewarden maiev": "瘟疫刑官玛维",
  "planet cracker cancel": "行星碎裂炮取消",
  "planet cracker": "行星碎裂炮",
  "planey pajamathur abathur": "飞机睡衣宝宝阿巴瑟",
  "plasma burn": "等离子灼烧",
  "plasma cutter": "等离子光线刀",
  "plasma shield": "等离子护盾",
  "plasma shock": "等离子冲击",
  "plate of the whale": "巨鲸护甲",
  "platinum cyber wolf": "白金科幻战狼",
  "platinum glam metal e t c": "白金万人迷精英牛头人酋长",
  "platinum malthael": "白金马萨伊尔",
  "platinum tyrael": "白金泰瑞尔",
  "platinum tyraels charger carried": "白金泰瑞尔的天使战马（扛着）",
  "platinum tyraels charger": "白金泰瑞尔的天使战马",
  "play again": "复活再战",
  "play of the game": "全场最佳",
  "playtime dehakasaurus rex": "欢乐暴龙德哈卡",
  "playtime": "陪我玩！",
  "plum adventurer li li": "梅红冒险家丽丽",
  "plum seasons reapings malthael": "梅紫礼物收割者马萨伊尔",
  "plum winters helper valla": "梅紫冬天爷爷的助手维拉",
  "plush unicorn": "毛绒独角兽",
  "plush zombicorn": "毛绒僵尸独角兽",
  "poison nazeebo": "剧毒纳兹波",
  "poison nova": "剧毒新星",
  "poison vampire slayer valla": "剧毒吸血鬼杀手维拉",
  "poison xul": "毒液祖尔",
  "poisoned spear": "剧毒之矛",
  "poly bomb": "变形炸弹",
  "polymorph": "变形术",
  "poppin pustules": "脓疱爆裂",
  "portal mastery": "传送门专精",
  "portal": "传送门",
  "possession": "占据",
  "potent bile": "强酸胆汁",
  "potion of revival": "振奋药水",
  "potion of shielding": "防护药水",
  "power briefs tychus": "劲泳泰凯斯",
  "power drench tychus": "大泵水枪泰凯斯",
  "power hungry": "奥能渴求",
  "power of icecrown": "冰冠之力",
  "power overflowing": "能量溢出",
  "power surge": "强力涌动",
  "power word shield": "真言术：盾",
  "powerslide": "动感滑步",
  "pox populi": "益向病变",
  "precision barrage": "精准弹幕",
  "precision strike": "定点打击",
  "predator eye pad": "肉食章鱼眼",
  "presence of mind": "气定神闲",
  "preservation": "保护",
  "press forward": "勇往直前",
  "press the advantage": "扩大优势",
  "press the attack": "持续进攻",
  "pressure point": "点穴踢",
  "pressurized glands": "加压腺体",
  "pretty plush unicorn": "毛绒独角兽美美",
  "pride": "傲慢",
  "primal brightwing": "原始光明之翼",
  "primal direhorn": "原始恐角龙",
  "primal dreamsaber": "原始梦刃豹",
  "primal flamesaber": "原始火刃豹",
  "primal grasp": "女王之爪",
  "primal intimidation": "野性威吓",
  "primal queen kerrigan": "原始女王凯瑞甘",
  "primal rage": "原始暴怒",
  "primal sandsaber": "原始沙刃豹",
  "primal swarm": "原始虫群",
  "primal tiger kharazim": "原始伏虎卡拉辛姆",
  "primary sequel lost vikings": "主要续作失落的维京人",
  "prime evil diablo": "大魔神迪亚波罗",
  "prime ribbit lucio": "最强宇宙蛙卢西奥",
  "prime soap bar": "超强去污皂",
  "prince varian": "瓦里安王子",
  "prismatic link": "棱镜链接",
  "prisoner tychus": "囚犯泰凯斯",
  "pristine chen": "古朴风老陈",
  "pristine orphea": "素色奥菲娅",
  "pro d va": "职业选手D.Va",
  "pro moves": "职业操作",
  "probius loop": "普罗比斯回路",
  "probius prime": "主力机普罗比斯",
  "probius": "普罗比斯",
  "prog rock": "前卫摇滚",
  "prolific dispersal": "散播繁殖",
  "prolonged safeguard": "持久护卫",
  "protective coating": "防护外壳",
  "prototype love doctor morales": "原型爱心医生莫拉莉斯",
  "prototype mecha dehaka": "原型机甲德哈卡",
  "prototype mecha valla": "原型机甲维拉",
  "prototype mecha yrel": "原型机甲伊瑞尔",
  "prototype seraph wing": "原型炽天使之翼",
  "prototype xenotech abathur": "原型异度机甲阿巴瑟",
  "psi infusion": "灵能灌注",
  "psionic barrier": "灵能屏障",
  "psionic echo": "灵能回响",
  "psionic efficiency": "卓越灵能",
  "psionic force valeera": "灵能特攻队瓦莉拉",
  "psionic lion": "灵能雄狮",
  "psionic projection": "灵能投射",
  "psionic pulse": "灵能脉冲",
  "psionic shift": "灵能位移",
  "psionic storm": "灵能风暴",
  "psionic strength": "灵能力量",
  "psionic synergy": "灵能协同",
  "psycho stitches": "电锯缝合怪",
  "psychotic break": "精神脱离",
  "puckish scamp": "淘气流氓",
  "pufferfish": "气泡鱼",
  "pulse bomb": "脉冲炸弹",
  "pulse detonation core": "脉冲爆核",
  "pulse rounds": "脉冲弹",
  "pulse strike": "脉冲打击",
  "pulsing pain": "阵痛",
  "pulverize": "粉碎",
  "pumpkin chogall": "南瓜古加尔",
  "pumpkin eye pad": "南瓜眼盘",
  "pumpkin psycho stitches": "南瓜电锯缝合怪",
  "puncturing arrow": "穿刺箭",
  "punish": "惩罚",
  "punishment": "惩罚",
  "pure country e t c": "乡村歌手精英牛头人酋长",
  "pure malice": "绝对仇恨",
  "pure zakarum leoric": "纯净萨卡兰姆李奥瑞克",
  "purge evil": "驱邪",
  "purge the wicked": "净化邪恶",
  "purification salvo": "净化齐射",
  "purifier artanis": "净化者阿塔尼斯",
  "purifier beam": "净化光束",
  "purifier probius": "净化者普罗比斯",
  "purifying brew": "活血酒",
  "purifying darts": "净化镖",
  "pursued by grace": "沐恩",
  "pursuit of flame": "烈焰渴求",
  "pursuit of justice": "正义追击",
  "pursuit of vengeance": "复仇追击",
  "push comes to shove": "愈推愈劲",
  "push forward": "向前推进！",
  "push off": "反冲",
  "put some english on it": "加点角度",
  "putrid bile": "腐烂胆汁",
  "pylon overcharge": "水晶塔超载",
  "pyroblast": "炎爆术",
  "pyromania": "纵火狂",
  "pyromaniac": "火焰狂热",
  "qhira": "琪拉",
  "quantum entanglement": "量子纠缠",
  "quantum overdrive": "量子超载",
  "quantum spike": "量子巅峰",
  "quarterback": "四分卫",
  "quartz high gravity zarya": "石英超强重力查莉娅",
  "queen of blades": "刀锋女王",
  "queen of ghosts kerrigan": "幽灵女王凯瑞甘",
  "queen of meka kerrigan": "MEKA女王凯瑞甘",
  "queen of templar kerrigan": "圣堂武士女王凯瑞甘",
  "quick spray expression": "快捷喷漆表情",
  "quick voice line expression": "快捷语音表情",
  "quickening blessing": "急速祝福",
  "quicksilver bullets": "水银子弹",
  "quicksilver": "流银泻地",
  "radiance": "圣恩闪耀",
  "radiant dash": "凌风击",
  "radiating faith": "辉煌信仰",
  "raging night wolf": "暴怒夜狼",
  "raging timber wolf": "暴怒森林狼",
  "raging war wolf": "暴怒战狼",
  "ragnarok missiles": "毁灭者导弹",
  "ragnarok n roll": "毁天灭地",
  "ragnaros": "拉格纳罗斯",
  "raider cyber ram": "游骑兵科幻公羊",
  "raider maraudin muradin": "游骑兵劫掠者穆拉丁",
  "raider rexxar": "游骑兵雷克萨",
  "raider sgt hammer": "游骑兵重锤军士",
  "rain nazeebo": "求雨纳兹波",
  "rain of destruction": "毁灭之雨",
  "rain of vengeance": "复仇之雨",
  "rainbow unicorn carried": "彩虹独角兽（扛着）",
  "rainbow unicorn": "彩虹独角兽",
  "raise skeleton": "骸骨复生",
  "rallying cry": "集结呐喊",
  "rampage": "狂暴践踏",
  "rampant hellfire": "狂乱地狱火",
  "rancor": "积怨",
  "rancorous miasma": "怨毒瘴气",
  "ranged assassin": "远程刺客",
  "ranger general sylvanas": "游侠将军希尔瓦娜斯",
  "ranger police hovercycle": "游骑兵执法悬浮摩托",
  "ranger": "游侠",
  "rangers mark": "游侠印记",
  "rapid chase": "夺命追猎",
  "rapid harvest": "快速收割",
  "rapid projection": "快速投射",
  "rapid recharge": "快速充能",
  "ravage": "毁灭跳击",
  "raven familiar": "乌鸦仆从",
  "raven form": "乌鸦形态",
  "raven malfurion": "渡鸦玛法里奥",
  "raven runner": "陆行鸦",
  "ravenous hunger": "贪食魔",
  "ravenous spirit": "饕餮恶灵",
  "ravens intellect": "乌鸦智慧",
  "ray of heaven": "天堂之光",
  "raynor": "雷诺",
  "raynors raider": "雷诺的游骑兵",
  "razor swipe": "利爪扫横",
  "rchs cheerleader kerrigan": "鸦冠高中拉拉队长凯瑞甘",
  "rchs slacker orphea": "校衫朋克奥菲娅",
  "rchs soap bar": "鸦中印花皂",
  "rchs striker li ming": "鸦冠高中排球女将李敏",
  "reabsorption": "重新吸收",
  "reactive ballistospores": "本能扩散",
  "reactive parry": "反应招架",
  "real dream 2016 championship banner": "美梦成真2016冠军旗帜",
  "real dream azmodunk": "梦想成真阿兹乔丹",
  "reaper necromaster xul": "收割者死灵大师祖尔",
  "reaper of souls": "夺魂之镰",
  "reapers mark": "死神印记",
  "reapers toll": "死神的丧钟",
  "reaver": "掠夺者",
  "rebirth": "涅槃",
  "recall": "闪回",
  "reciprocate": "回馈",
  "recklessness": "鲁莽",
  "recon commandant varian": "侦察指挥官瓦里安",
  "red horse carried": "红色马（扛着）",
  "red horse": "红色马",
  "red hot firestorm blaze": "红热烈焰风暴布雷泽",
  "red raynor": "红色雷诺",
  "redeemed tombstone": "救赎之墓碑",
  "redemption": "救赎",
  "redirect healing beam": "重新指定治疗射线目标",
  "redirect ley line seal": "魔网封印重新导向",
  "redridge anduin": "赤脊山安度因",
  "redridge reverence carried": "赤脊山虔敬（扛着）",
  "redridge reverence": "赤脊山虔敬",
  "redstone muradin": "红石穆拉丁",
  "reduce reuse recycle": "降解、循环、回收",
  "reef admiral krakenov": "暗礁上将海怪诺夫",
  "reef deepcrawler": "礁石深渊爬行蟹",
  "reflect": "一闪",
  "reflexive block": "本能格挡",
  "regal alarak": "帝王阿拉纳克",
  "regal orphea": "皇家奥菲娅",
  "regeneration master": "恢复大师",
  "regeneration": "再生",
  "regenerative bio steel": "再生型生物钢",
  "regrowth": "愈合",
  "rehgar": "雷加尔",
  "reign deer": "时空驯鹿",
  "reinforce": "强固",
  "reinforced carapace": "强化甲壳",
  "reinforcements": "援军",
  "rejuvenating bubble": "恢复泡泡",
  "rejuvenation potion": "复苏药水",
  "rejuvenation": "回春术",
  "rejuvenescencia": "新生",
  "relentless soldier": "坚韧士兵",
  "relentless strikes": "无情打击",
  "reload": "装填",
  "relocate wisp": "小精灵重新定位",
  "remorseless winter": "冷酷严冬",
  "remorseless": "冰冷无情",
  "rending cleave": "撕裂斩",
  "renegade master sgt hammer": "叛军大师级重锤军士",
  "renew": "强化恢复",
  "repeated offense": "连续进攻",
  "repeating arrow": "无尽追踪箭",
  "repentance": "忏悔",
  "reptilian butcher": "卑鄙屠夫",
  "repulsion": "反斥",
  "repulsor": "震退力场",
  "rescue shrike": "救援伯劳鸟",
  "reservoir of hope": "充满希望",
  "resilient flame": "顽强烈焰",
  "resonation": "共鸣",
  "respect the elderly": "尊敬长者",
  "restored cyberdemon zarya": "复苏赛博恶鬼查莉娅",
  "resurrect": "圣洁新生",
  "reverberation": "余波回荡",
  "reverence carried": "虔敬（扛着）",
  "reverence": "虔敬",
  "reverse amp": "刺耳强音",
  "revitalize": "新生",
  "revolving sweep": "回旋扫荡",
  "rewind": "时光回溯",
  "rexxar": "雷克萨",
  "ribbit lucio": "宇宙蛙卢西奥",
  "ricochet": "弹跳弹",
  "rift shock": "裂隙冲击",
  "righteous assault": "正义突袭",
  "righteous flame": "正义怒焰",
  "righteous hammer": "正义之锤",
  "righteous momentum": "正义势能",
  "righteousness": "正义凛然",
  "rime": "白霜",
  "ring of fire": "火焰之环",
  "ring of frost": "冰霜之环",
  "ring of poison": "剧毒之环",
  "ring of the leech": "吸血指环",
  "ringmaster greymane": "马戏团长格雷迈恩",
  "ringmasters pride": "马戏团长的雄狮",
  "rip tire": "炸弹轮胎",
  "ripper air": "窜天鼠",
  "ripper": "锯齿飞轮",
  "riptide rehgar": "激流雷加尔",
  "riptide sharkbite surfboard": "驭浪鲨鱼咬痕冲浪板",
  "riptide surfboard": "激流冲浪板",
  "rising dread": "恐惧升腾",
  "rising storm": "风暴崛起",
  "rite of rak shir": "拉克希尔仪式",
  "ritual of life": "生命仪式",
  "river lumberjack uther": "河流伐木工乌瑟尔",
  "road boar": "霸路猪",
  "road chariot": "双轮战车",
  "roadraider raynor": "巡游侠雷诺",
  "roar": "怒吼",
  "robo goblin": "机械地精",
  "rock it turret xl": "超大号摇滚炮台",
  "rock it turret": "摇滚炮台",
  "rocket jump jets": "火箭喷气背包",
  "rocket ride": "火箭狂飙",
  "rockstar": "摇滚明星",
  "rogue mecha rehgar": "叛变机甲雷加尔",
  "rogue novazon": "盗贼亚马逊诺娃",
  "rogue vampire slayer v": "游侠吸血鬼猎人V",
  "rollback": "炸弹回弹",
  "roller derby nova": "轮滑女孩诺娃",
  "rolling thunder": "滚雷",
  "ronin zeratul": "东瀛剑客泽拉图",
  "rosa ribbit lucio": "玫瑰宇宙蛙卢西奥",
  "rose high priestess tyrande": "玫瑰高阶祭司泰兰德",
  "rose vampire slayer valla": "玫瑰吸血鬼杀手维拉 ",
  "rosy deputy valla": "玫瑰副警长维拉",
  "rosy greatfather winter malfurion": "玫红冬天爷爷玛法里奥",
  "rosy winter veil kharazim": "玫红冬幕节卡拉辛姆",
  "rotten scarecrow xul": "腐烂稻草人祖尔",
  "rough landing": "千斤坠",
  "royal armored war steed carried": "皇家重甲军马（扛着）",
  "royal armored war steed": "皇家重甲军马",
  "royal blue tracer": "皇家蓝色“猎空”",
  "royal bone visage xul": "皇家白骨面罩祖尔",
  "royal centurion johanna": "皇家百夫长乔汉娜",
  "royal focus": "皇室专注",
  "royal lionheart varian": "皇家狮心瓦里安",
  "ruby chromie": "红宝石克罗米",
  "ruby desert queen zagara": "红宝石沙漠女王扎加拉",
  "ruby frost wyrm arthas": "红宝石冰霜巨龙阿尔萨斯",
  "ruby theramore jaina": "红宝石塞拉摩吉安娜",
  "ruby": "红宝石",
  "rugged deathranger nova": "荒野死亡游侠诺娃",
  "ruinous affliction": "毁灭痛苦",
  "ruinwalker fenix": "废墟行者菲尼克斯",
  "run and gun": "冲刺射击",
  "rune bomb": "符文炸弹",
  "rune tap": "符文分流",
  "runed felstalker": "符文魔犬",
  "runed gauntlet": "符文护手",
  "runic blast": "符文冲击",
  "runic feedback": "符文反馈",
  "runic persistence": "符文耐久",
  "running wild": "狂野奔跑",
  "rupture": "割裂",
  "rush down": "无损动力",
  "rusted bone visage xul": "锈迹白骨面罩祖尔",
  "rusted fenix": "泛锈菲尼克斯",
  "rusted junkrat": "染锈狂鼠",
  "rusted xenotech abathur": "泛锈异度机甲阿巴瑟",
  "ruthless momentum": "锐气逼人",
  "ruthless onslaught cancel": "取消赶尽杀绝",
  "ruthless onslaught": "赶尽杀绝",
  "ruthless spirit": "无情怨魂",
  "ruthless": "残忍",
  "saboteur xenotech abathur": "造恶异度机甲阿巴瑟",
  "sacred ground": "圣洁之地",
  "sacred oath johanna": "神圣誓言乔汉娜",
  "sacred sweep": "神圣扫击",
  "sacrifice": "牺牲",
  "sacrificial soul": "献祭灵魂",
  "sad cloud": "伤心云",
  "saddled battle beast": "鞍座战争蛮兽",
  "saddled horse carried": "鞍座马（扛着）",
  "saddled horse": "鞍座马",
  "sadism": "施虐",
  "sadistic dark nexus hound": "嗜虐黑暗时空恶犬",
  "safe zone": "安全区",
  "safeguard": "护卫",
  "safety bubble": "安全泡泡",
  "safety dust": "防护之尘",
  "safety in numbers": "人多安全",
  "safety sprint": "安全冲刺",
  "saffron jaina": "橘黄吉安娜",
  "saffron li li": "橘黄丽丽",
  "sakura auriel": "樱花奥莉尔",
  "salty buccaneer falstad": "盐白掠夺者弗斯塔德",
  "salvager": "变废为宝",
  "salvation": "救赎",
  "samuro": "萨穆罗",
  "sanctification": "圣化",
  "sand blast": "沙尘爆裂",
  "sand desert queen zagara": "流沙沙漠女王扎加拉",
  "sandfury zuljin": "沙怒祖尔金",
  "sandy arcadian war turtle": "沙地阿坎迪安战龟",
  "sanguine death god arthas": "紫红死神阿尔萨斯",
  "sanguine deathbringer sonya": "腥红死亡使者桑娅",
  "sanguine tiger kharazim": "血腥伏虎卡拉辛姆",
  "sanlayn dark lady sylvanas": "萨莱因黑暗女王希尔瓦娜斯",
  "sapper junkrat": "爆破兵狂鼠",
  "sapphire cyberhawk kaelthas": "蓝宝石赛博雄鹰凯尔萨斯",
  "sapphire heart stone": "蓝宝石爱心之石",
  "sapphire striker li ming": "蓝宝石排球女将李敏",
  "sapphire": "蓝宝石",
  "sargas probius prime": "沙加斯主力机普罗比斯",
  "saronite alexstrasza": "萨隆邪铁阿莱克丝塔萨",
  "saronite arthas": "萨隆邪铁阿尔萨斯",
  "saronite crypt queen zagara": "萨隆邪铁地穴女王扎加拉",
  "saronite dreadlord jaina": "萨隆邪铁恐惧魔王吉安娜",
  "saronite ironclaw rehgar": "萨隆邪铁铁爪雷加尔",
  "satyr betrayer malfurion": "萨特背叛者玛法里奥",
  "savage butchers beast": "野蛮屠夫蛮兽",
  "savage charge": "野蛮冲撞",
  "savage eye pad": "野蛮章鱼眼",
  "savage iron butcher": "野蛮钢铁屠夫",
  "savage pack leader dehaka": "野生虫群首领德哈卡",
  "savor the flavor": "气香味美",
  "scarab host": "甲虫宿主",
  "scarecrow xul": "稻草人祖尔",
  "scarlet aegis": "血色之盾",
  "scarlet arcanist jaina": "血色奥术师吉安娜",
  "scarlet archangel auriel": "血色大天使奥莉尔",
  "scarlet crusade": "血色十字军",
  "scarlet daelaam artanis": "血色达拉姆阿塔尼斯",
  "scarlet dream genie chromie": "血色梦幻精灵克罗米",
  "scarlet farstrider hanzo": "血色远行者半藏",
  "scarlet harlequin nazeebo": "血色小丑纳兹波",
  "scarlet johanna": "血色乔汉娜",
  "scarlet nova": "血色诺娃",
  "scarlet sakura auriel": "血色樱花奥莉尔",
  "scarlet sir murkalot": "血色鱼卡罗特爵士",
  "scarlet striker li ming": "血色排球女将李敏",
  "scarlet sylvanas": "血色希尔瓦娜斯",
  "scarlet whitemane": "血色怀特迈恩",
  "scarlet wrath sonya": "血色愤怒套装桑娅",
  "scatter arrow": "散",
  "scavengers ripper": "拾荒者飞轮",
  "scorching ragnaros": "灼热拉格纳罗斯",
  "scourge kel thuzad": "天灾克尔苏加德",
  "scourged wastewalker deckard": "天灾废墟行者迪卡德",
  "scrap o matic smelter": "废材熔炉",
  "scrapper queen qhira": "削铁女皇琪拉",
  "scroll of identify": "辨识卷轴",
  "scroll of sealing": "封印卷轴",
  "scroll of stone curse": "石咒卷轴",
  "seafarer greymane": "航海家格雷迈恩",
  "seafoam buccaneer falstad": "海沫掠夺者弗斯塔德",
  "seafury pirate queen cassia": "海怒海盗女王卡西娅",
  "seal fate": "封印命运",
  "seal of eldruin": "圣剑之印",
  "seared flesh": "肉体灼烧",
  "searing lash": "灼痛鞭笞",
  "searing light": "灼热之光",
  "searing shadows": "灼热暗影",
  "seasoned marksman": "老练的射手",
  "seasons reapings malthael": "礼物收割者马萨伊尔",
  "second helping": "加餐",
  "second opinion": "第二意见",
  "second wind": "复苏之风",
  "secondary fire": "附加火力",
  "secret phantom stallion carried": "神秘幽灵马 (扛着)",
  "secret phantom stallion": "神秘幽灵马",
  "secret weapon": "秘密武器",
  "seeker in the dark": "黑暗猎手",
  "seeker swarm": "寻踪蝠群",
  "seeker": "追踪飞弹",
  "seething hatred": "憎恨高涨",
  "seismic slam": "裂地斩",
  "select all vikings": "选中所有维京人",
  "select all": "全选",
  "select baleog": "选择巴尔洛戈",
  "select erik": "选择埃瑞克",
  "select olaf": "选择奥拉夫",
  "select samuro": "选择萨穆罗",
  "self destruct": "自毁",
  "self righteous": "自命正义",
  "sentenced to death": "处决",
  "sentinel lunara": "哨兵露娜拉",
  "sentinel wisp": "放哨精灵",
  "sentinel": "哨兵",
  "sequel lost vikings": "续作失落的维京人",
  "seraph wing": "炽天使之翼",
  "seraphim tyrael": "六翼天使泰瑞尔",
  "seraphim": "炽天使",
  "seraphs hymn": "天使赞美诗",
  "serenity": "平静",
  "serpent king xul": "毒蛇之王祖尔",
  "serpent sidekick": "翔龙伙伴",
  "serrated arrows": "锯齿箭矢",
  "serrated edge": "锯齿钩",
  "serrated spines": "锯齿脊针",
  "seven sided strike": "七相拳",
  "sewage gazlowe": "污水加兹鲁维",
  "sgt doomhammer": "毁灭之锤军士",
  "sgt hammer": "重锤军士",
  "shackler": "白骨镣铐",
  "shade lord": "影之主宰",
  "shade of mephisto": "墨菲斯托之影",
  "shade": "白骨之影",
  "shadow archon li ming": "暗影御法者李敏",
  "shadow armor": "暗影护甲",
  "shadow bolt volley": "暗影箭雨",
  "shadow charge": "暗影冲锋",
  "shadow council guldan": "暗影议会古尔丹",
  "shadow count arthas": "暗影伯爵阿尔萨斯",
  "shadow crimson hare carried": "暗影赤兔（扛着）",
  "shadow crimson hare": "暗影赤兔",
  "shadow dagger": "暗影匕首",
  "shadow demonic auriel": "暗影恶魔奥莉尔",
  "shadow fissure": "暗影裂隙",
  "shadow hunter": "暗影猎手",
  "shadow kerrigan": "暗影凯瑞甘",
  "shadow mending": "暗影治疗",
  "shadow mystic kingdoms arthas": "暗影武圣阿尔萨斯",
  "shadow nazeebo": "暗影纳兹波",
  "shadow oni genji": "暗影邪鬼源氏",
  "shadow orb huntress": "暗影宝珠：女猎手",
  "shadow orb shadow strike": "暗影宝珠：暗影突袭",
  "shadow orb vengeance": "暗影宝珠：复仇之魂",
  "shadow patriarch kharazim": "暗影尊者卡拉辛姆",
  "shadow priestess tyrande": "暗影祭司泰兰德",
  "shadow sgt doomhammer": "暗影毁灭之锤军士",
  "shadow shogun artanis": "暗影幕府将军阿塔尼斯",
  "shadow storm mantle malfurion": "暗影怒风肩甲玛法里奥",
  "shadow waltz": "暗影华尔兹",
  "shadowblade li li": "影刃丽丽",
  "shadowflame": "暗影烈焰",
  "shadowfury": "暗影之怒",
  "shadowmoon guldan": "影月谷古尔丹",
  "shadowmoon hellblade samuro": "影月地狱之刃萨穆罗",
  "shadowmoon hellboar": "影月地狱野猪",
  "shadowpaw li li": "影掌丽丽",
  "shadowsnare": "暗影诱捕",
  "shadowstalk": "暗影潜行",
  "shake it off": "出入无形",
  "shakuras johanna": "萨古拉斯乔汉娜",
  "shambling horror": "蹒跚恐魔",
  "shando illidan": "衫多伊利丹",
  "shandos clarity": "杉多之澈",
  "shard of hate": "憎恨碎片",
  "shared punishment": "株连受罚",
  "sharkbite surfboard": "鲨鱼咬痕冲浪板",
  "sharkmouth goliath d va": "鲨鱼嘴歌利亚D.Va",
  "sharpened arrowheads": "锋锐箭矢",
  "sharpened blades": "锋利之刃",
  "sharpened stars": "星镖",
  "sharpshooter": "神枪手",
  "shattered armor": "粉碎护甲",
  "shattered dark nexus alarak": "破碎的黑暗时空阿拉纳克",
  "shattered ground": "破碎大地",
  "shattered hand garrosh": "碎手加尔鲁什",
  "shattered hand samuro": "碎手萨穆罗",
  "shattering throw": "碎裂投掷",
  "shed exoskeleton": "蜕皮外壳",
  "shield ally": "投射屏障",
  "shield battery": "护盾充能",
  "shield capacitor": "护盾储能器",
  "shield glare": "盾闪",
  "shield of hope": "希望之盾",
  "shield overload": "护盾过载",
  "shield sequencer": "护盾序列器",
  "shield surge": "护盾喷涌",
  "shield wall": "盾墙",
  "shifting malice": "恶意转移",
  "shifting meteor": "移形流星",
  "shifting nether": "转移虚空",
  "shifting sands": "流沙",
  "shingan": "心眼",
  "shock custom rig tychus": "闪电特制装备泰凯斯",
  "shock l 800 e t c": "雷霆800级精英牛头人",
  "shogun artanis": "幕府将军阿塔尼斯",
  "sholazar direhorn": "索拉查恐角龙",
  "shoot em up": "脉冲四射",
  "shooting star": "疾速流星",
  "shot of fury": "无名怒火",
  "shove": "猛推",
  "show of force": "力量的展示",
  "show stopper": "热烈掌声",
  "showtime 2016 championship banner": "大显身手2016冠军旗帜",
  "showtime azmodunk": "大显身手阿兹乔丹",
  "showtime lucio": "大显身手卢西奥",
  "shrapnel mines": "霰弹跳雷",
  "shrike": "伯劳鸟",
  "shroud of adun": "亚顿之影",
  "shroud of the dead king": "不死君王的裹尸布",
  "shroud of wisdom": "智慧帷幕",
  "shukuchi": "隐遁术",
  "shuriken mastery": "忍镖精通",
  "shuriken": "镖",
  "si 7 bloodfang valeera": "军情七处血牙瓦莉拉",
  "sidewinder ana": "响尾蛇安娜",
  "siege mode": "攻城模式",
  "siege tactics": "攻城战术",
  "siegebreaker": "攻城突击兽",
  "silent killer": "沉默杀手",
  "silent love goddess tyrande": "沉默爱神泰兰德",
  "silithus crypt queen zagara": "希利苏斯地穴女王扎加拉",
  "silithus underking anubarak": "希利苏斯地底虫王阿努巴拉克",
  "silver angelic valla": "白银天使维拉",
  "silver archangel tyrael": "白银大天使泰瑞尔",
  "silver grand marshal uther": "白银大元帅乌瑟尔",
  "silver hand uther": "白银之手乌瑟尔",
  "silver hand yrel": "白银之手伊瑞尔",
  "silver kaelthas": "白银凯尔萨斯",
  "silver mad martian gazlowe": "白银疯狂火星人加兹鲁维",
  "silver thrall": "白银萨尔",
  "silver touch": "白银之触",
  "simple geometry": "简单几何学",
  "sindorei ranger general sylvanas": "辛多雷游侠将军希尔瓦娜斯",
  "singularity charge": "奇点充能",
  "singularity spike": "奇点钉刺",
  "sinister strike": "影袭",
  "sinister xenotech abathur": "凶恶异度机甲阿巴瑟",
  "sinlord azmodan": "罪恶之王阿兹莫丹",
  "sins exposed": "原形毕露",
  "sins grasp": "原罪之握",
  "sinuous grave warden malthael": "阴邪镇墓者马萨伊尔",
  "siphoning arrow": "虹吸箭",
  "siphoning impact": "虹吸冲击",
  "siphoning link": "虹吸之链",
  "siphoning toxin": "虹吸毒素",
  "sir murkalot": "鱼卡罗特爵士",
  "sixth sense": "第六感",
  "sizzlin attacks": "灼热攻击",
  "skeletal bone visage xul": "骷髅白骨面罩祖尔",
  "skeletal mages": "骷髅法师",
  "skeletal raven sylvanas": "骨鸦希尔瓦娜斯",
  "skeletal swing": "骸骨重击",
  "skelethur abathur": "骷髅阿巴瑟",
  "skull missile": "魔颅飞弹",
  "skullcracker": "碎颅者",
  "sky gryphon master falstad": "天空狮鹫大师弗斯塔德",
  "sky temple": "天空殿",
  "skyborne archangel diablo": "天诞大天使迪亚波罗",
  "skyborne imperius": "巡天者英普瑞斯",
  "slacker orphea": "叛逆少女奥菲娅",
  "slam": "猛击",
  "slate tychus": "蓝灰泰凯斯",
  "slaughterhouse": "屠宰场",
  "sledgehammer": "无情铁锤",
  "sleep dart": "麻醉镖",
  "sleight of hand": "手法娴熟",
  "slice and dice": "切割",
  "slime time": "粘液表演",
  "slime": "粘液喷射",
  "slip n stream tracer": "水枪“猎空”",
  "slip": "滑行",
  "slippery when wet": "湿湿滑滑",
  "slipstream orochi hovercycle": "跃空“大蛇”悬浮摩托",
  "slipstream turbo tracer": "跃空极速“猎空”",
  "slipstream": "跃空",
  "slow burn": "缓慢烧灼",
  "slowing sands": "减速沙尘",
  "sludge gazlowe": "淤泥加兹鲁维",
  "slumber shells": "阻滞弹",
  "smart storm strider": "智能机动队追击者",
  "smelling salts": "嗅盐",
  "smite the wicked": "严惩罪恶",
  "smite": "惩击",
  "smoke bomb": "烟雾弹",
  "smokin blaze": "熏烟布雷泽",
  "smoldering desert queen zagara": "燃火沙漠女王扎加拉",
  "smoldering fel reaver blaze": "燃火魔能机甲布雷泽",
  "smooth moves": "行云流水",
  "snipe": "狙击",
  "snow oni genji": "雪鬼源氏",
  "snow plum sylvanas": "雪梅希尔瓦娜斯",
  "snowfall alexstrasza": "雪落阿莱克丝塔萨",
  "snowfall winter veil lunara": "飘雪冬幕节露娜拉",
  "snowstorm": "雪暴",
  "snowy adventurer li li": "雪白冒险家丽丽",
  "snuggle bear stitches": "亲亲熊缝合怪",
  "soap bar": "经典款肥皂",
  "soaring cassia": "飞翔卡西娅",
  "soaring lunar skyrocket": "高升春节爆竹",
  "soaring lunar sylvanas": "高升春节希尔瓦娜斯",
  "solar mecha valla": "太阳能机甲维拉",
  "solarions fire": "索拉里昂之焰",
  "solarite high templar zeratul": "太阳能高阶圣堂武士泽拉图",
  "solarite probius prime": "太阳能主力机普罗比斯",
  "solarite reaper": "太阳能灵刃",
  "solarite reaver": "太阳能掠夺者",
  "solarite tassadar": "太阳能塔萨达尔",
  "soldiers ripper": "士兵飞轮",
  "soma transference": "细胞转移",
  "sonic arrow": "音",
  "sonya": "桑娅",
  "soothing mist": "抚慰之雾",
  "sora hanzo": "蓝龙半藏",
  "sora sakura auriel": "空之樱花奥莉尔",
  "soul collector": "集魂者",
  "soul harvest": "灵魂收割",
  "soul iron diablo": "灵魂钢铁迪亚波罗",
  "soul rip": "夺魂",
  "soul shield": "灵魂护盾",
  "soul siphon": "灵魂虹吸",
  "soulbreaker thrall": "碎魂者萨尔",
  "soulburn mephisto": "焰魂墨菲斯托",
  "souleater azmodan": "噬魂阿兹莫丹",
  "souls to the flame": "灵魂化火",
  "sound barrier": "音障",
  "soundblast lucio": "震音卢西奥",
  "soundwave": "音波",
  "sour apple kandy king muradin": "酸苹果糖王穆拉丁",
  "sour plum sylvanas": "酸梅希尔瓦娜斯",
  "sous chef stitches": "副厨缝合怪",
  "sovereign armor": "君王护甲",
  "sovereign kaelthas": "帝王凯尔萨斯",
  "space lord leoric": "太空王李奥瑞克",
  "space lords starbreaker": "太空王的歼星者号",
  "sparkle jester yrel": "闪光小丑伊瑞尔",
  "spatial echo": "空间回音",
  "spatial efficiency": "腔体进化",
  "spawn egg": "放置鱼人蛋",
  "special ordnance raynor": "特殊军火雷诺",
  "special snowflake": "特殊雪花",
  "spectral bewitching brightwing": "幽灵女巫光明之翼",
  "spectral buccaneer falstad": "幽魂掠夺者弗斯塔德",
  "spectral countess kerrigan": "幽灵伯爵夫人凯瑞甘",
  "spectral leech": "幽魂汲取",
  "spectral malthael": "幽灵马萨伊尔",
  "spectral scythe": "幽魂镰刀",
  "spectral stallion carried": "鬼灵马（扛着）",
  "spectral stallion": "鬼灵马",
  "spectral wyrm alexstrasza": "鬼龙阿莱克丝塔萨",
  "spectre cyberhawk kaelthas": "幽灵赛博雄鹰凯尔萨斯",
  "spectre goliath d va": "幽魂歌莉娅D.Va",
  "spectre illidan": "幽魂伊利丹",
  "spectre l 800 e t c": "幽魂800级精英牛头人",
  "spectre nova": "幽魂诺娃",
  "spectre orochi hovercycle": "幽魂“大蛇”悬浮摩托",
  "spectre phantom": "幽魂幻影摩托",
  "spectre thunder guard zarya": "幽魂雷霆卫队查莉娅",
  "spectre tracer": "幽魂“猎空”",
  "spectre vulture": "幽魂秃鹫",
  "spectrum cybersteed carried": "光谱赛博战马（扛着）",
  "spectrum cybersteed": "光谱赛博战马",
  "speed barrier": "加速屏障",
  "speed demon lucio": "飚速恶鬼卢西奥",
  "speed metal": "速度金属",
  "speed of the pious": "虔诚之速",
  "speed serum": "加速血清",
  "speedy dragon": "快快龙",
  "spell barrier": "法术屏障",
  "spell shield": "法术护盾",
  "spellbreaker johanna": "破法者乔汉娜",
  "spider colony": "群聚蜘蛛",
  "spider mines": "蜘蛛雷",
  "spider warden maiev": "蜘蛛守望者玛维",
  "spike burst": "尖刺喷射",
  "spin to win": "转向胜利",
  "spine launcher": "脊刺投射",
  "spirit ally": "灵相幻身",
  "spirit bond": "灵魂相连",
  "spirit healer auriel": "灵魂医师奥莉尔",
  "spirit of arachyr": "亚拉基尔的灵魂",
  "spirit of vengeance": "复仇之魂",
  "spirit shield": "狼魂之盾",
  "spirit swoop": "灵魂猛扑",
  "spirited bewitching brightwing": "仙灵女巫光明之翼",
  "spite": "狂饮憎恨",
  "spiteful janitor leoric": "怨毒清洁工李奥瑞克",
  "splintered spear": "分裂之矛",
  "spoiled slacker orphea": "娇纵少女奥菲娅",
  "spray n pray": "机枪扫射",
  "spread volley": "散射榴弹",
  "spreading plague": "传播瘟疫",
  "spring funny bunny murky": "春季搞笑兔奔波尔霸",
  "spring sakura auriel": "春天樱花奥莉尔",
  "spy games": "间谍游戏",
  "squeaky soap bar": "滑溜润爽皂",
  "stab": "刺击",
  "stable portal": "稳定传送门",
  "stage dive": "舞台跳水",
  "stagger": "醉拳",
  "stalwart angel": "强韧天使",
  "star chariot": "星辰战车",
  "star lich kel thuzad": "星辰巫妖克尔苏加德",
  "star princess li ming": "星辰公主李敏",
  "star queen li ming": "星辰女王李敏",
  "star wood spear": "星木之矛",
  "star wraith mephisto": "星际怨灵墨菲斯托",
  "starfall": "星辰坠落",
  "starry winter veil lunara": "星光冬幕节露娜拉",
  "stars and stripes raynor": "星条旗雷诺",
  "static barrier": "静电屏障",
  "static field": "静电力场",
  "static shield": "静电护盾",
  "stay awhile and listen": "英雄请留步",
  "steady blade": "静刃",
  "stealth mecha dehaka": "隐秘机甲德哈卡",
  "stealth shrike": "潜行伯劳鸟",
  "steel cyber wolf": "钢铁科幻战狼",
  "steel dragon genji": "钢铁神龙源氏",
  "steel sir murkalot": "钢铁鱼卡罗特爵士",
  "steel trap": "捕兽夹",
  "steel zarya": "钢铁查莉娅",
  "sticky bomb": "黏性炸弹",
  "sticky flare": "粘性闪耀",
  "sticky wicket": "黏性陷阱",
  "stim drone": "激素无人机",
  "stitches": "缝合怪",
  "stoneform": "石像形态",
  "stop and pop": "原地跳",
  "storm bolt": "风暴之锤",
  "storm bow": "风",
  "storm earth fire": "风火雷电",
  "storm front": "风暴之锋",
  "storm lord falstad": "风暴之王弗斯塔德",
  "storm mantle malfurion": "怒风肩甲玛法里奥",
  "storm mecha tyrael": "冲锋机甲泰瑞尔",
  "storm of vengeance": "复仇风暴",
  "storm punk doctor wolf stein": "风暴朋克沃尔夫博士与斯坦",
  "storm punk kaelthas": "风暴朋克凯尔萨斯",
  "storm shield": "风暴护盾",
  "storm strider": "机动队追击者",
  "storm warmaster chen": "风暴战争大师陈",
  "storm wolf rehgar": "风暴之狼雷加尔",
  "storm": "风暴之灵",
  "stormbot kaelthas": "风暴机械凯尔萨斯",
  "stormcaller": "风暴召唤者",
  "stormpike marshal varian": "雷矛元帅瓦里安",
  "stormpike ram": "雷矛山羊",
  "stormstout secret recipe": "风暴烈酒秘方",
  "stormwind footman varian": "暴风城步兵瓦里安",
  "stormwind warden tyrande": "暴风城守望者泰兰德",
  "strafe": "扫射",
  "strangle": "扼杀",
  "strangling vines": "窒息之藤",
  "strawberry gingerboard": "草莓姜饼飞板",
  "street cyborg kharazim": "街头改造人卡拉辛姆",
  "striding giant": "天神步",
  "strike at the heart": "直击要害",
  "strike mecha tyrael": "强袭机甲泰瑞尔",
  "striker li ming": "排球女将李敏",
  "strip shields": "剥离护盾",
  "striped pure country e t c": "条纹乡村歌手精英牛头人酋长",
  "stromgarde footman varian": "激流堡步兵瓦里安",
  "stromgarde prince arthas": "激流堡王子阿尔萨斯",
  "stuck in a loop": "二次循环",
  "stukov": "斯托科夫",
  "subdue": "强光克敌",
  "subjugation": "认罪伏法",
  "submerge": "下潜",
  "subterranean shield": "遁地护盾",
  "subtlety": "敏锐",
  "subwoofer": "重低音",
  "succubus kerrigan": "魅魔凯瑞甘",
  "sudden vengeance": "突然复仇",
  "suffering mistress kerrigan": "痛苦妖女凯瑞甘",
  "sugar plum sylvanas": "糖梅希尔瓦娜斯",
  "sulfuras hungers": "萨弗拉斯的饥渴",
  "sulfuras smash": "萨弗拉斯重击",
  "sulfuron ragnaros": "萨弗隆拉格纳罗斯",
  "sulfuron uther": "萨弗隆乌瑟尔",
  "summer anthem": "夏日圣歌",
  "summon demon warrior": "召唤恶魔战士",
  "summon mount": "召唤坐骑",
  "summon sindragosa": "召唤辛达苟萨",
  "summon ultralisk": "召唤雷兽",
  "summon water elemental": "召唤水元素",
  "sun kings fury": "太阳之王之怒",
  "sun sovereign kaelthas": "太阳帝王凯尔萨斯",
  "sun warden tyrande": "太阳守望者泰兰德",
  "sundering": "裂地术",
  "sunfire enchantment": "炙炎强化",
  "sunfury nightslayer valeera": "日怒夜幕杀手瓦莉拉",
  "sunny side eye pad": "向阳面眼盘",
  "sunrise nazeebo": "旭日纳兹波",
  "sunset ana": "黄昏安娜",
  "super healing potion": "超级治疗药水",
  "super monkey king samuro": "超级猴王萨穆罗",
  "super sonya": "超级桑娅",
  "supercharged police hovercycle": "增压执法悬浮摩托",
  "supercharged storm strider": "机械增压机动队追击者",
  "superior schematics": "卓越结构",
  "supersonic": "超强音障",
  "superstition": "力量信仰",
  "superstrain": "超级菌株",
  "support": "支援型",
  "suppressing fire": "压制之火",
  "suppression pulse": "压制脉冲",
  "suppressive fire": "火焰压制",
  "surfboard": "冲浪板",
  "surge of light": "圣光涌动",
  "surge of vitality": "活力涌现",
  "surging dash": "涌动冲刺",
  "surging fist": "涌动之拳",
  "surging winds": "席卷之风",
  "survival instincts": "生存本能",
  "survivor qhira": "幸存者琪拉",
  "sustaining power": "持久能量",
  "sustaining rounds": "汲血弹",
  "swarm abathur": "虫群阿巴瑟",
  "swarms doubloon": "虫群的达布隆币",
  "sweeping strike": "扫荡打击",
  "sweet lunar li li": "糖果春节丽丽",
  "sweet plum sylvanas": "甜梅希尔瓦娜斯",
  "swift as the wind": "动如疾风",
  "swift dark iron ram": "迅捷黑铁山羊",
  "swift frostwolf": "迅捷霜狼",
  "swift retribution": "即时正义",
  "swift stormpike ram": "迅捷雷矛山羊",
  "swift stormwind ram": "迅捷暴风城山羊",
  "swift strike": "影",
  "swift sweep": "迅捷扫击",
  "swing life away": "就像龙卷风",
  "sword of justice": "公正之剑",
  "sylvanas": "希尔瓦娜斯",
  "symbiosis": "共生虫群",
  "symbiote": "共生体",
  "system shock": "系统震荡",
  "tactical mine deployment": "机动布雷",
  "tailwind": "顺风之力",
  "taking flight": "振翅高飞",
  "tal rasha li ming": "塔·拉夏李敏",
  "tal rashas elements": "塔·拉夏的法理",
  "taldarim probius": "塔达林普罗比斯",
  "taldarim reaver": "塔达林掠夺者",
  "taldarim zerg hunter zeratul": "塔达林异虫猎手泽拉图",
  "tan battle beast": "棕色战争蛮兽",
  "tan billie the kid": "棕色儿童版比利",
  "tan horse carried": "棕色马（扛着）",
  "tan horse": "棕色马",
  "tan saddled battle beast": "棕色鞍座战争蛮兽",
  "tangerine mad martian gazlowe": "橘红疯狂火星人加兹鲁维",
  "tank mode": "坦克模式",
  "tank": "坦克",
  "tanned power briefs tychus": "晒黑劲泳泰凯斯",
  "target acquired": "目标获取",
  "target practice": "箭靶练习",
  "target purified": "目标灭除",
  "targeted excision": "精准切除",
  "tarnished arthas": "晦暗阿尔萨斯",
  "tarnished malthael": "颓废马萨伊尔",
  "taskmaster": "监工",
  "tassadar": "塔萨达尔",
  "taste for explosions": "爆炸美学",
  "taunt": "嘲讽",
  "tazdingo": "塔兹丁苟！",
  "teal battle beast": "青色战争蛮兽",
  "teal ronin zeratul": "青色东瀛剑客泽拉图",
  "teal saddled battle beast": "青色鞍座战争蛮兽",
  "tech war world sgt hammer": "高科技世界大战重锤军士",
  "techno super sonya": "电子超级桑娅",
  "techno vandal chromie": "科技颠覆者克罗米",
  "technolope": "科技战羊",
  "telekinesis": "心灵传动",
  "teleport": "传送",
  "tempered by discipline": "戒律调和",
  "tempered commandant varian": "淬火指挥官瓦里安",
  "tempered flame": "回火",
  "tempest fury": "风暴狂怒",
  "tempest regalia jaina": "风暴套装吉安娜",
  "templar li ming": "圣堂武士李敏",
  "templars verdict": "圣殿骑士的裁决",
  "templars will": "圣堂武士的意志",
  "templars zeal": "圣堂武士的狂热",
  "temporal flux": "时光涌动",
  "temporal loop": "时光循环",
  "tenacious roots": "坚韧根须",
  "tenderizer": "嫩化剂",
  "terran probius 01": "泰伦普罗比斯01",
  "terran probius g 1": "泰伦普罗比斯G1",
  "terran probius red one": "泰伦普罗比斯红色一号",
  "terran probius x 1": "泰伦普罗比斯X1",
  "terran probius": "泰伦普罗比斯",
  "terror charge": "奔跑破坏神",
  "test model purifier artanis": "测试模型净化者阿塔尼斯",
  "thats the stuff": "这才像话！",
  "the bigger they are": "越大就越……",
  "the butcher": "屠夫",
  "the butcherlisk": "屠夫雷兽",
  "the damned return": "被诅咒者的回归",
  "the dragon awakens": "龙魂觉醒",
  "the dragon becomes me": "人竜合一",
  "the dragon hungers": "巨龙饿了",
  "the good stuff": "千年老酒",
  "the hunt": "恶魔追击",
  "the hunted": "捕猎游戏",
  "the long pitch": "远距抛投",
  "the lost vikings": "失落的维京人",
  "the night beckons": "黑夜召唤",
  "the plaguelands": "瘟疫之地",
  "the sequel": "续作来临",
  "the thirst": "嗜血如渴",
  "the will of cho": "古的意志",
  "the will of gall": "加尔的意志",
  "theramore jaina": "塞拉摩吉安娜",
  "theramore sorceress jaina": "塞拉摩女巫吉安娜",
  "thermal protection": "隔热防护",
  "thick skin": "厚皮",
  "thing of the deep": "深渊魔物",
  "third wind": "觉醒之风",
  "thirst for battle": "渴望战斗",
  "thirsting blade": "嗜血之刃",
  "thistle tea": "菊花茶",
  "thornwood vine": "棘刺藤条",
  "thrall": "萨尔",
  "three blade style": "三刃式",
  "three peat azmodunk": "三连冠阿兹乔丹",
  "thrill of the hunt": "狩猎刺激",
  "throwback tracer": "闪回“猎空”",
  "throwing shade": "死亡投影",
  "thrusters": "推进器",
  "thunder burn": "雷霆灼烧",
  "thunder clap": "雷霆一击",
  "thunder guard zarya": "雷霆卫队查莉娅",
  "thunder star chariot": "雷霆星辰战车",
  "thunder star princess li ming": "雷霆星辰公主李敏",
  "thunder strike": "雷霆打击",
  "thundergods vigor": "雷神之力",
  "thunderstorm": "雷霆风暴",
  "thunderstrikes": "雷霆打击",
  "thunderstroke": "雷击",
  "tidal waves": "潮汐奔涌",
  "tide of sin": "罪恶弥天",
  "tideswept admiral krakenov": "卷潮上将海怪诺夫",
  "timberwolf rehgar": "森林狼雷加尔",
  "time out": "时间暂停",
  "time to feed": "进食时间",
  "time to krill": "虾戮时间",
  "time trap": "时间陷阱",
  "time troubles": "时间问题",
  "timeless aspect alexstrasza": "永恒巨龙阿莱克丝塔萨",
  "timeless prime evil diablo": "永恒大魔神迪亚波罗",
  "timelost corruptor chogall": "迷失腐蚀者古加尔",
  "timelost grave warden malthael": "忘世镇墓者马萨伊尔",
  "timewalker chromie": "时光旅行者克罗米",
  "timewalker": "时光旅行者",
  "timewalkers pursuit": "时光旅行者的追求",
  "tissue regeneration": "组织再生",
  "titan grenade": "泰坦手雷",
  "titan killer": "泰坦杀手",
  "titanic might": "泰坦之力",
  "titanium cybersteed carried": "钛金赛博战马（扛着）",
  "titanium cybersteed": "钛金赛博战马",
  "titans revenge": "泰坦的复仇",
  "to the limit": "突破极限",
  "toads of hugeness": "巨型蟾蜍",
  "together we are strong": "众志成城",
  "tomb of the spider queen": "蛛后墓",
  "toon pajama party lost vikings": "卡通睡衣派对失落的维京人",
  "tooth and claw": "尖牙与利爪",
  "top off": "强健治愈",
  "torment mistress kerrigan": "折磨妖女凯瑞甘",
  "tormented souls": "折磨之魂",
  "torpedo dash": "鱼雷冲刺",
  "torrasque": "暴龙兽",
  "total annihilation": "咂魂之球",
  "total mayhem": "临别礼物",
  "total recall": "全面闪回",
  "totemic projection": "图腾投掷",
  "touch of death": "死亡之触",
  "tough as nails": "坚如钢钉",
  "tough love": "坚实的爱",
  "tour bus": "巡回演出",
  "tower defense": "塔防战术",
  "tower of doom": "末日塔",
  "toxic archangel diablo": "剧毒大天使迪亚波罗",
  "toxic azmodan": "剧毒阿兹莫丹",
  "toxic balespider guldan": "剧毒邪蛛古尔丹",
  "toxic buildup": "毒性物质",
  "toxic count arthas": "剧毒伯爵阿尔萨斯",
  "toxic custom rig tychus": "剧毒特制装备泰凯斯",
  "toxic dehaka": "剧毒德哈卡",
  "toxic demonic auriel": "剧毒恶魔奥莉尔",
  "toxic demonic hellsteed carried": "剧毒恶魔战马（扛着）",
  "toxic demonic hellsteed": "剧毒恶魔战马",
  "toxic diablo": "剧毒迪亚波罗",
  "toxic emberlord zuljin": "剧毒灰烬领主祖尔金",
  "toxic executioner butcher": "剧毒刽子手屠夫",
  "toxic grimskull nazeebo": "剧毒恐惧之颅纳兹波",
  "toxic insectoid zagara": "剧毒昆虫形态扎加拉",
  "toxic janitor leoric": "剧毒清洁工李奥瑞克",
  "toxic kerrigan": "剧毒凯瑞甘",
  "toxic king stitches": "剧毒国王缝合怪",
  "toxic love doctor morales": "剧毒爱心医生莫拉莉斯",
  "toxic malthael": "剧毒马萨伊尔",
  "toxic nazeebra carried": "剧毒纳兹布拉（扛着）",
  "toxic nazeebra": "剧毒纳兹布拉",
  "toxic nest": "剧毒巢穴",
  "toxic prime evil diablo": "剧毒大魔神迪亚波罗",
  "toxic skelethur abathur": "剧毒骷髅阿巴瑟",
  "tracer rounds": "曳光弹",
  "tracer": "猎空",
  "trag ouls essence": "塔格奥的精华",
  "trample": "魔王冲锋",
  "tranquility": "宁静",
  "transcendence": "升腾",
  "transgression": "超度众生",
  "trauma trigger": "创伤触发",
  "treasure goblin": "盗宝地精",
  "trickery": "诡计多端",
  "tricky shuffles": "魔鬼步",
  "triple strike": "三连击",
  "triple tap": "三连击",
  "triumvirate": "三元宝珠",
  "trolls blood": "巨魔之血",
  "tropical brightwing": "热带光明之翼",
  "tropical murky": "热带奔波尔霸",
  "trueshot aura": "强击光环",
  "tufferfish": "铁甲鱼",
  "tulip shambler murky": "郁金香恐波尔霸",
  "tundra arthas": "苔原阿尔萨斯",
  "tundra commandant varian": "苔原指挥官瓦里安",
  "tundra malfurion": "苔原玛法里奥",
  "tunneling claws": "掘地之爪",
  "turbo charged": "涡轮增压",
  "turbo tracer": "极速“猎空”",
  "turquoise cloud serpent": "绿松石腾云巨蛇",
  "turquoise magic carpet": "绿松石魔法飞毯",
  "turquoise serpent king xul": "绿松石毒蛇之王祖尔",
  "turret storage": "炮台仓库",
  "twilight ana": "暮光安娜",
  "twilight archangel auriel": "暮光大天使奥莉尔",
  "twilight archangel diablo": "暮光大天使迪亚波罗",
  "twilight archon": "暮光执政官",
  "twilight dream": "暮光梦境",
  "twilight falls": "暮光降临",
  "twilight fenix": "暮光菲尼克斯",
  "twilight herald of n zoth alarak": "暮光恩佐斯的传令官阿拉纳克",
  "twilight nova": "暮光新星",
  "twilight pumpkin chogall": "暮光南瓜古加尔",
  "twilight shadowpaw li li": "暮光影掌丽丽",
  "twilight shogun artanis": "暮光幕府将军阿塔尼斯",
  "twilight veil": "暮光帷幕",
  "twilight whitemane": "暮光怀特迈恩",
  "twilight xenotech malthael": "暮光异度机甲马萨伊尔",
  "twin blades of fury": "愤怒双刃",
  "twin blades primed": "双刃（激活）",
  "twin blades": "双刃",
  "twin cleave": "双斧投掷",
  "twin spheres": "双生魔珠",
  "twisting nether": "扭曲虚空",
  "two for one": "一酒两用",
  "tychus": "泰凯斯",
  "tyrael": "泰瑞尔",
  "tyraels charger carried": "泰瑞尔的天使战马（扛着）",
  "tyraels charger": "泰瑞尔的天使战马",
  "tyrande": "泰兰德",
  "tyrant kaijo diablo": "暴君怪兽迪亚波罗",
  "tyrant maw": "暴君巨口",
  "tyrs deliverance": "提尔的拯救",
  "ued stukov": "UED斯托科夫",
  "ultimate evolution": "终极进化",
  "ultra capacitors": "超级电容器",
  "umbral bind": "黑月缚杀",
  "umbral xenotech malthael": "黯影异度机甲马萨伊尔",
  "umojan cyber ram": "尤摩扬科幻公羊",
  "umojan maraudin muradin": "尤摩扬劫掠者穆拉丁",
  "umojan sgt hammer": "尤摩扬重锤军士",
  "unbound": "无拘无束",
  "unbridled energy": "能量狂飙",
  "uncle ringmaster greymane": "大叔马戏团长格雷迈恩",
  "unclean sonya": "不洁者桑娅",
  "unconquered spirit": "不屈战魂",
  "undead horse carried": "僵尸马（扛着）",
  "undead horse": "僵尸马",
  "undercity mal ganis": "幽暗城玛尔加尼斯",
  "underking anubarak": "地底虫王阿努巴拉克",
  "underking": "地底虫王",
  "underworld chamuco diablo": "“冥界火罗刹”迪亚波罗",
  "underworld jefe garrosh": "“冥界暴君”加尔鲁什",
  "underworld luchihuahua": "冥界露奇花花",
  "underworld mariachi e t c": "“冥界玛利亚奇音乐牛”E.T.C.",
  "underworld pantera sonya": "“冥界豹”桑娅",
  "undying": "亡魂不灭",
  "unending hatred": "无尽仇恨",
  "unfair advantage": "天生优势",
  "unfettered assault": "无缚攻势",
  "unfurling shadows": "暗影侵袭",
  "unholy crypt queen zagara": "邪恶地穴女王扎加拉",
  "unholy death knight sonya": "邪恶死亡骑士桑娅",
  "unholy dreadlord jaina": "邪恶恐惧魔王吉安娜",
  "unholy frost wyrm arthas": "邪恶冰霜巨龙阿尔萨斯",
  "universal carrier": "万能携带体",
  "unleash deadly charge": "施放致命冲锋",
  "unleash the boars": "关门放猪",
  "unleashed potential": "潜能释放",
  "unleashed": "解禁",
  "unraveler zeratul": "剖尸者泽拉图",
  "unravelling": "时光瓦解",
  "unrelenting descent": "神罚天降",
  "unrelenting frost": "凛冽冰霜",
  "unrelenting pursuit": "无情追击",
  "unrelenting strikes": "剑舞送葬",
  "unrivaled strength": "无匹之力",
  "unspeakable horror": "缄默恐惧",
  "unstable anomaly": "不稳异能",
  "unstable compound": "不稳复合弹",
  "unstable poison": "爆裂毒药",
  "unstoppable competitor": "不可阻挡的对手",
  "unstoppable force": "无坚不摧之力",
  "unsummon mount": "解除坐骑",
  "untapped potential": "黯然销魂",
  "untouchable": "触不可及",
  "unwavering faith": "信仰坚定",
  "unyielding defender": "不屈卫士",
  "unyielding despair": "不灭绝望",
  "unyielding power": "不灭之力",
  "up the frequency": "频率加快",
  "up to eleven": "音量爆表",
  "updraft": "上升气流",
  "upheaval": "颠覆之击",
  "uppercut": "上勾拳",
  "upstage": "杂技身法",
  "urban commander raynor": "城市指挥官雷诺",
  "urban spectre nova": "城市幽魂诺娃",
  "urticating spines": "毒虫螫刺",
  "uther": "乌瑟尔",
  "utility belt": "万能腰带",
  "v haka": "V.哈卡",
  "valeera": "瓦莉拉",
  "valiant rooster": "英勇的公鸡",
  "valkyrie": "女武神",
  "valla": "维拉",
  "valorous brand": "英勇烙印",
  "valorous pursuit": "英勇追击",
  "valorous sonya": "勇猛桑娅",
  "vampire slayer v": "吸血鬼猎人V",
  "vampire slayer valla": "吸血鬼杀手维拉",
  "vampiric aura": "吸血光环",
  "vampiric rounds": "吸血弹",
  "vampiric touch": "吸血之触",
  "vanadium plating": "钒合金板",
  "vanish": "消失",
  "vanndar muradin": "范达尔穆拉丁",
  "vanquish the weak": "剔除弱者",
  "vanquisher scrapper queen qhira": "征伐削铁女皇琪拉",
  "varian": "瓦里安",
  "varians legacy": "瓦里安的遗产",
  "vault of the wardens": "守望者空翻",
  "vault": "影轮翻",
  "velens chosen": "维伦的恩泽",
  "velvet pirate queen cassia": "天鹅绒海盗女王卡西娅",
  "vengeance valla": "复仇维拉",
  "vengeful archangel tyrael": "复仇大天使泰瑞尔",
  "vengeful dark prelate zeratul": "复仇黑暗教长泽拉图",
  "vengeful knives": "报复之刃",
  "vengeful oni genji": "复仇邪鬼源氏",
  "vengeful roots": "复仇根须",
  "vengeful shadowblade li li": "复仇影刃丽丽",
  "vengeful shogun artanis": "复仇幕府将军阿塔尼斯",
  "vengeful spirit healer auriel": "复仇灵魂医师奥莉尔",
  "vengeful whitemane": "复仇怀特迈恩",
  "venom warbringer zuljin": "毒液战争使者祖尔金",
  "venomous anubalisk": "剧毒阿努巴利斯克",
  "veradani li ming": "梵罗达尼李敏",
  "verdant bikini stitches": "翠绿比基尼缝合怪",
  "verdant dream genie chromie": "翠绿梦幻精灵克罗米",
  "verdant elemental boar": "翠绿元素野猪",
  "verdant elemental lion": "翠绿元素雄狮",
  "verdant elemental lizard": "翠绿元素蜥蜴",
  "verdant elemental stag": "翠绿元素驯鹿",
  "verdant elemental wolf": "翠绿元素战狼",
  "verdant epic elemental lizard": "翠绿史诗元素蜥蜴",
  "verdant flourish": "春雨荷露",
  "verdant jaina": "翠绿吉安娜",
  "verdant kharazim": "翠绿卡拉辛姆",
  "verdant lunar chen": "翠绿春节老陈",
  "verdant lunar dragon": "翠绿春节祥龙",
  "verdant magic carpet": "翠绿魔法飞毯",
  "verdant orphea": "翠绿奥菲娅",
  "verdant power drench tychus": "翠绿大泵水枪泰凯斯",
  "verdant primal queen kerrigan": "翠绿原始女王凯瑞甘",
  "verdant slip n stream tracer": "翠绿水枪“猎空”",
  "verdant special snowflake": "翠绿特殊雪花",
  "verdant spheres active": "翠绿魔珠激活",
  "verdant spheres": "翠绿魔珠",
  "verdant valla": "翠绿维拉",
  "vermelho lucio": "红色卢西奥",
  "vermillion artanis": "朱红阿塔尼斯",
  "vermillion mecha tassadar": "朱红机甲塔萨达尔",
  "vespene ghost speeder": "瓦斯幽灵穿梭者",
  "vespene queen of ghosts kerrigan": "瓦斯幽灵女王凯瑞甘",
  "veteran blaze": "老兵布雷泽",
  "veteran delta hanzo": "老兵敢死队半藏",
  "veteran marksman": "枪法精湛",
  "vice admiral krakenov": "海军中将海怪诺夫",
  "vicious assault": "恶意突袭",
  "viciousness": "恶意",
  "victorious rooster": "凯旋的公鸡",
  "victory rush": "乘胜追击",
  "victuals": "吃肉补肉",
  "vigilance": "警戒",
  "vigilante enforcer johanna": "义勇执法者乔汉娜",
  "vigor": "精力",
  "vigorous reuptake": "活力摄取",
  "viking bribery": "维京贿赂",
  "viking hoard": "维京宝藏",
  "vile cleaver": "胆汁横扫",
  "vile demonic imperius": "邪能恶魔英普瑞斯",
  "vile infection": "剧毒感染",
  "vile nest": "邪恶巢穴",
  "vile sinlord azmodan": "恶毒罪恶之王阿兹莫丹",
  "vindication": "辩护之光",
  "vindicator imperius": "维护者英普瑞斯",
  "violet fel queen chromie": "紫罗兰邪能女王克罗米",
  "violet flying monkey brightwing": "紫罗兰飞猿光明之翼",
  "violet hierarch artanis": "紫罗兰大主教阿塔尼斯",
  "violet nexus battle beast": "紫罗兰时空蛮兽",
  "violet nexus charger carried": "紫罗兰时空战马（扛着）",
  "violet nexus charger": "紫罗兰时空战马",
  "violet nexus tiger": "紫罗兰时空战虎",
  "violet roller derby nova": "紫罗兰轮滑女孩诺娃",
  "violet tiger kharazim": "紫罗兰伏虎卡拉辛姆",
  "violet vengeance valla": "紫罗兰复仇维拉",
  "violet void speeder": "紫罗兰虚空穿梭者",
  "viper dominator": "蝰蛇陆霸",
  "viridian super sonya": "翠绿超级桑娅",
  "virtuous blood elf tyrande": "公正血精灵泰兰德",
  "virulent reaction": "剧毒反应",
  "visceral diablo": "血污迪亚波罗",
  "viscous acid": "黏性强酸",
  "void demonic tyrael": "虚空恶魔泰瑞尔",
  "void illidan": "虚空伊利丹",
  "void prison cancel": "虚空禁锢 取消",
  "void prison": "虚空禁锢",
  "void slash": "虚空挥砍",
  "void speeder": "虚空穿梭者",
  "void tassadar": "虚空塔萨达尔",
  "void templar li ming": "虚空圣堂武士李敏",
  "voidclaw rehgar": "虚空之爪雷加尔",
  "volatile acid": "不稳定强酸",
  "volatile mutation": "猛烈突变",
  "volatile power": "动荡能量",
  "volskaya foundry": "沃斯卡娅铸造厂",
  "voodoo ritual": "巫毒祭典",
  "voodoo shuffle": "巫毒步",
  "vordrassil shando illidan": "沃达希尔衫多伊利丹",
  "vorpal blade": "穿刺剑刃",
  "vrykul king leoric": "维库国王李奥瑞克",
  "vrykul leoric": "维库人李奥瑞克",
  "vulture": "秃鹫",
  "wailing arrow": "哀恸箭",
  "wall ride": "滑墙",
  "wanderer chen": "云游者陈",
  "wandering keg": "迷踪酒桶",
  "war paint": "作战伪装",
  "war pig raynor": "战地豪猪雷诺",
  "war traveler": "战争旅者",
  "war world sgt hammer": "世界大战重锤军士",
  "warbreaker": "灭战者",
  "warbringer zuljin": "战争使者祖尔金",
  "warbringer": "战神",
  "warchief sylvanas": "大酋长希尔瓦娜斯",
  "warden lunara": "守望者露娜拉",
  "warden tyrande": "守望者泰兰德",
  "wardens cage": "守望者牢笼",
  "warhead junction": "弹头枢纽站",
  "warlord chogall": "督军古加尔",
  "warlords challenge": "督军的挑战",
  "warmaster chen": "战争大师陈",
  "warmatron cassia": "战争仕女卡西娅",
  "warp in pylon": "折跃水晶塔",
  "warp resonance": "折跃共鸣",
  "warp rift": "折跃裂隙",
  "warp sickness": "折跃恶感",
  "warp skirmisher": "折跃奇兵",
  "warp warfare": "折跃势能",
  "warp": "折跃",
  "warped fallen junkrat": "扭曲堕落者狂鼠",
  "warpforge probius prime": "折跃锻炉主力机普罗比斯",
  "warpspace empress whitemane": "超时空女皇怀特迈恩",
  "warsong hellblade samuro": "战歌地狱之刃萨穆罗",
  "warsong johanna": "战歌乔汉娜",
  "warsong samuro": "战歌萨穆罗",
  "waste bag gazlowe": "垃圾袋加兹鲁维",
  "wastewalker deckard": "废墟行者迪卡德",
  "watchdog greymane": "看门狗格雷迈恩",
  "watcher maiev": "守望者玛维",
  "water dragon": "深海游龙",
  "wave of force": "原力之波",
  "wave of light": "圣光涌动",
  "way of illusion": "幻象之道",
  "way of the blade": "剑刃之道",
  "way of the hundred fists": "百裂拳",
  "way of the wind": "疾风之道",
  "waywatcher malfurion": "守路者玛法里奥",
  "we see you": "我们看到你了！",
  "weak spot acquired": "弱点暴露",
  "weaken": "削弱",
  "weapon mode phase bomb": "武器模式：相位炸弹",
  "weapon mode repeater cannon": "武器模式：光继炮",
  "weathered hellflame nazeebo": "风化地狱火纳兹波",
  "webbed sharkbite surfboard": "蛛网鲨鱼咬痕冲浪板",
  "webbed surfboard": "蛛网冲浪板",
  "weighted pustule": "负重脓疱",
  "well met": "欢迎指教",
  "westfall anduin": "西部荒野安度因",
  "whirlpool pirate queen cassia": "漩涡海盗女王卡西娅",
  "whirlwind": "旋风斩",
  "whitemane": "怀特迈恩",
  "widowmaker nova": "黑百合诺娃",
  "widowmakers": "寡妇毒蛛",
  "wild aspect alexstrasza": "狂野巨龙阿莱克丝塔萨",
  "wild betrayer malfurion": "荒野背叛者玛法里奥",
  "wild bewitching brightwing": "绿野女巫光明之翼",
  "wild cassia": "荒野卡西娅",
  "wild champion lunara": "荒野勇士露娜拉",
  "wild demon hunter valeera": "荒野恶魔猎手瓦莉拉",
  "wild growth": "野性成长",
  "wild raven sylvanas": "狂鸦希尔瓦娜斯",
  "wild rexxar": "荒野雷克萨",
  "wild vigor": "荒野活力",
  "wildfire bear": "烈火巨熊",
  "wildstone tiger kharazim": "狂石伏虎卡拉辛姆",
  "will of heaven": "天堂意志",
  "will of the forsaken": "被遗忘者的意志",
  "will of tichondrius": "提克迪奥斯的意志",
  "willing vessel": "意志躯壳",
  "wind rush": "挟风而行",
  "wind serpent": "风龙",
  "wind strider": "逐风者",
  "wind tunnel": "风之隧道",
  "wind walk": "疾风步",
  "windfury": "风怒",
  "windrunner": "风行者",
  "winds of celerity": "灵犀之风",
  "wing buffet": "龙翼打击",
  "winged guard": "飞翼卫士",
  "wingman": "搭档",
  "winter veil jaina": "冬幕节吉安娜",
  "winter veil kharazim": "冬幕节卡拉辛姆",
  "winter veil lunara": "冬幕节露娜拉",
  "wintermute": "寂静寒冬",
  "winters helper valla": "冬天爷爷的助手维拉",
  "winters reach": "寒冬蔓延",
  "wisdom archangel tyrael": "智慧大天使泰瑞尔",
  "wisp": "小精灵",
  "withered ruinwalker fenix": "枯萎废墟行者菲尼克斯",
  "withering barrage": "凋零箭幕",
  "withering fire": "凋零射击",
  "withering flames": "凋零烈焰",
  "wizened duelist": "枯瘦的对手",
  "wolf run": "野狼狂奔",
  "wolfheart": "恶狼之心",
  "wonder billie": "神奇比利",
  "wonder william": "神奇威廉",
  "wondrous cassia": "神奇卡西娅",
  "woodland ranger general sylvanas": "林地游侠将军希尔瓦娜斯",
  "word of glory": "荣耀圣令",
  "worker rush": "探机冲刺",
  "world shaman thrall": "世界萨满萨尔",
  "worldbreaker": "灭世者",
  "wormhole": "虫洞",
  "wound poison": "致伤药膏",
  "wraith strike": "怨鬼扑杀",
  "wraith valeera": "怨灵瓦莉拉",
  "wraith walk": "幽灵步",
  "wrath of cod": "鳕鱼之怒",
  "wrath of heaven": "天堂之怒",
  "wrath of nathreza": "纳斯雷萨之怒",
  "wrath of the angiris": "大天使之怒",
  "wrath of the berserker": "狂战之怒",
  "wrath sonya": "愤怒套装桑娅",
  "wrath": "愤怒",
  "wrecking ball": "肉弹抛投",
  "wretched eredar armor illidan": "灰暗艾瑞达护甲伊利丹",
  "wretched illidans nightmare carried": "灰暗伊利丹的梦魇（扛着）",
  "wretched illidans nightmare": "灰暗伊利丹的梦魇",
  "wretched shadow council guldan": "恶毒暗影议会古尔丹",
  "wrong place wrong time": "阴差阳错",
  "x strike": "烈",
  "x tra large bombs": "超大炸弹",
  "x treme d va": "极限D.Va",
  "xenotech abathur": "异度机甲阿巴瑟",
  "xenotech malthael": "异度机甲马萨伊尔",
  "xplodium charge": "爆素炸药",
  "xul": "祖尔",
  "ymirjar deathbringer sonya": "伊米亚死亡使者桑娅",
  "ymirjar leoric": "伊米亚李奥瑞克",
  "ymirjar lord muradin": "伊米亚之王穆拉丁",
  "your pain my gain": "以攻为守",
  "yrel": "伊瑞尔",
  "yseras gift": "伊瑟拉之赐",
  "zagara": "扎加拉",
  "zakarum leoric": "萨卡兰姆李奥瑞克",
  "zanshin": "残心",
  "zarya": "查莉娅",
  "zeal": "狂热",
  "zealot charge": "狂热冲锋",
  "zealous glare": "狂热眩光",
  "zealous spirit": "狂热意志",
  "zebra bikini stitches": "斑马比基尼缝合怪",
  "zebra carried": "斑马（扛着）",
  "zebra": "斑马",
  "zeis vengeance": "贼神的复仇",
  "zeratai artanis": "泽阿泰阿塔尼斯",
  "zeratul": "泽拉图",
  "zerg hunter zeratul": "异虫猎手泽拉图",
  "zergling": "跳虫",
  "zergy pajamathur abathur": "异虫睡衣宝宝阿巴瑟",
  "zergy power drench tychus": "虫化大泵水枪泰凯斯",
  "zerus stukov": "泽鲁斯斯托科夫",
  "zerus zagara": "泽鲁斯扎加拉",
  "zombie wall": "僵尸之墙",
  "zuljin": "祖尔金"
};
export default i18nDict;